import React, { useState, useCallback, useRef } from "react";
import { elakayAutoText } from "../dataElakay";


// ─── Design tokens ─────────────────────────────────────────────────────────────
const C = {
  bg:       "#f6f4fb",
  white:    "#ffffff",
  sidebar:  "#1e1b4b",
  sideHdr:  "#16133e",
  sideBdr:  "#2d2a5a",
  sideTxt:  "#a5b4fc",
  sideAct:  "#312e81",
  sideActT: "#e0e7ff",
  purple:   "#6d28d9",
  violet:   "#7c3aed",
  light:    "#ede9fe",
  border:   "#e4dcfb",
  txt1:     "#1a1a2e",
  txt2:     "#4a4a68",
  txt3:     "#9b93b8",
  green:    "#059669",
  cyan:     "#0284c7",
  orange:   "#f97316",
  red:      "#e11d48",
  gold:     "#d4af37",
  codeBg:   "#1a1a2e",
  codeTxt:  "#d6cfec",
};

// ─── Navigation sections ────────────────────────────────────────────────────────
const NAV = [
  { id:"intro",       icon:"🏠", get label() { return elakayAutoText("h_2473e96bc614a9", "Introduction"); } },
  { id:"interface",   icon:"🖥️", get label() { return elakayAutoText("h_4b17c6bfc99ddc", "Interface & Panneaux"); } },
  { id:"elements",    icon:"🧩", get label() { return elakayAutoText("h_285c38754808f9", "Catalogue d'éléments"); }, children:[
    { id:"el-base",   get label() { return elakayAutoText("h_63e364ea6282d1", "Base (texte, bouton, image…)"); } },
    { id:"el-layout", get label() { return elakayAutoText("h_6cdb349448d229", "Mise en page (row, grid, section…)"); } },
    { id:"el-rich",   get label() { return elakayAutoText("h_f2bc6cef80bc2e", "Composants riches (swiper, tabs…)"); } },
    { id:"el-form",   get label() { return elakayAutoText("h_edb3637fe7e2c6", "Formulaires"); } },
    { id:"el-media",  get label() { return elakayAutoText("h_79092002931d7a", "Médias (vidéo, icône…)"); } },
    { id:"el-data",   get label() { return elakayAutoText("h_d6e210686cb50d", "Données (stat, note, barre…)"); } },
    { id:"el-html",   get label() { return elakayAutoText("h_abb55daccf5184", "HTML brut"); } },
  ]},
  { id:"properties",  icon:"⚙️", get label() { return elakayAutoText("h_a218b8ca082ca9", "Propriétés & Styles"); } },
  { id:"animations",  icon:"✨", get label() { return elakayAutoText("h_c77dcdedc0f40e", "Animations"); }, children:[
    { id:"anim-how",  get label() { return elakayAutoText("h_5bea94e8e9ce44", "Comment ajouter une animation"); } },
    { id:"anim-types",get label() { return elakayAutoText("h_f757b78a824953", "Types d'animation disponibles"); } },
    { id:"anim-tips", get label() { return elakayAutoText("h_d6dce4a785d58f", "Conseils & bonnes pratiques"); } },
  ]},
  { id:"links",       icon:"🔗", get label() { return elakayAutoText("h_1dd8d0f2dcc1d7", "Liens & Actions au clic"); }, children:[
    { id:"link-fn",   get label() { return elakayAutoText("h_4780483a7f34f0", "Fonction shopUser"); } },
    { id:"link-url",  get label() { return elakayAutoText("h_4be51bdaf470c7", "URL / lien externe"); } },
    { id:"link-page", get label() { return elakayAutoText("h_ada824c94f49b9", "Page interne"); } },
    { id:"link-modal",get label() { return elakayAutoText("h_f12938ce8ec0e4", "Ouvrir un modal"); } },
  ]},
  { id:"data",        icon:"📊", get label() { return elakayAutoText("h_9cd0d78fa07da3", "Données & Binding"); }, children:[
    { id:"data-bind", get label() { return elakayAutoText("h_4314877292f848", "bindKey — lier un champ"); } },
    { id:"data-rep",  get label() { return elakayAutoText("h_29f43946a79190", "repeatBind — répéter sur un tableau"); } },
    { id:"data-modes",get label() { return elakayAutoText("h_35cff871da7d08", "Modes de page"); } },
    { id:"data-src",  get label() { return elakayAutoText("h_e70fa98b5bb0a7", "Sources de données"); } },
    { id:"data-json", get label() { return elakayAutoText("h_a829c25872234d", "Onglet JSON — édition directe"); } },
  ]},
  { id:"live",        icon:"🏪", get label() { return elakayAutoText("h_0e37f7562500ac", "Boutique Live (Live ⚡)"); } },
  { id:"grid-mapping",icon:"📐", get label() { return elakayAutoText("h_4db1692e5db2e2", "Grille, Mapping & Pagination"); }, children:[
    { id:"grid-base",   get label() { return elakayAutoText("h_03665824588e04", "Créer une grille responsive"); } },
    { id:"grid-pagine", get label() { return elakayAutoText("h_0920caf40e9160", "Pagination automatique"); } },
    { id:"grid-field",  get label() { return elakayAutoText("h_c38da9c071acb2", "Mapping des champs (fieldMap)"); } },
  ]},
  { id:"cards",       icon:"🃏", get label() { return elakayAutoText("h_4fceb68f943d3b", "Cartes Portrait & Paysage"); }, children:[
    { id:"card-portrait",  get label() { return elakayAutoText("h_ff2343cc07ceb1", "Carte Portrait (verticale)"); } },
    { id:"card-landscape", get label() { return elakayAutoText("h_94bc86de09dbca", "Carte Paysage (horizontale)"); } },
    { id:"card-mini",      get label() { return elakayAutoText("h_270c0ef537ae8d", "Carte Mini (compact)"); } },
  ]},
  { id:"categories",  icon:"🏷️", get label() { return elakayAutoText("h_8b2ccf9d07b3db", "Catégories — Horizontale & Verticale"); }, children:[
    { id:"cat-horiz",  get label() { return elakayAutoText("h_2d03707caf4276", "Barre horizontale (pills)"); } },
    { id:"cat-vert",   get label() { return elakayAutoText("h_85c795eee1d0e2", "Sidebar verticale"); } },
    { id:"cat-active", get label() { return elakayAutoText("h_4f89235bb593b8", "✦ État actif — couleur au clic"); } },
    { id:"cat-matrix", get label() { return elakayAutoText("h_451f5948f6d280", "Matrix animée (shopCatMatrix)"); } },
  ]},
  { id:"examples",    icon:"💡", get label() { return elakayAutoText("h_a65f93a4fb88af", "5 Exemples pratiques"); }, children:[
    { id:"ex-hero",   get label() { return elakayAutoText("h_ff0b7814a69eec", "Hero + Stat band"); } },
    { id:"ex-faq",    get label() { return elakayAutoText("h_7c43e6e9f37d79", "FAQ Accordéon"); } },
    { id:"ex-gallery",get label() { return elakayAutoText("h_c222deb77533ea", "Galerie Media"); } },
    { id:"ex-pricing",get label() { return elakayAutoText("h_5b0d9f38229d4e", "Plans tarifaires"); } },
    { id:"ex-contact",get label() { return elakayAutoText("h_9f98bce907aa02", "Section Contact / Formulaire"); } },
  ]},
  { id:"templates",   icon:"🏗️", get label() { return elakayAutoText("h_2fc7a025915a2b", "Templates Boutique — pas à pas"); }, children:[
    { id:"tpl-classique", get label() { return elakayAutoText("h_4232e9dd0710bd", "Boutique Classique"); } },
    { id:"tpl-premium",   get label() { return elakayAutoText("h_986d5ef695fc8b", "Boutique Premium"); } },
    { id:"tpl-content",   get label() { return elakayAutoText("h_5429e6989a6c19", "Contenu Classique"); } },
    { id:"tpl-invest",    get label() { return elakayAutoText("h_0b581f7884f6fc", "Investissement Pro"); } },
  ]},
  { id:"boutique-guide", icon:"🛒", get label() { return elakayAutoText("h_04c8f7b31e4ac2", "Créer une page boutique"); }, children:[
    { id:"btq-overview",  get label() { return elakayAutoText("h_ac31fb445b7bbe", "Vue d'ensemble — 6 étapes"); } },
    { id:"btq-step1",     get label() { return elakayAutoText("h_d4727413db1b62", "Ét. 1 — Mode Boutique (store)"); } },
    { id:"btq-step2",     get label() { return elakayAutoText("h_07695dc344fe82", "Ét. 2 — Structure de la page"); } },
    { id:"btq-step3",     get label() { return elakayAutoText("h_cf6d1ce711f697", "Ét. 3 — Hero Slider"); } },
    { id:"btq-step4",     get label() { return elakayAutoText("h_e2234291578b0c", "Ét. 4 — Barre catégories"); } },
    { id:"btq-step5",     get label() { return elakayAutoText("h_d6013412ab06b2", "Ét. 5 — Grille produits + pagination"); } },
    { id:"btq-step6",     get label() { return elakayAutoText("h_5d4e8c495acda2", "Ét. 6 — Sauvegarder / Modifier"); } },
  ]},
  { id:"export",      icon:"📦", get label() { return elakayAutoText("h_801a56805e8047", "Export / Import & API"); } },
  { id:"sauvegarde",  icon:"💾", get label() { return elakayAutoText("h_a30671e0cdff65", "Sauvegarde en base de données"); }, children:[
    { id:"save-btn",    get label() { return elakayAutoText("h_0be78e4d84129a", "Bouton Sauvegarder / Modifier"); } },
    { id:"save-modal",  get label() { return elakayAutoText("h_38da27bfda4d36", "Modal — titre, prix, options"); } },
    { id:"save-edit",   get label() { return elakayAutoText("h_dfee322a084b03", "Éditer une page existante"); } },
    { id:"save-mypages",get label() { return elakayAutoText("h_c681d7911f30e1", "Tab Mes pages"); } },
    { id:"save-draft",  get label() { return elakayAutoText("h_e8a322eada2de9", "Auto-save localStorage"); } },
  ]},
  { id:"toggle",      icon:"⚙️", get label() { return elakayAutoText("h_bec93c21ad3603", "Fonction Toggle — Activer / Désactiver"); }, children:[
    { id:"toggle-how",  get label() { return elakayAutoText("h_0ec110cbd62174", "Principe & configuration"); } },
    { id:"toggle-auto", get label() { return elakayAutoText("h_8fa9c6987bcb79", "Bouton Auto-configure"); } },
    { id:"toggle-check",get label() { return elakayAutoText("h_e60b07c9d36077", "Sélection manuelle (checkboxes)"); } },
    { id:"toggle-cat",  get label() { return elakayAutoText("h_fd64d8620577c0", "catBar & catSidebar pré-configurés"); } },
  ]},
  { id:"lxc",         icon:"🔢", get label() { return elakayAutoText("h_fd64b09eca15ae", "Grille l × c"); } },
  { id:"combined",    icon:"📦", get label() { return elakayAutoText("h_de42c2afda15c7", "Éléments combinés"); } },
];

// ─── Shared styles ──────────────────────────────────────────────────────────────
const S = {
  h1:  { fontSize:"22px", fontWeight:900, color:C.txt1, margin:"0 0 8px" },
  h2:  { fontSize:"17px", fontWeight:800, color:C.purple, margin:"28px 0 10px" },
  h3:  { fontSize:"14px", fontWeight:700, color:C.txt1, margin:"18px 0 6px" },
  p:   { fontSize:"14px", color:C.txt2, lineHeight:1.7, margin:"0 0 10px" },
  tag: { display:"inline-block", padding:"2px 8px", borderRadius:"999px", fontSize:"10px", fontWeight:700, margin:"0 3px 3px 0" },
  code:{ fontFamily:"ui-monospace,'SF Mono',Menlo,monospace", fontSize:"12px", background:C.codeBg, color:C.codeTxt, padding:"12px 16px", borderRadius:"10px", display:"block", whiteSpace:"pre-wrap", overflowX:"auto", lineHeight:1.6, margin:"10px 0" },
  inlineCode:{ fontFamily:"ui-monospace,monospace", fontSize:"12px", background:"#f3effe", color:C.purple, padding:"2px 5px", borderRadius:"4px" },
  prop:{ display:"grid", gridTemplateColumns:"1fr 1fr 2fr", gap:"6px", padding:"7px 10px", borderRadius:"8px", background:"#faf9fd", border:`1px solid ${C.border}`, marginBottom:"4px", fontSize:"12px" },
  propH:{ display:"grid", gridTemplateColumns:"1fr 1fr 2fr", gap:"6px", padding:"6px 10px", borderRadius:"8px 8px 0 0", background:C.light, border:`1px solid ${C.border}`, marginBottom:"2px", fontSize:"11px", fontWeight:700, color:C.purple },
  card:{ background:C.white, border:`1px solid ${C.border}`, borderRadius:"12px", padding:"18px", marginBottom:"16px" },
  step:{ display:"flex", gap:"14px", marginBottom:"16px", alignItems:"flex-start" },
  stepNum:{ width:"28px", height:"28px", borderRadius:"50%", background:C.purple, color:"#fff", fontSize:"13px", fontWeight:800, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, marginTop:"1px" },
  badge:(color,bg)=>({ ...S.tag, color, background:bg }),
  warn:{ background:"#fffbeb", border:"1px solid #fcd34d", borderRadius:"10px", padding:"10px 14px", fontSize:"13px", color:"#92400e", margin:"10px 0" },
  tip: { background:"#f0fdf4", border:"1px solid #a7f3d0", borderRadius:"10px", padding:"10px 14px", fontSize:"13px", color:"#065f46", margin:"10px 0" },
};

// ─── Reusable building blocks ────────────────────────────────────────────────────
const Prop = ({ name, type, desc }) => (
  <div style={S.prop}>
    <span style={{ color:C.purple, fontWeight:600, fontFamily:"ui-monospace,monospace" }}>{name}</span>
    <span style={{ color:C.orange }}>{type}</span>
    <span style={{ color:C.txt2 }}>{desc}</span>
  </div>
);
const PropTable = ({ rows }) => (
  <div style={{ marginBottom:"12px" }}>
    <div style={S.propH}><span>{elakayAutoText("h_5e345e0c779b14", "Propriété")}</span><span>{elakayAutoText("h_3deb7456519697", "Type")}</span><span>{elakayAutoText("h_55f8ebc805e65b", "Description")}</span></div>
    {rows.map((r,i) => <Prop key={i} {...r} />)}
  </div>
);
const Code = ({ children }) => <pre style={S.code}>{children}</pre>;
const Step = ({ n, title, children }) => (
  <div style={S.step}>
    <div style={S.stepNum}>{n}</div>
    <div style={{ flex:1 }}>
      {title && <div style={{ fontSize:"14px", fontWeight:700, color:C.txt1, marginBottom:"4px" }}>{title}</div>}
      <div style={{ fontSize:"13px", color:C.txt2, lineHeight:1.6 }}>{children}</div>
    </div>
  </div>
);
const SectionTitle = ({ icon, title, sub }) => (
  <div style={{ marginBottom:"20px", paddingBottom:"14px", borderBottom:`2px solid ${C.border}` }}>
    <div style={{ fontSize:"11px", color:C.txt3, textTransform:"uppercase", letterSpacing:"0.15em", marginBottom:"4px" }}>{icon}{elakayAutoText("h_9e9cf3221a3024", "Documentation")}</div>
    <h1 style={S.h1}>{title}</h1>
    {sub && <p style={{ ...S.p, margin:0, color:C.txt3 }}>{sub}</p>}
  </div>
);
const Tag = ({ label, color="#6d28d9", bg="#f3effe" }) => <span style={S.badge(color,bg)}>{label}</span>;
const Warn = ({ children }) => <div style={S.warn}>⚠️ {children}</div>;
const Tip  = ({ children }) => <div style={S.tip}>💡 {children}</div>;

// ═══════════════════════════════════════════════════════════════════════════════
// COMPOSANT ÉTAT ACTIF CATÉGORIES (nécessite useState → composant nommé)
// ═══════════════════════════════════════════════════════════════════════════════

const CAT_DEMO = ["Tout", "Polo Shirts", "Laptop", "Tank Tops", "tablet", "phone"];

function CatActiveSection() {
  const [activeIdx, setActiveIdx] = useState(0);

  const HorizDemo = ({ allBg="#1a1a2e", allColor="#fff", pillBg="#f9fafb", pillColor="#374151", pillBorder="#e5e7eb", radius="50px", label }) => (
    <div>
      <div style={{ fontSize:"11px", fontWeight:700, color:C.txt3, marginBottom:"8px", textTransform:"uppercase", letterSpacing:"0.06em" }}>{label}</div>
      <div style={{ background:"#fff", border:"1px solid #f0f0f0", borderRadius:"10px", padding:"10px 14px", overflowX:"auto" }}>
        <div style={{ display:"flex", gap:"7px", flexWrap:"nowrap", alignItems:"center" }}>
          {CAT_DEMO.map((cat, i) => {
            const isActive = i === activeIdx;
            return (
              <button key={i} onClick={() => setActiveIdx(i)} style={{
                padding:"7px 18px", borderRadius:radius, cursor:"pointer", flexShrink:0,
                background: isActive ? allBg : pillBg,
                border: isActive ? "none" : `1px solid ${pillBorder}`,
                transition:"all 0.18s",
              }}>
                <span style={{ fontSize:"12px", fontWeight: isActive ? 700 : 600, color: isActive ? allColor : pillColor, whiteSpace:"nowrap" }}>{cat}</span>
              </button>
            );
          })}
        </div>
      </div>
      <p style={{ fontSize:"11px", color:C.txt3, margin:"4px 0 0" }}>{elakayAutoText("h_e325e758033e63", "Actif :")}<strong style={{ color:C.purple }}>{CAT_DEMO[activeIdx]}</strong></p>
    </div>
  );

  const VertDemo = ({ allBg="#1a1a2e", allColor="#fff", itemBg="transparent", itemColor="#6b7280", itemBorder="#2a3050", itemRadius="6px", sidebarBg="#1a1a2e", label }) => (
    <div>
      <div style={{ fontSize:"11px", fontWeight:700, color:C.txt3, marginBottom:"8px", textTransform:"uppercase", letterSpacing:"0.06em" }}>{label}</div>
      <div style={{ background:sidebarBg, borderRadius:"10px", padding:"12px 10px", display:"flex", flexDirection:"column", gap:"5px", width:"160px" }}>
        {CAT_DEMO.map((cat, i) => {
          const isActive = i === activeIdx;
          return (
            <button key={i} onClick={() => setActiveIdx(i)} style={{
              padding:"8px 12px", borderRadius:itemRadius, cursor:"pointer", textAlign:"left",
              border: isActive ? "none" : `1px solid ${itemBorder}`,
              background: isActive ? allBg : itemBg,
              transition:"all 0.18s",
            }}>
              <span style={{ fontSize:"12px", fontWeight: isActive ? 700 : 500, color: isActive ? allColor : itemColor }}>{cat}</span>
            </button>
          );
        })}
      </div>
      <p style={{ fontSize:"11px", color:C.txt3, margin:"4px 0 0" }}>{elakayAutoText("h_e325e758033e63", "Actif :")}<strong style={{ color:C.purple }}>{CAT_DEMO[activeIdx]}</strong></p>
    </div>
  );

  return (
    <div>
      <SectionTitle icon="✦" title={elakayAutoText("h_0645fa7c6cdac7", "État actif — Couleur au clic")}
        sub="Quand on clique une catégorie ou Tout, elle prend sa couleur active. Les autres reviennent à l'état inactif." />

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_ffafccacc54546", "Démo interactive — cliquez une catégorie")}</h2>
        <div style={{ display:"grid", gridTemplateColumns:"1fr auto", gap:"24px", alignItems:"start" }}>
          <HorizDemo label={elakayAutoText("h_a9c01304337480", "Horizontal (catBar)")} />
          <VertDemo  label={elakayAutoText("h_07c9adb2bdda57", "Vertical (catSidebar)")} sidebarBg="#1a1a2e" allBg="#d4af37" allColor="#0f172a" itemColor="#94a3b8" itemBorder="#2a3050" />
        </div>
        <div style={{ marginTop:"16px", background:"#f5f3ff", borderRadius:"10px", padding:"12px 16px", fontSize:"12px", color:C.purple }}>
          <strong>{elakayAutoText("h_338459f8bd9290", "Principe :")}</strong>{elakayAutoText("h_72efd73ef9aecc", "Tout est actif au chargement. Une catégorie cliquée reçoit l'apparence active du groupe; Tout et les autres catégories reçoivent l'apparence inactive.")}</div>
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_48fc173ccb27e5", "Comment ça fonctionne — les 5 étapes")}</h2>
        {[
          { n:1, title:elakayAutoText("h_70e35d50fd55ed", "Un groupe commun"),
            desc:"Tout et le panel répété des catégories utilisent le même toggleGroup.id." },
          { n:2, title:elakayAutoText("h_636aefc04deb17", "Tout actif par défaut"),
            desc:"Le bouton Tout possède isDefault:true. Le panel catégorie possède isDefault:false." },
          { n:3, title:elakayAutoText("h_d766644d27822f", "Deux apparences partagées"),
            desc:"activeStyle reprend l'apparence de Tout; inactiveStyle reprend l'apparence normale d'une catégorie." },
          { n:4, title:elakayAutoText("h_8e2c335e836c15", "Un seul actif au clic"),
            desc:"PageRenderer garde l'instance cliquée active et rend tous les autres membres inactifs." },
          { n:5, title:elakayAutoText("h_446e8c70dd6b91", "Filtrage synchronisé"),
            desc:"Le même clic appelle loadProductsByArrival_ avec categoryID et categoryName, puis met à jour les produits." },
        ].map(({ n, title, desc }) => <Step key={n} n={n} title={title}>{desc}</Step>)}
        <Tip>{elakayAutoText("h_c236ced0c1289a", "Les anciennes pages sans toggleGroup sont migrées automatiquement par le Builder et par PageRenderer.")}</Tip>
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_5a24515c8d9969", "JSON catBar complet avec état actif")}</h2>
        <p style={S.p}>{elakayAutoText("h_e04d447ec3ddc1", "Aucun script DOM n'est nécessaire. Les apparences sont déclarées directement dans")}<code style={S.inlineCode}>toggleGroup</code>.</p>
        <Code>{`{
  "type": "section",
  "style": { "padding":"12px 32px","background":"#fff","borderBottom":"1px solid #f0f0f0" },
  "children": [{
    "type": "row",

    "style": { "display":"flex","alignItems":"center","gap":"8px","overflowX":"auto","flexWrap":"nowrap","scrollbarWidth":"none" },
    "children": [
      {
        "type":"panel","clickActionType":"function","clickActionFunction":"loadProductsByArrival_",
        "toggleGroup":{
          "id":"cat-main","isDefault":true,
          "activeStyle":{"background":"#1a1a2e","border":"none","color":"#fff","fontWeight":"700"},
          "inactiveStyle":{"background":"#f9fafb","border":"1px solid #e5e7eb","color":"#374151","fontWeight":"600"}
        },
        "style":{ "padding":"7px 20px","background":"#1a1a2e","borderRadius":"50px","cursor":"pointer","flexShrink":0 },
        "children":[{ "type":"text","text":"Tout","tag":"p",
          "style":{ "fontSize":"12px","fontWeight":700,"color":"#ffffff","margin":0,"whiteSpace":"nowrap" } }]
      },
      {
        "type":"panel","repeatBind":{ "source":"store","path":"categories.categories","mode":"children","autoFill":false },
        "clickActionType":"function","clickActionFunction":"loadProductsByArrival_",
        "clickActionArg1":"items.categoryID","clickActionArg2":"items.categoryName",
        "toggleGroup":{
          "id":"cat-main","isDefault":false,
          "activeStyle":{"background":"#1a1a2e","border":"none","color":"#fff","fontWeight":"700"},
          "inactiveStyle":{"background":"#f9fafb","border":"1px solid #e5e7eb","color":"#374151","fontWeight":"600"}
        },
        "style":{ "padding":"7px 20px","background":"#f9fafb","borderRadius":"50px","cursor":"pointer","border":"1px solid #e5e7eb","flexShrink":0 },
        "children":[{ "type":"text","text":"Catégorie","bindKey":"name.0","tag":"p",
          "style":{ "fontSize":"12px","fontWeight":600,"color":"#374151","margin":0,"whiteSpace":"nowrap" } }]
      }
    ]
  }]
}`}</Code>
        <div style={{ background:"#f0fdf4", border:"1px solid #a7f3d0", borderRadius:"8px", padding:"10px 14px", fontSize:"12px", color:"#065f46", marginTop:"8px" }}>
          <strong>{elakayAutoText("h_b132bd50bae969", "Règle :")}</strong>{elakayAutoText("h_19638fbe1ec3f4", "tous les membres gardent le même activeStyle et inactiveStyle; seul isDefault change.")}</div>
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_7256fa2767a12e", "JSON catSidebar complet avec état actif")}</h2>
        <Code>{`{
  "type": "stack",
  "style": { "width":"200px","flexShrink":0,"padding":"24px 14px","background":"#1a1a2e","borderRight":"1px solid #2a3050","display":"flex","flexDirection":"column","gap":"6px" },
  "children": [
    { "type":"text","text":"CATEGORIES","tag":"p",
      "style":{ "fontSize":"10px","fontWeight":700,"color":"#4a5568","letterSpacing":"0.2em","margin":"0 0 12px" } },
    {
      "type":"panel","clickActionType":"function","clickActionFunction":"loadProductsByArrival_",
      "toggleGroup":{
        "id":"cat-side","isDefault":true,
        "activeStyle":{"background":"#d4af37","border":"none","color":"#0f172a","fontWeight":"700"},
        "inactiveStyle":{"background":"transparent","border":"1px solid #2a3050","color":"#94a3b8","fontWeight":"500"}
      },
      "style":{ "padding":"9px 14px","background":"#d4af37","borderRadius":"6px","cursor":"pointer" },
      "children":[{ "type":"text","text":"Tout voir","tag":"p",
        "style":{ "fontSize":"13px","fontWeight":700,"color":"#0f172a","margin":0 } }]
    },
    {
      "type":"panel","repeatBind":{ "source":"store","path":"categories.categories","mode":"children","autoFill":false },
      "clickActionType":"function","clickActionFunction":"loadProductsByArrival_",
      "clickActionArg1":"items.categoryID","clickActionArg2":"items.categoryName",
      "toggleGroup":{
        "id":"cat-side","isDefault":false,
        "activeStyle":{"background":"#d4af37","border":"none","color":"#0f172a","fontWeight":"700"},
        "inactiveStyle":{"background":"transparent","border":"1px solid #2a3050","color":"#94a3b8","fontWeight":"500"}
      },
      "style":{ "padding":"9px 14px","background":"transparent","borderRadius":"6px","cursor":"pointer","border":"1px solid #2a3050" },
      "children":[{ "type":"text","text":"Catégorie","bindKey":"name.0","tag":"p",
        "style":{ "fontSize":"13px","fontWeight":500,"color":"#6b7280","margin":0 } }]
    }
  ]
}`}</Code>
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_46646e6d12bee7", "Variantes par template")}</h2>
        {[
          { label:elakayAutoText("h_f5b82e581b354b", "Classique (crème/brun)"),  actifBg:"#2d1a0e", actifTxt:"#fdf8f0", inactifBg:"#fdf8f0",    inactifTxt:"#2d1a0e", border:"#e8d5b7" },
          { label:elakayAutoText("h_9f7fca4602f347", "Nature (vert)"),           actifBg:"#2d4a3e", actifTxt:"#ecf7ee", inactifBg:"#fff",        inactifTxt:"#2d4a3e", border:"#c8e2ce" },
          { label:elakayAutoText("h_39a7b8fa384777", "Sport (rouge)"),           actifBg:"#ef4444", actifTxt:"#fff",    inactifBg:"#111827",     inactifTxt:"#d1d5db", border:"#374151" },
          { label:elakayAutoText("h_9b5f9fedadda37", "Tech (cyan)"),             actifBg:"#00d4aa", actifTxt:"#0d1117", inactifBg:"transparent", inactifTxt:"#8b949e", border:"#30363d" },
          { label:elakayAutoText("h_a2fd1dfb7f6c83", "Ocean (bleu)"),            actifBg:"#0c4a6e", actifTxt:"#f0f9ff", inactifBg:"#fff",        inactifTxt:"#0c4a6e", border:"#bae6fd" },
          { label:elakayAutoText("h_9a1ccb6f799068", "Nuit (violet)"),           actifBg:"rgba(167,139,250,0.15)", actifTxt:"#a78bfa", inactifBg:"transparent", inactifTxt:"#7c6fa8", border:"#312e81" },
          { label:elakayAutoText("h_4021d0477ff9dc", "Premium (marine/or)"),     actifBg:"#d4af37", actifTxt:"#0f172a", inactifBg:"transparent", inactifTxt:"#94a3b8", border:"#2a3550" },
          { label:elakayAutoText("h_ee4f3cecd18e9a", "Festival (corail)"),       actifBg:"#f43f5e", actifTxt:"#fff",    inactifBg:"#fff",        inactifTxt:"#9a3412", border:"#fbcfe8" },
        ].map(({ label, actifBg, actifTxt, inactifBg, inactifTxt, border }, i) => (
          <div key={i} style={{ display:"flex", gap:"12px", alignItems:"center", marginBottom:"8px", padding:"8px 10px", background:"#fafafa", borderRadius:"8px", border:`1px solid ${C.border}` }}>
            <span style={{ fontSize:"11px", color:C.txt2, minWidth:"180px", flexShrink:0 }}>{label}</span>
            <div style={{ display:"flex", gap:"6px", alignItems:"center" }}>
              <span style={{ padding:"5px 14px", background:actifBg, borderRadius:"50px", fontSize:"10px", fontWeight:700, color:actifTxt, whiteSpace:"nowrap" }}>{elakayAutoText("h_eb05c761ceb94d", "Tout ✓")}</span>
              <span style={{ padding:"5px 14px", background:inactifBg, border:`1px solid ${border}`, borderRadius:"50px", fontSize:"10px", color:inactifTxt, whiteSpace:"nowrap" }}>{elakayAutoText("h_51f8e034badf84", "Polo")}</span>
              <span style={{ padding:"5px 14px", background:inactifBg, border:`1px solid ${border}`, borderRadius:"50px", fontSize:"10px", color:inactifTxt, whiteSpace:"nowrap" }}>{elakayAutoText("h_ed91cd89f3c81b", "Laptop")}</span>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// CONTENT SECTIONS
// ═══════════════════════════════════════════════════════════════════════════════

const SECTIONS = {

  // ── INTRODUCTION ─────────────────────────────────────────────────────────────
  intro: () => (
    <div>
      <SectionTitle icon="🏠" title={elakayAutoText("h_dbdbf62ef46674", "Page Builder — Guide complet")}
        sub="Maîtrisez chaque fonctionnalité pour créer des pages dynamiques liées à vos données réelles." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_492fb7e14bdc05", "Qu'est-ce que le Page Builder ?")}</h2>
        <p style={S.p}>{elakayAutoText("h_ab4be540453946", "Le Page Builder est un éditeur visuel qui permet de concevoir des pages web multi-pages directement dans l'interface Elakay. Vous pouvez :")}</p>
        <ul style={{ paddingLeft:"20px", margin:"0 0 10px" }}>
          {["Glisser-déposer des éléments sur le canevas visuel","Styliser chaque élément via le panneau propriétés","Lier des éléments aux données réelles de votre boutique (produits, catégories…)","Prévisualiser en temps réel sur desktop et mobile","Exporter en JSON ou HTML pour déploiement"].map((t,i)=>(
            <li key={i} style={{ fontSize:"14px", color:C.txt2, lineHeight:1.7, marginBottom:"4px" }}>{t}</li>
          ))}
        </ul>
        <Tip>{elakayAutoText("h_ce665196266fac", "Le Page Builder est non-destructif : toutes vos modifications sont réversibles via l'onglet JSON ou en rechargeant un template.")}</Tip>
      </div>
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_fbbc8310686747", "Flux de travail typique")}</h2>
        <Step n={1} title={elakayAutoText("h_d3077af72c0544", "Choisir un template")}>{elakayAutoText("h_b82a46ba9aa7fd", "Ouvrez le sélecteur de templates (bouton ✦ en haut), choisissez un template adapté à votre mode de page (Boutique, Contenu, Projet…).")}</Step>
        <Step n={2} title={elakayAutoText("h_91788f4aaacbeb", "Personnaliser les éléments")}>{elakayAutoText("h_a4b0583ae73486", "Cliquez un élément dans le canevas → le panneau droit affiche ses propriétés. Modifiez couleurs, textes, styles, animations.")}</Step>
        <Step n={3} title={elakayAutoText("h_1dd501a59d4c3e", "Lier aux données réelles")}>{elakayAutoText("h_cc807cc9842059", "Dans l'onglet")}<b>{elakayAutoText("h_e3e0c5ec8a3b34", "Données")}</b>{elakayAutoText("h_e77d9429393a7b", ", chargez votre jeu de données, puis reliez les clés aux éléments (bindKey / repeatBind).")}</Step>
        <Step n={4} title={elakayAutoText("h_53769748ac13d4", "Prévisualiser")}>{elakayAutoText("h_0caed41d9ecab9", "Cliquez")}<b>{elakayAutoText("h_f0f5300429dfee", "Aperçu")}</b>{elakayAutoText("h_d61db53bd71390", "en haut pour voir le rendu final avec vos données réelles.")}</Step>
        <Step n={5} title={elakayAutoText("h_0cd84bdcb23e59", "Exporter")}>{elakayAutoText("h_8ed5307491f022", "Utilisez")}<b>{elakayAutoText("h_9c89ce2d68c182", "Données → Exporter → Télécharger (JSON)")}</b>{elakayAutoText("h_903f6f5af4bffb", "pour sauvegarder votre page, ou")}<b>{elakayAutoText("h_0b0280f49d4385", "Exporter HTML")}</b>{elakayAutoText("h_121bd13217e9a2", "pour une page standalone.")}</Step>
      </div>
    </div>
  ),

  // ── INTERFACE ─────────────────────────────────────────────────────────────────
  interface: () => (
    <div>
      <SectionTitle icon="🖥️" title={elakayAutoText("h_4b17c6bfc99ddc", "Interface & Panneaux")}
        sub="Le Page Builder est divisé en trois zones principales." />
      {[
        { icon:"◀", title:elakayAutoText("h_302eaa513981dc", "Panneau gauche (Éléments, Calques, Pages…)"), color:C.purple, items:[
          "Onglet Éléments : palettes d'éléments à ajouter (base, layout, rich, forms…)",
          "Onglet HTML : éléments HTML sémantiques",
          "Onglet Calques : arborescence de tous les éléments, permettant sélection et réordonnancement",
          "Onglet Pages : gestion des pages multiples (créer, renommer, supprimer, naviguer)",
          "Onglet Boutique : galerie de templates prêts à l'emploi",
          "Onglet Live ⚡ : composants boutique live (produits, slider, grilles…)",
        ]},
        { icon:"▣", title:elakayAutoText("h_0668531be519b6", "Canevas central (zone de design)"), color:C.green, items:[
          "Cliquez un élément pour le sélectionner (surligné en violet)",
          "Shift+clic pour multi-sélection → styles partagés via la barre du haut",
          "Mode Libre (Free Mode) : positionnement absolu par glisser-déposer",
          "Bascule Desktop ↔ Mobile dans la barre du haut pour prévisualiser la réactivité",
          "Les éléments répétés (repeatBind) montrent les données réelles en aperçu automatique",
        ]},
        { icon:"▶", title:elakayAutoText("h_51c70db038a025", "Panneau droit (Propriétés, Animation, Données…)"), color:C.orange, items:[
          "Onglet Général : styles, action au clic, balise HTML, contenu spécifique au type",
          "Onglet Mapping : liaison de données (bindKey, repeatBind, fieldMap)",
          "Onglet Anim. : choix de l'animation CSS appliquée à l'élément",
          "Onglet Liens : tous les href/target du document",
          "Onglet JSON : éditeur JSON direct, synchronisation bi-directionnelle",
          "Onglet Données : source de données, explorateur de champs, liaisons actives, export, API",
        ]},
      ].map(({ icon, title, color, items }, i) => (
        <div key={i} style={{ ...S.card, borderLeft:`4px solid ${color}` }}>
          <h3 style={{ ...S.h3, color }}>{icon} {title}</h3>
          <ul style={{ paddingLeft:"18px", margin:0 }}>
            {items.map((t,j)=><li key={j} style={{ fontSize:"13px", color:C.txt2, lineHeight:1.7, marginBottom:"3px" }}>{t}</li>)}
          </ul>
        </div>
      ))}
      <Tip>{elakayAutoText("h_0fbfad4eadbe2e", "Les onglets des deux panneaux sont interchangeables : glissez un onglet de droite à gauche (bouton ↔) pour réorganiser votre espace de travail.")}</Tip>
    </div>
  ),

  // ── ELEMENTS BASE ──────────────────────────────────────────────────────────────
  "el-base": () => (
    <div>
      <SectionTitle icon="🧩" title={elakayAutoText("h_1feb050a8ee924", "Éléments — Base")} sub="Les briques fondamentales de toute page." />
      {[
        { type:"heading", label:elakayAutoText("h_eb97899aedcd56", "Titre"), desc:"Balise h1–h6. Définissez le niveau hiérarchique dans Propriétés → Balise HTML.", props:[
          {name:"text",type:"string",desc:"Contenu du titre"},
          {name:"tag",type:"h1…h6",desc:"Niveau hiérarchique"},
          {name:"style.fontSize",type:"string",desc:"Taille (ex: '32px', '2rem')"},
          {name:"style.fontWeight",type:"string",desc:"Graisse (ex: '700', 'bold')"},
          {name:"bindKey",type:"string",desc:"Clé de donnée à afficher (ex: 'store.owner.shopName.0')"},
        ], json:`{ "type":"heading", "text":"Mon titre", "tag":"h2",
  "style":{ "fontSize":"28px", "fontWeight":"800", "color":"#1a1a2e" },
  "bindKey":"store.owner.shopName.0" }` },
        { type:"text", label:elakayAutoText("h_d5766ae0b6d9b7", "Paragraphe / Texte"), desc:"Balise p, span, div. Idéal pour tout contenu textuel courant.", props:[
          {name:"text",type:"string",desc:"Contenu"},
          {name:"tag",type:"p|span|div",desc:"Balise HTML rendue"},
          {name:"bindKey",type:"string",desc:"Clé de donnée"},
        ], json:`{ "type":"text", "text":"Contenu ici", "tag":"p",
  "style":{ "fontSize":"15px", "color":"#4a4a68", "lineHeight":"1.7" } }` },
        { type:"button", label:elakayAutoText("h_fd5aea7172cc0a", "Bouton"), desc:"Bouton cliquable. Configurez son action au clic (URL, fonction, page interne) dans Propriétés → Action Au Clic.", props:[
          {name:"text",type:"string",desc:"Label du bouton"},
          {name:"clickActionType",type:"none|function|url|page",desc:"Type d'action"},
          {name:"clickActionFunction",type:"string",desc:"Nom de la fonction shopUser"},
          {name:"clickActionHref",type:"string",desc:"URL cible"},
          {name:"href",type:"string",desc:"Lien href direct"},
        ], json:`{ "type":"button", "text":"Acheter",
  "clickActionType":"url", "clickActionHref":"/product/123",
  "style":{ "padding":"10px 24px", "background":"#6d28d9", "color":"#fff",
    "borderRadius":"8px", "border":"none", "cursor":"pointer" } }` },
        { type:"image", label:elakayAutoText("h_50e19fda0d5b4b", "Image"), desc:"Image responsive. Utilisez bindKey pour lier à une URL d'image depuis les données boutique.", props:[
          {name:"src",type:"string",desc:"URL de l'image (placeholder par défaut)"},
          {name:"bindKey",type:"string",desc:"Clé données pointant vers l'URL"},
          {name:"style.width",type:"string",desc:"Largeur (ex: '100%', '280px')"},
          {name:"style.height",type:"string",desc:"Hauteur (ex: '220px', 'auto')"},
          {name:"style.objectFit",type:"cover|contain|fill",desc:"Rognage de l'image"},
        ], json:`{ "type":"image", "src":"https://placehold.co/400x300",
  "bindKey":"store.products.0.galeriesID.galeries.0.urlImg.0",
  "style":{ "width":"100%", "height":"220px", "objectFit":"cover",
    "borderRadius":"12px", "display":"block" } }` },
        { type:"link", label:elakayAutoText("h_8fd81573bfc344", "Lien (page)"), desc:"Lien de navigation entre pages du même document.", props:[
          {name:"text",type:"string",desc:"Texte affiché"},
          {name:"linkHref",type:"string",desc:"Cible (id de page ou URL)"},
          {name:"linkTarget",type:"_self|_blank",desc:"Ouverture"},
        ], json:`{ "type":"link", "text":"Voir les produits",
  "linkHref":"/shop", "linkTarget":"_blank" }` },
      ].map(({ type, label, desc, props, json }) => (
        <div key={type} style={{ ...S.card, marginBottom:"16px" }}>
          <div style={{ display:"flex", alignItems:"center", gap:"10px", marginBottom:"8px" }}>
            <Tag label={type} /><span style={{ fontSize:"15px", fontWeight:700, color:C.txt1 }}>{label}</span>
          </div>
          <p style={S.p}>{desc}</p>
          <PropTable rows={props} />
          <Code>{json}</Code>
        </div>
      ))}
    </div>
  ),

  // ── ELEMENTS LAYOUT ────────────────────────────────────────────────────────────
  "el-layout": () => (
    <div>
      <SectionTitle icon="📐" title={elakayAutoText("h_8e88ddaf6e6089", "Éléments — Mise en page")} sub="Conteneurs pour organiser vos éléments." />
      {[
        { type:"section", label:elakayAutoText("h_f2c6b564bd8119", "Section"), desc:"Bloc de section pleine largeur (fond coloré, padding). Idéal pour les grandes zones d'une page (hero, grille produits…)." },
        { type:"row", label:elakayAutoText("h_36baa5fac1553f", "Ligne (Row)"), desc:"Conteneur flex horizontal. Placez des éléments côte à côte. Configurez gap, justify-content, align-items." },
        { type:"stack", label:elakayAutoText("h_83e5a0d3d2ef19", "Stack"), desc:"Conteneur flex vertical (colonne). Empile les enfants avec un gap contrôlable." },
        { type:"grid", label:elakayAutoText("h_48de192f20a1f7", "Grille (Grid)"), desc:"Grille CSS multi-colonnes. Définissez le nombre de colonnes et le gap. Supporte le responsive via deviceGrid.", special:[
          "options.columns: nombre de colonnes (ex: 4)",
          "options.deviceGrid: configuration responsive par breakpoint (mobile/tablet/laptop/desktop)",
          "Ajoutez des enfants avec repeatBind pour auto-remplir depuis un tableau de données",
        ]},
        { type:"panel", label:elakayAutoText("h_aeaa87fa4638ae", "Panneau (Panel)"), desc:"Conteneur générique (div) avec styles libres. Peut avoir des enfants et une action au clic." },
        { type:"banner", label:elakayAutoText("h_d06d3598439edf", "Bannière (Banner)"), desc:"Bande horizontale pleine largeur (fond coloré, contenu centré). Utilisée pour les stat bands ou messages d'alerte." },
      ].map(({ type, label, desc, special }) => (
        <div key={type} style={S.card}>
          <div style={{ display:"flex", alignItems:"center", gap:"10px", marginBottom:"6px" }}>
            <Tag label={type} color="#0369a1" bg="#f0f9ff" />
            <span style={{ fontSize:"14px", fontWeight:700, color:C.txt1 }}>{label}</span>
          </div>
          <p style={S.p}>{desc}</p>
          {special && <ul style={{ paddingLeft:"18px", margin:0 }}>{special.map((s,i)=><li key={i} style={{ fontSize:"12px", color:C.txt2, lineHeight:1.6, marginBottom:"2px" }}>{s}</li>)}</ul>}
        </div>
      ))}
      <div style={S.card}>
        <h3 style={S.h3}>{elakayAutoText("h_28a9df1b0be40c", "Exemple — Grille produits 4 colonnes responsive")}</h3>
        <Code>{`{ "type":"grid",
  "options":{
    "columns": 4,
    "deviceGrid":[
      { "device":"mobile",  "columns":1, "gap":"12px" },
      { "device":"tablet",  "columns":2, "gap":"14px" },
      { "device":"laptop",  "columns":3, "gap":"16px" },
      { "device":"desktop", "columns":4, "gap":"16px" }
    ]
  },
  "children":[{ ...carteProduitsAvecRepeatBind }]
}`}</Code>
      </div>
    </div>
  ),

  // ── ELEMENTS RICH ──────────────────────────────────────────────────────────────
  "el-rich": () => (
    <div>
      <SectionTitle icon="💎" title={elakayAutoText("h_bc285995bdad42", "Éléments — Composants riches")} sub="Composants avancés pour des interactions complexes." />
      {[
        { type:"swiper", label:elakayAutoText("h_8c9338813bd7d4", "Swiper (Carrousel)"), desc:"Carrousel d'images automatique. Liez bindSource à un tableau de slides (ex: store.sliderShop). Configurez autoplay, interval, flèches, points de navigation." },
        { type:"tabs", label:elakayAutoText("h_1bb600afcd0491", "Onglets (Tabs)"), desc:"Groupe d'onglets avec panneaux de contenu. Définissez les items (label + texte) dans Propriétés → Contenu." },
        { type:"accordion", label:elakayAutoText("h_f5fff8bd7e7b14", "Accordéon / FAQ"), desc:"Sections dépliables. Idéal pour les FAQ. Chaque item a un titre (q) et un contenu (a)." },
        { type:"modal", label:elakayAutoText("h_d44c2c5216ec66", "Modal"), desc:"Fenêtre popup. Déclenchez son ouverture via clickActionType:'function' ou depuis un bouton externe ciblant l'id du modal." },
        { type:"quote", label:elakayAutoText("h_a0ed5b51654a72", "Citation (Quote)"), desc:"Citation stylisée avec texte et auteur." },
        { type:"textGroup", label:elakayAutoText("h_a7ba93f4cbb180", "Groupe de textes"), desc:"Ensemble de balises texte (p, h1, h2…) avec styles individuels. Parfait pour les sections hero avec titre + sous-titre." },
        { type:"card", label:elakayAutoText("h_e00008a4203023", "Carte produit (Card)"), desc:"Affichage d'une carte produit complète avec image, nom, prix, bouton panier." },
        { type:"shopCatMatrix", label:elakayAutoText("h_d45410db6b5705", "Catégories Matrix"), desc:"Composant live affichant les catégories boutique avec animation. Liez bindSource à store.categories." },
      ].map(({ type, label, desc }) => (
        <div key={type} style={S.card}>
          <div style={{ display:"flex", alignItems:"center", gap:"10px", marginBottom:"6px" }}>
            <Tag label={type} color="#9333ea" bg="#faf5ff" />
            <span style={{ fontSize:"14px", fontWeight:700, color:C.txt1 }}>{label}</span>
          </div>
          <p style={{ ...S.p, margin:0 }}>{desc}</p>
        </div>
      ))}
    </div>
  ),

  // ── PROPRIETES GENERALES ───────────────────────────────────────────────────────
  properties: () => (
    <div>
      <SectionTitle icon="⚙️" title={elakayAutoText("h_d29f791434bb9d", "Propriétés & Styles généraux")}
        sub="Toutes les propriétés CSS disponibles dans le panneau droite." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_9f4ca9ec08715d", "Dimensions")}</h2>
        <PropTable rows={[
          {name:"width",type:"string",desc:"Largeur : '100%', '320px', 'auto'"},
          {name:"height",type:"string",desc:"Hauteur : '220px', 'auto', '100vh'"},
          {name:"minWidth / maxWidth",type:"string",desc:"Contraintes min/max de largeur"},
          {name:"minHeight / maxHeight",type:"string",desc:"Contraintes min/max de hauteur"},
        ]} />
      </div>
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_e0a35ec4d2a004", "Espacement")}</h2>
        <PropTable rows={[
          {name:"padding",type:"string",desc:"Espace intérieur (ex: '20px 32px')"},
          {name:"paddingTop/Right/Bottom/Left",type:"string",desc:"Espacement individuel"},
          {name:"margin",type:"string",desc:"Espace extérieur"},
          {name:"gap",type:"string",desc:"Espace entre enfants flex/grid (ex: '16px')"},
        ]} />
      </div>
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_c746bb02dd1ad9", "Typographie")}</h2>
        <PropTable rows={[
          {name:"fontSize",type:"string",desc:"Taille du texte ('14px', '1.2rem')"},
          {name:"fontWeight",type:"string",desc:"Graisse ('400', '700', '900')"},
          {name:"color",type:"string",desc:"Couleur du texte (hex, rgb, var)"},
          {name:"lineHeight",type:"string",desc:"Hauteur de ligne ('1.5', '24px')"},
          {name:"textAlign",type:"left|center|right",desc:"Alignement"},
          {name:"textTransform",type:"string",desc:"Casse ('uppercase', 'capitalize')"},
          {name:"letterSpacing",type:"string",desc:"Espacement des lettres ('0.1em')"},
        ]} />
      </div>
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_5b48eff7bf8e08", "Fond & Bordures")}</h2>
        <PropTable rows={[
          {name:"background",type:"string",desc:"Fond : couleur, gradient ou URL image"},
          {name:"border",type:"string",desc:"Bordure complète ('1px solid #e5e7eb')"},
          {name:"borderRadius",type:"string",desc:"Arrondi des coins ('8px', '50%')"},
          {name:"boxShadow",type:"string",desc:"Ombre portée ('0 4px 20px rgba(0,0,0,0.1)')"},
          {name:"opacity",type:"number",desc:"Opacité (0–1)"},
        ]} />
      </div>
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_b7ba4b35f93557", "Flex & Disposition")}</h2>
        <PropTable rows={[
          {name:"display",type:"string",desc:"'flex', 'grid', 'block', 'inline-block'"},
          {name:"flexDirection",type:"string",desc:"'row', 'column'"},
          {name:"justifyContent",type:"string",desc:"Alignement principal ('center', 'space-between')"},
          {name:"alignItems",type:"string",desc:"Alignement croisé ('center', 'flex-start')"},
          {name:"flexWrap",type:"wrap|nowrap",desc:"Retour à la ligne des enfants"},
          {name:"flex",type:"string",desc:"Facteur de croissance ('1' = prend l'espace restant)"},
        ]} />
      </div>
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_2a866d6868c67f", "Styles Mobile (surcharges)")}</h2>
        <p style={S.p}>{elakayAutoText("h_49ffe123dc0c99", "En mode Mobile (bascule barre du haut), les styles que vous modifiez s'écrivent dans")}<code style={S.inlineCode}>mobileStyle</code>{elakayAutoText("h_6d05d1f900f30c", "et surchargent le style desktop sans l'écraser.")}</p>
        <Code>{`// Desktop: style de base
"style": { "fontSize":"22px", "padding":"40px 48px" },
// Mobile: surcharges uniquement
"mobileStyle": { "fontSize":"16px", "padding":"20px 16px" }`}</Code>
        <Tip>{elakayAutoText("h_da4c0ed24ba43a", "Réinitialisez les surcharges mobile via le bouton \"Réinitialiser les surcharges mobile\" dans le panneau droite.")}</Tip>
      </div>
    </div>
  ),

  // ── ANIMATIONS ─────────────────────────────────────────────────────────────────
  "anim-how": () => (
    <div>
      <SectionTitle icon="✨" title={elakayAutoText("h_91f14219fac813", "Animations — Comment ajouter")}
        sub="Appliquez des animations CSS à n'importe quel élément." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_8562e33e574462", "Étapes pour animer un élément")}</h2>
        <Step n={1} title={elakayAutoText("h_5011422d5a62e2", "Sélectionner l'élément")}>{elakayAutoText("h_e56484d72a0390", "Cliquez l'élément dans le canevas ou dans le panneau Calques.")}</Step>
        <Step n={2} title={elakayAutoText("h_10b145a5b015d1", "Ouvrir l'onglet Anim.")}>{elakayAutoText("h_d9690aa5396d9e", "Dans le panneau droite, cliquez l'onglet")}<b>{elakayAutoText("h_fc018a615aeaf7", "Anim.")}</b></Step>
        <Step n={3} title={elakayAutoText("h_726e763dd38ce5", "Choisir l'animation")}>{elakayAutoText("h_7841f31de3d959", "Sélectionnez une animation dans la liste déroulante. Un aperçu s'affiche immédiatement dans le canevas.")}</Step>
        <Step n={4} title={elakayAutoText("h_33d6298ea700c2", "Configurer (optionnel)")}>{elakayAutoText("h_db4530bb143589", "Ajustez la durée, le délai, le nombre d'itérations et la fonction de timing.")}</Step>
      </div>
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_86c300cd388cd7", "Propriétés d'animation")}</h2>
        <PropTable rows={[
          {name:"animation",type:"string",desc:"Nom de l'animation CSS (ex: 'fadeInUp', 'pulse')"},
          {name:"animationDuration",type:"string",desc:"Durée ('0.5s', '1.2s')"},
          {name:"animationDelay",type:"string",desc:"Délai avant démarrage ('0s', '0.3s')"},
          {name:"animationIterationCount",type:"string",desc:"Nombre d'itérations ('1', 'infinite')"},
          {name:"animationTimingFunction",type:"string",desc:"Courbe de vitesse ('ease', 'linear', 'ease-in-out')"},
          {name:"animationFillMode",type:"string",desc:"État final ('both', 'forwards', 'none')"},
        ]} />
        <Code>{`{ "type":"heading", "text":"Titre animé",
  "animation": "fadeInUp",
  "animationDuration": "0.8s",
  "animationDelay": "0.2s",
  "animationFillMode": "both" }`}</Code>
      </div>
      <Tip>{elakayAutoText("h_a05ccd77497bb8", "Les animations s'appliquent au chargement de la page. Utilisez")}<b>{elakayAutoText("h_59835572a02b7a", "animationDelay")}</b>{elakayAutoText("h_7c9956e980f925", "pour créer des effets d'entrée en cascade.")}</Tip>
    </div>
  ),

  "anim-types": () => (
    <div>
      <SectionTitle icon="🎬" title={elakayAutoText("h_2cf0f244a16089", "Animations — Types disponibles")} />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_64e6fa0b4fe6b4", "Animations d'entrée")}</h2>
        {[
          ["fadeIn","Apparition progressive (opacité 0→1)"],
          ["fadeInUp","Apparition en montant"],
          ["fadeInDown","Apparition en descendant"],
          ["fadeInLeft","Apparition depuis la gauche"],
          ["fadeInRight","Apparition depuis la droite"],
          ["slideInUp","Glissement depuis le bas"],
          ["slideInLeft","Glissement depuis la gauche"],
          ["zoomIn","Zoom avant depuis 0"],
          ["bounceIn","Apparition rebondissante"],
          ["flipInX","Rotation sur axe X"],
        ].map(([name,desc])=>(
          <div key={name} style={{ display:"flex", gap:"12px", marginBottom:"6px", alignItems:"flex-start" }}>
            <code style={{ ...S.inlineCode, flexShrink:0 }}>{name}</code>
            <span style={{ fontSize:"13px", color:C.txt2 }}>{desc}</span>
          </div>
        ))}
      </div>
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_b8a469220025d6", "Animations continues")}</h2>
        {[
          ["pulse","Pulsation (zoom léger répété)"],
          ["bounce","Rebond vertical répété"],
          ["spin","Rotation continue (360°)"],
          ["shake","Vibration horizontale"],
          ["float","Lévitation douce"],
          ["glow","Halo lumineux pulsant"],
        ].map(([name,desc])=>(
          <div key={name} style={{ display:"flex", gap:"12px", marginBottom:"6px" }}>
            <code style={{ ...S.inlineCode, flexShrink:0 }}>{name}</code>
            <span style={{ fontSize:"13px", color:C.txt2 }}>{desc}</span>
          </div>
        ))}
      </div>
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_7d16f0952c3303", "Animations de fond (shopCatMatrix)")}</h2>
        <p style={S.p}>{elakayAutoText("h_d2ca854492ae96", "Le composant")}<code style={S.inlineCode}>shopCatMatrix</code>{elakayAutoText("h_260c51a3398171", "utilise un système d'animation de fond distinct via")}<code style={S.inlineCode}>options.type_Animation</code> :</p>
        <Code>{`{ "type":"shopCatMatrix",
  "options":{
    "type_Animation": "0_type_Animation",   // Arc-en-ciel
    // "type_Animation": "19_type_Animation",  // Neon Glow
    // "type_Animation": "24_type_Animation",  // Water Ripples
    "title": "Nos Catégories",
    "titleColor": "#1f2937",
    "nbrArr": 4
  } }`}</Code>
        <Tip>{elakayAutoText("h_30fda5b7c39018", "Consultez l'onglet Paramètres d'Animation dans les paramètres de l'app pour une galerie complète de toutes les animations disponibles (0 à 30+).")}</Tip>
      </div>
    </div>
  ),

  "anim-tips": () => (
    <div>
      <SectionTitle icon="💡" title={elakayAutoText("h_7b2cc4411c7458", "Animations — Conseils & bonnes pratiques")} />
      <div style={S.card}>
        {[
          { title:elakayAutoText("h_cdb3d5ceecc6a7", "Cascade d'entrée"), desc:"Pour un effet d'entrée en cascade (éléments qui apparaissent l'un après l'autre), appliquez fadeInUp à chaque enfant avec un animationDelay croissant : 0s, 0.1s, 0.2s, 0.3s…" },
          { title:elakayAutoText("h_eb1009ec85d98d", "Ne pas abuser"), desc:"Limitez les animations continues (pulse, spin) aux éléments qui doivent attirer l'attention (badge, CTA). Trop d'animations simultanées nuit à l'expérience." },
          { title:elakayAutoText("h_22a02e5a22b935", "animationFillMode: both"), desc:"Toujours utiliser 'both' pour que l'élément reste dans son état final après l'animation et n'apparaisse pas avant l'animation." },
          { title:elakayAutoText("h_63c90455999393", "Performance"), desc:"Préférez les animations transform/opacity (fadeIn, slideIn) aux animations layout (width, height) pour éviter le repainting GPU." },
          { title:elakayAutoText("h_b1d702459399a2", "Mobile"), desc:"Réduisez ou désactivez les animations complexes sur mobile via mobileStyle: { animation: 'none' }." },
        ].map(({ title, desc }, i) => (
          <div key={i} style={{ marginBottom:"14px", paddingBottom:"14px", borderBottom:i<4?`1px solid ${C.border}`:"none" }}>
            <div style={{ fontSize:"14px", fontWeight:700, color:C.txt1, marginBottom:"4px" }}>✓ {title}</div>
            <p style={{ ...S.p, margin:0 }}>{desc}</p>
          </div>
        ))}
      </div>
    </div>
  ),

  // ── LIENS & ACTIONS ────────────────────────────────────────────────────────────
  links: () => (
    <div>
      <SectionTitle icon="🔗" title={elakayAutoText("h_1dd8d0f2dcc1d7", "Liens & Actions au clic")}
        sub="Configurez ce qui se passe quand un visiteur clique un élément." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_09e4146c3fe1c2", "Types d'action disponibles")}</h2>
        <PropTable rows={[
          {name:"none",type:"—",desc:"Aucune action (par défaut)"},
          {name:"function",type:"shopUser",desc:"Appelle une fonction runtime de la boutique"},
          {name:"url",type:"string",desc:"Ouvre une URL (même onglet ou nouvel onglet)"},
          {name:"page",type:"string",desc:"Navigue vers une page interne du document"},
        ]} />
      </div>
    </div>
  ),

  "link-fn": () => (
    <div>
      <SectionTitle icon="⚡" title={elakayAutoText("h_364e9e12778868", "Action — Fonction shopUser")}
        sub="Fonctions runtime disponibles dans le contexte boutique." />
      <div style={S.card}>
        <p style={S.p}>{elakayAutoText("h_543047a1a90a9f", "Les fonctions shopUser sont des actions prédéfinies qui interagissent avec les données boutique en temps réel.")}</p>
        {[
          ["loadProductsByArrival(search?, filters?, limit?)", "Recharge tous les produits, catégories et données boutique"],
          ["loadProductsByArrival_(categoryID?, categoryName?, limit?)", "Filtre les produits par catégorie (utilisé avec les boutons/pills de catégorie)"],
          ["loadMore(limit?)", "Passe à la page suivante de produits (pagination →)"],
          ["loadMore0(limit?)", "Revient à la page précédente (pagination ←)"],
          ["loadindSearCh(searchText)", "Lance une recherche dans les produits"],
          ["setFilterShop(value)", "Toggle un filtre boutique"],
          ["onFilterShop()", "Réinitialise la recherche et affiche les filtres"],
          ["clickToFollowShop()", "Bascule le même bouton entre Follow et Unfollow via addFollowUserShop"],
        ].map(([fn, desc], i) => (
          <div key={i} style={{ marginBottom:"10px" }}>
            <code style={{ ...S.inlineCode, display:"block", marginBottom:"3px", padding:"4px 8px" }}>{fn}</code>
            <span style={{ fontSize:"12px", color:C.txt2 }}>→ {desc}</span>
          </div>
        ))}
        <Code>{`// Bouton "Tout voir" — charge tous les produits
{ "type":"button", "text":"Tout voir",
  "clickActionType":"function",
  "clickActionFunction":"loadProductsByArrival_" }

// Bouton catégorie "Électronique"
{ "type":"panel", "clickActionType":"function",
  "clickActionFunction":"loadProductsByArrival_",
  "clickActionArg1":"catID_electronique",
  "clickActionArg2":"Électronique" }

// Bouton Next Page
{ "type":"button", "text":"Next →",
  "clickActionType":"function",
  "clickActionFunction":"loadMore" }`}</Code>
      </div>
    </div>
  ),

  "link-url": () => (
    <div>
      <SectionTitle icon="🌐" title={elakayAutoText("h_b8fce6633a6b92", "Action — URL / Lien externe")} />
      <div style={S.card}>
        <p style={S.p}>{elakayAutoText("h_2885f203a01e8a", "Ouvre une URL dans le même onglet ou un nouvel onglet.")}</p>
        <PropTable rows={[
          {name:"clickActionType",type:"url",desc:"Définir à 'url'"},
          {name:"clickActionHref",type:"string",desc:"URL cible (absolue ou relative)"},
          {name:"clickActionTargetBlank",type:"boolean",desc:"true = nouvel onglet, false = même onglet"},
        ]} />
        <Code>{`{ "type":"button", "text":"Voir la boutique",
  "clickActionType":"url",
  "clickActionHref":"/lakay-ShopSeller/userId123",
  "clickActionTargetBlank": false }`}</Code>
        <Tip>{elakayAutoText("h_d3d189c4d7592b", "Vous pouvez utiliser des clés de données dans l'URL (résolution automatique au rendu) :")}<code style={S.inlineCode}>store.links.shopPage</code></Tip>
      </div>
    </div>
  ),

  "link-page": () => (
    <div>
      <SectionTitle icon="📄" title={elakayAutoText("h_81178e28b434cc", "Action — Page interne")} />
      <div style={S.card}>
        <p style={S.p}>{elakayAutoText("h_6ade0521310e6a", "Navigue vers une page du même document (multi-pages).")}</p>
        <PropTable rows={[
          {name:"clickActionType",type:"page",desc:"Définir à 'page'"},
          {name:"clickActionPageId",type:"string",desc:"ID ou nom de la page cible"},
        ]} />
        <Code>{`{ "type":"button", "text":"Aller à la page 2",
  "clickActionType":"page",
  "clickActionPageId":"page-id-ou-nom" }`}</Code>
        <Tip>{elakayAutoText("h_cfeda6341e6f54", "Créez plusieurs pages via l'onglet Pages du panneau gauche. Naviguez entre elles en cliquant dans l'onglet Pages.")}</Tip>
      </div>
    </div>
  ),

  // ── DONNÉES & BINDING ──────────────────────────────────────────────────────────
  "data-bind": ({ isBoutique }) => {
    const ALL_KEYS = [
      ["store.owner.shopName.0","Nom de la boutique (premier)"],
      ["store.siseProductAll","Nombre total de produits"],
      ["store.products.0.name","Nom du premier produit"],
      ["store.products.0.price","Prix du premier produit"],
      ["store.products.0.galeriesID.galeries.0.urlImg.0","Image du premier produit"],
      ["store.categories.categories","Tableau des catégories"],
      ["contentPage.pageTitle","Titre de la page de contenu"],
    ];
    const keys = isBoutique ? ALL_KEYS.filter(([k]) => !k.startsWith("contentPage") && !k.startsWith("project")) : ALL_KEYS;
    return (
      <div>
        <SectionTitle icon="🔑" title={elakayAutoText("h_c43bc081865285", "Liaison de données — bindKey")}
          sub="Liez le contenu d'un élément à un champ de vos données." />
        <div style={S.card}>
          <h2 style={S.h2}>{elakayAutoText("h_c05bafdb56031b", "Concept")}</h2>
          <p style={S.p}>{elakayAutoText("h_27794369aea4a7", "La propriété")}<code style={S.inlineCode}>bindKey</code>{elakayAutoText("h_6e7b30769010f6", "remplace la valeur statique d'un élément par la valeur d'un champ dans les données chargées.")}</p>
          <Code>{`// Sans binding (valeur statique)
{ "type":"heading", "text":"Ma Boutique" }

// Avec binding — affiche le nom réel de la boutique
{ "type":"heading", "text":"Ma Boutique",
  "bindKey": "store.owner.shopName.0" }`}</Code>
          <h2 style={S.h2}>{elakayAutoText("h_d99ba64442dde4", "Comment lier")}</h2>
          <Step n={1}>{elakayAutoText("h_e01e17e9eb34da", "Chargez un jeu de données dans Données → Source de données.")}</Step>
          <Step n={2}>{elakayAutoText("h_2bf0ede12ded1e", "Sélectionnez l'élément à lier dans le canevas.")}</Step>
          <Step n={3}>{elakayAutoText("h_a14f6037372cfa", "Dans l'onglet Mapping → Liaison de données, naviguez l'explorateur et cliquez ✓ sur le champ voulu.")}</Step>
          <Step n={4}>{elakayAutoText("h_32a577a100748e", "Le bindKey est automatiquement appliqué. L'aperçu se met à jour.")}</Step>
          <h2 style={S.h2}>{elakayAutoText("h_4c6f55c783f676", "Clés store.* disponibles")}</h2>
          {keys.map(([key, desc], i) => (
            <div key={i} style={{ display:"flex", gap:"8px", marginBottom:"6px", alignItems:"flex-start" }}>
              <code style={{ ...S.inlineCode, flexShrink:0, fontSize:"11px" }}>{key}</code>
              <span style={{ fontSize:"12px", color:C.txt2 }}>{desc}</span>
            </div>
          ))}
        </div>
      </div>
    );
  },

  "data-rep": ({ isBoutique }) => {
    const ALL_EXAMPLES = [
      { source:"store",       path:"products",             desc:"Grille de produits boutique" },
      { source:"store",       path:"categories.categories",desc:"Barre/sidebar de catégories" },
      { source:"contentPage", path:"sections",             desc:"Sections d'une page de contenu" },
      { source:"project",     path:"plans",                desc:"Cartes des plans d'investissement" },
      { source:"project",     path:"faq",                  desc:"Accordéon FAQ" },
    ];
    const examples = isBoutique ? ALL_EXAMPLES.filter(e => e.source !== "contentPage" && e.source !== "project") : ALL_EXAMPLES;
    return (
    <div>
      <SectionTitle icon="🔄" title={elakayAutoText("h_3a01bc215dbbab", "repeatBind — Répéter sur un tableau")}
        sub="Générez automatiquement un élément pour chaque item d'un tableau." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_c05bafdb56031b", "Concept")}</h2>
        <p style={S.p}>{elakayAutoText("h_27794369aea4a7", "La propriété")}<code style={S.inlineCode}>repeatBind</code>{elakayAutoText("h_a0d56fcbe0435f", "duplique un élément (gabarit) pour chaque item d'un tableau de données. C'est ainsi que fonctionne la grille de produits.")}</p>
        <Code>{`// Un seul élément "carte produit" avec repeatBind
// → se duplique autant de fois qu'il y a de produits
{ "type":"panel",
  "repeatBind":{
    "source": "store",
    "path": "products",
    "mode": "children",   // "children" = les enfants sont les gabarits
    "autoFill": true,     // remplit automatiquement les champs enfants
    "paginate": true,
    "pageSize": 12
  },
  "children":[
    { "type":"image", "bindKey":"galeriesID.galeries.0.urlImg.0" },
    { "type":"heading", "text":"Nom", "bindKey":"name" },
    { "type":"text", "text":"Prix", "bindKey":"price" }
  ]
}`}</Code>
        <Tip>{elakayAutoText("h_68463c66bafae5", "Dans un gabarit repeatBind, les bindKey des enfants sont RELATIFS à chaque item du tableau — pas besoin de préfixer par 'store.products.0.'.")}</Tip>
        <h2 style={S.h2}>{elakayAutoText("h_764de6aabb7959", "Exemples de repeatBind")}</h2>
        {examples.map(({ source, path, desc }, i) => (
          <div key={i} style={{ padding:"6px 10px", background:"#f5f3ff", borderRadius:"7px", marginBottom:"4px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <code style={{ fontSize:"11px", color:C.purple }}>{source}.{path}</code>
            <span style={{ fontSize:"11px", color:C.txt2 }}>{desc}</span>
          </div>
        ))}
      </div>
    </div>
    );
  },

  "data-modes": ({ isBoutique }) => {
    const ALL_MODES = [
      { id:"static",      color:C.cyan,   label:elakayAutoText("h_26e378ccde6724", "Statique"),                          desc:"Aucune donnée externe. Pour les pages de présentation, contrats, documents fixes. Les éléments ont des valeurs statiques uniquement." },
      { id:"store",       color:C.purple, label:elakayAutoText("h_ae64243512289a", "Boutique (store)"),                  desc:"Données boutique en temps réel. Accès à produits, catégories, vendeur, slider, filtres. Idéal pour les pages boutique personnalisées." },
      { id:"contentPage", color:C.green,  label:elakayAutoText("h_010c8962b67de5", "Page de contenu (contentPage)"),     desc:"Pages de contenu Elakay (À propos, Devenir vendeur, Plans…). Données structurées en sections avec titre, texte, liste, image, vidéo." },
      { id:"project",     color:C.gold,   label:elakayAutoText("h_1ec2860fe15b07", "Projet / Investissement (project)"), desc:"Pages de projet avec plans, statistiques, équipe, FAQ. Pour les pages d'investissement et partenariats." },
    ];
    const modes = isBoutique ? ALL_MODES.filter(m => m.id !== "contentPage" && m.id !== "project") : ALL_MODES;
    return (
      <div>
        <SectionTitle icon="🗂️" title={elakayAutoText("h_35cff871da7d08", "Modes de page")} sub="Le mode contrôle quelles données sont disponibles pour le binding." />
        <div style={S.card}>
          {modes.map(({ id, color, label, desc }) => (
            <div key={id} style={{ borderLeft:`4px solid ${color}`, paddingLeft:"12px", marginBottom:"16px" }}>
              <div style={{ fontSize:"14px", fontWeight:700, color, marginBottom:"4px" }}>{label}</div>
              <p style={{ ...S.p, margin:0 }}>{desc}</p>
            </div>
          ))}
          <Warn>{elakayAutoText("h_0ea0ac6d4cb395", "Le mode de page est défini dans le panneau droite quand aucun élément n'est sélectionné (section \"Mode de page\"). Une fois défini et sauvegardé, il est chargé automatiquement.")}</Warn>
        </div>
      </div>
    );
  },

  "data-json": () => (
    <div>
      <SectionTitle icon="{ }" title={elakayAutoText("h_1d94d94f37e11b", "Onglet JSON — Édition directe")}
        sub="Modifiez le document JSON de la page directement." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_f43ac0588e6a45", "Synchro automatique")}</h2>
        <p style={S.p}>{elakayAutoText("h_a3982e561982ab", "Activez la")}<b>{elakayAutoText("h_f43ac0588e6a45", "Synchro automatique")}</b>{elakayAutoText("h_f8fd78358b5028", "pour que l'éditeur JSON et le canevas visuel se synchronisent dans les deux sens en temps réel. Désactivez-la pour des modifications complexes sans rechargement à chaque frappe.")}</p>
        <h2 style={S.h2}>{elakayAutoText("h_6dcb1ece206d34", "Structure du document")}</h2>
        <Code>{`{
  "meta": { "title": "Mon site", "description": "..." },
  "pageMode": "store",
  "currentPageId": "page-id",
  "pages": [
    {
      "id": "page-id",
      "name": "Accueil",
      "style": { "width":"100%", "margin":0, "padding":0 },
      "children": [
        // ... éléments de la page
      ]
    }
  ]
}`}</Code>
        <Tip>{elakayAutoText("h_364985c4812f0c", "Utilisez Données → Copier toute la page pour obtenir le JSON complet, puis collez-le dans l'onglet JSON pour restaurer ou modifier.")}</Tip>
      </div>
    </div>
  ),

  // ── BOUTIQUE LIVE ─────────────────────────────────────────────────────────────
  live: () => (
    <div>
      <SectionTitle icon="🏪" title={elakayAutoText("h_0e37f7562500ac", "Boutique Live (Live ⚡)")}
        sub="Composants qui se synchronisent automatiquement avec vos données boutique réelles." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_323773b512b04f", "Composants disponibles")}</h2>
        {[
          { type:"shopHeader", label:elakayAutoText("h_d93c365d9d2c9d", "Header Boutique"), desc:"En-tête complet avec logo, recherche, panier, navigation." },
          { type:"shopProductGrid", label:elakayAutoText("h_5797493d06691f", "Grille Produits"), desc:"Grille responsive de produits avec pagination intégrée. Auto-sync avec store.products." },
          { type:"shopCard", label:elakayAutoText("h_236da7e95890a7", "Carte Produit"), desc:"Carte produit individuelle avec image, nom, prix, remise, étoiles, bouton panier." },
          { type:"shopPrice", label:elakayAutoText("h_568077469dc7c1", "Prix & Remise"), desc:"Affichage du prix avec calcul automatique de la remise salePrice." },
          { type:"shopSlider", label:elakayAutoText("h_ecc7dc2d04eeed", "Hero Slider"), desc:"Slider de la boutique. Auto-sync avec store.sliderShop." },
          { type:"shopCarousel", label:elakayAutoText("h_3b11eb795d1659", "Carrousel Produits"), desc:"Carrousel horizontal de produits. Auto-sync avec store.products." },
          { type:"shopCatMatrix", label:elakayAutoText("h_d45410db6b5705", "Catégories Matrix"), desc:"Grille animée des catégories avec images. Auto-sync avec store.categories." },
          { type:"shopVote", label:elakayAutoText("h_4c12d0a3b1e65c", "Vote / Étoiles"), desc:"Système de notation produit. Auto-sync avec store.products.0.Stars." },
          { type:"shopButtonPagination", label:elakayAutoText("h_100325b8d6de92", "Pagination"), desc:"Boutons ← / → pour naviguer entre les pages de produits."},
        ].map(({ type, label, desc }) => (
          <div key={type} style={{ display:"flex", gap:"12px", marginBottom:"10px", paddingBottom:"10px", borderBottom:`1px solid ${C.border}` }}>
            <Tag label={type} color="#059669" bg="#ecfdf5" />
            <div>
              <div style={{ fontSize:"13px", fontWeight:700, color:C.txt1 }}>{label}</div>
              <div style={{ fontSize:"12px", color:C.txt2, marginTop:"2px" }}>{desc}</div>
            </div>
          </div>
        ))}
        <Tip>{elakayAutoText("h_f48af033db4c46", "Les composants Live nécessitent que le mode de page soit défini sur")}<b>{elakayAutoText("h_ae64243512289a", "Boutique (store)")}</b>{elakayAutoText("h_365ab5607b7878", "et que des données réelles soient chargées (via les liveDatasets de l'application).")}</Tip>
      </div>
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_7a715e0049037e", "Exemple — Grille produits live")}</h2>
        <Code>{`{ "type": "shopProductGrid",
  "bindSource": "store",
  "style": { "width":"100%", "padding":"32px 40px" } }`}</Code>
        <p style={S.p}>{elakayAutoText("h_ea01a0d737667d", "En mode aperçu, ce composant charge automatiquement les produits depuis l'API boutique et gère lui-même la pagination.")}</p>
      </div>
    </div>
  ),

  // ── TEMPLATES PAS À PAS ────────────────────────────────────────────────────────
  "tpl-classique": () => (
    <div>
      <SectionTitle icon="🏗️" title={elakayAutoText("h_2f6e27bc253888", "Template Boutique Classique — Pas à pas")}
        sub="Créez une boutique complète style crème/or étape par étape." />
      <div style={{ ...S.card, borderTop:`4px solid ${C.gold}` }}>
        <h2 style={S.h2}>{elakayAutoText("h_42ad93a86199f8", "Vue d'ensemble du template")}</h2>
        <p style={S.p}>{elakayAutoText("h_1d6312f702c694", "La Boutique Classique est composée de 5 sections empilées :")}</p>
        {[
          ["Swiper Hero","Carrousel plein écran (400px) lié à store.sliderShop","#fdf8f0","#b8943f"],
          ["Header inline","Nom boutique + stat produits + bouton Explorer","#fdf8f0","#b8943f"],
          ["Barre catégories","Scroll horizontal de pills (catBar) liés à store.categories","#ffffff","#2d1a0e"],
          ["Section vedette","shopCatMatrix animée (produits vedettes par catégorie)","#fdf8f0","#b8943f"],
          ["Grille produits","Grid 4 cols avec pagination, liée à store.products","#ffffff","#b8943f"],
        ].map(([section, desc, bg, color], i) => (
          <div key={i} style={{ display:"flex", gap:"12px", marginBottom:"8px", padding:"8px 12px", background:bg, borderRadius:"8px", border:`1px solid #e8d5b7` }}>
            <span style={{ fontWeight:700, fontSize:"12px", color, minWidth:"120px", flexShrink:0 }}>{i+1}. {section}</span>
            <span style={{ fontSize:"12px", color:"#7a5c3a" }}>{desc}</span>
          </div>
        ))}
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_d97119c0d96b91", "Étape 1 — Charger le template")}</h2>
        <Step n={1} title={elakayAutoText("h_5fdd73618147fa", "Ouvrir le sélecteur de templates")}>{elakayAutoText("h_8909b051fb31fb", "Cliquez le bouton ✦")}<b>{elakayAutoText("h_f25b700ed9f092", "Templates")}</b>{elakayAutoText("h_be5b24d9024bf3", "dans la barre du haut du Page Builder.")}</Step>
        <Step n={2} title={elakayAutoText("h_44411af620198a", "Choisir le mode Store")}>{elakayAutoText("h_1284bf2d2de47d", "Vérifiez que l'onglet")}<b>{elakayAutoText("h_ae64243512289a", "Boutique (store)")}</b>{elakayAutoText("h_334d197cbba3c5", "est actif dans le sélecteur.")}</Step>
        <Step n={3} title={elakayAutoText("h_7986c68b88b2e6", "Charger Classique")}>{elakayAutoText("h_ade7208613264d", "Cliquez sur la carte")}<b>{elakayAutoText("h_4232e9dd0710bd", "Boutique Classique")}</b>{elakayAutoText("h_c0bcc319046399", ". La page se charge immédiatement avec les données de démo.")}</Step>
        <Warn>{elakayAutoText("h_e36f4f3dc908b7", "Charger un template écrase la page courante. Exportez votre travail en JSON avant si nécessaire.")}</Warn>
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_7755768428e213", "Étape 2 — Connecter les données réelles")}</h2>
        <Step n={1} title={elakayAutoText("h_0c72b74e8ddd03", "Aller dans Données")}>{elakayAutoText("h_d9690aa5396d9e", "Dans le panneau droite, cliquez l'onglet")}<b>{elakayAutoText("h_e3e0c5ec8a3b34", "Données")}</b>.</Step>
        <Step n={2} title={elakayAutoText("h_092c84543a2741", "Sélectionner votre boutique")}>{elakayAutoText("h_7147c4cf586249", "Dans Source de données, choisissez votre boutique réelle (● données réelles) dans la liste.")}</Step>
        <Step n={3} title={elakayAutoText("h_a7997daf2ea8c5", "Vérifier les liaisons")}>{elakayAutoText("h_7ca4e2347e5d0b", "Les éléments liés (swiper, nom boutique, stat produits) se mettent à jour automatiquement avec vos vraies données.")}</Step>
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_964e990f3f3833", "Étape 3 — Personnaliser les couleurs")}</h2>
        <Step n={1} title={elakayAutoText("h_98a5d5da3c117d", "Sélectionner le Hero Swiper")}>{elakayAutoText("h_0ffe1db5a32b84", "Cliquez le swiper dans le canevas. Dans Propriétés → Style, modifiez")}<code style={S.inlineCode}>background</code>{elakayAutoText("h_77de19d4ee90a8", "pour le fond et")}<code style={S.inlineCode}>itemStyle.overlay</code>{elakayAutoText("h_5d6b1266072b47", "pour la couleur de l'overlay.")}</Step>
        <Step n={2} title={elakayAutoText("h_04843c91930959", "Modifier la palette")}>{elakayAutoText("h_8962721f4f2dd6", "La palette crème/or (")}<code style={S.inlineCode}>#fdf8f0</code> / <code style={S.inlineCode}>#b8943f</code>{elakayAutoText("h_576f5aeedd9c10", ") est appliquée sur tous les éléments. Modifiez chaque section en les sélectionnant une à une.")}</Step>
        <Step n={3} title={elakayAutoText("h_613c2cbb7642d4", "Changer le logo/nom")}>{elakayAutoText("h_eecca4ce055e44", "Cliquez l'élément Titre dans le header inline. Si bindKey = store.owner.shopName.0, le nom de votre boutique s'affiche automatiquement.")}</Step>
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_45ddd84768b44b", "Étape 4 — Configurer les catégories (catBar)")}</h2>
        <Step n={1}>{elakayAutoText("h_6dcfa986ee410f", "La barre catégories (section 3) est liée à")}<code style={S.inlineCode}>store.categories.categories</code>{elakayAutoText("h_66f2f61a82c949", "via repeatBind.")}</Step>
        <Step n={2}>{elakayAutoText("h_11aef98f47e624", "Cliquez la pill \"Categorie\" dans le canevas pour la sélectionner. Dans Mapping, vous verrez")}<code style={S.inlineCode}>repeatBind.path = "categories.categories"</code>.</Step>
        <Step n={3}>{elakayAutoText("h_1cb81c31e92aee", "Les catégories réelles de votre boutique s'affichent automatiquement en aperçu.")}</Step>
        <Step n={4} title={elakayAutoText("h_0c395fc468ce19", "Modifier l'action de filtre")}>{elakayAutoText("h_1f3cb09ac75930", "Le bouton \"Tout\" est lié à")}<code style={S.inlineCode}>loadProductsByArrival_</code>{elakayAutoText("h_ebf1dd0c6101ad", ". Chaque pill catégorie appelle automatiquement cette fonction avec l'ID de catégorie.")}</Step>
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_54ca2f01e2706e", "Étape 5 — Configurer la grille produits")}</h2>
        <Step n={1}>{elakayAutoText("h_4494ea1460ad4a", "La grille (section 5) contient un élément Panel avec")}<code style={S.inlineCode}>repeatBind.path = "products"</code>, <code style={S.inlineCode}>paginate: true</code>, <code style={S.inlineCode}>pageSize: 12</code>.</Step>
        <Step n={2}>{elakayAutoText("h_352a491b629dda", "Sélectionnez la carte produit (enfant de la grille) pour modifier son apparence : couleurs, rayon de bordure, taille de l'image.")}</Step>
        <Step n={3} title={elakayAutoText("h_488ba1e82f86ff", "Boutons pagination")}>{elakayAutoText("h_e7a43309b3a7a1", "Les boutons ← Previous et Next → sont liés aux fonctions")}<code style={S.inlineCode}>loadMore0</code>{elakayAutoText("h_a5bc1d9b2ae74e", "et")}<code style={S.inlineCode}>loadMore</code>.</Step>
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_960fa0a0b18ab4", "JSON complet de la structure")}</h2>
        <Code>{`{
  "pageMode": "store",
  "pages": [{
    "name": "Boutique Classique",
    "children": [
      // 1. Swiper lié à store.sliderShop
      { "type":"swiper", "bindSource":"store.sliderShop",
        "options":{ "autoplay":true, "interval":5000, "height":"400px" } },

      // 2. Header inline
      { "type":"section", "children":[
        { "type":"heading", "bindKey":"store.owner.shopName.0" },
        { "type":"stat", "bindKey":"store.siseProductAll" },
        { "type":"button", "text":"Explorer" }
      ]},

      // 3. Barre catégories
      { "type":"section", "children":[
        { "type":"row", "children":[
          { "type":"panel", "clickActionFunction":"loadProductsByArrival_",
            "children":[{ "type":"text", "text":"Tout" }] },
          { "type":"panel", "repeatBind":{ "source":"store",
            "path":"categories.categories" },
            "children":[{ "type":"text", "bindKey":"name.0" }] }
        ]}
      ]},

      // 4. shopCatMatrix vedettes
      { "type":"shopCatMatrix", "bindSource":"store.categories",
        "options":{ "title":"Produits en Vedette", "nbrArr":4 } },

      // 5. Grille produits + pagination
      { "type":"section", "children":[
        { "type":"grid", "options":{ "columns":4 },
          "children":[
            { "type":"panel",
              "repeatBind":{ "source":"store", "path":"products",
                "paginate":true, "pageSize":12 },
              "children":[
                { "type":"image", "bindKey":"galeriesID.galeries.0.urlImg.0" },
                { "type":"heading", "bindKey":"name" },
                { "type":"text", "bindKey":"price" }
              ]}
          ]},
        // Pagination
        { "type":"row", "children":[
          { "type":"button", "text":"← Previous",
            "clickActionFunction":"loadMore0" },
          { "type":"button", "text":"Next →",
            "clickActionFunction":"loadMore" }
        ]}
      ]}
    ]
  }]
}`}</Code>
      </div>
    </div>
  ),

  "tpl-premium": () => (
    <div>
      <SectionTitle icon="💎" title={elakayAutoText("h_e3e9c20e0bf319", "Template Boutique Premium — Guide")}
        sub="Boutique marine/or avec sidebar catégories et grille sombre." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_9482c5d5bfbed5", "Structure")}</h2>
        <p style={S.p}>{elakayAutoText("h_bd89d77098fcfb", "Le template Premium se distingue par :")}</p>
        <ul style={{ paddingLeft:"18px", margin:0 }}>
          <li style={{ fontSize:"13px", color:C.txt2, marginBottom:"4px" }}>{elakayAutoText("h_5483812cafadcf", "Swiper hero (440px) avec overlay marine")}</li>
          <li style={{ fontSize:"13px", color:C.txt2, marginBottom:"4px" }}>{elakayAutoText("h_88b02308a0ab3f", "Stat band doré (produits, qualité, note clients)")}</li>
          <li style={{ fontSize:"13px", color:C.txt2, marginBottom:"4px" }}>{elakayAutoText("h_07a10569c25e29", "Layout Row : sidebar catégories (200px) + grille 4 colonnes")}</li>
          <li style={{ fontSize:"13px", color:C.txt2, marginBottom:"4px" }}>{elakayAutoText("h_78fda900393878", "Cartes produits sur fond sombre (#1e293b)")}</li>
        </ul>
        <h2 style={S.h2}>{elakayAutoText("h_f54bd84d2ba08a", "Personnalisation clé")}</h2>
        <Step n={1} title={elakayAutoText("h_665383ddbe98ae", "Sidebar catégories")}>{elakayAutoText("h_33a3b0455819e4", "La sidebar utilise")}<code style={S.inlineCode}>catSidebar</code>{elakayAutoText("h_ebff3b85a4ee95", "— un Stack vertical lié à")}<code style={S.inlineCode}>store.categories.categories</code>{elakayAutoText("h_66f2f61a82c949", "via repeatBind.")}</Step>
        <Step n={2} title={elakayAutoText("h_eb97a78f988935", "Stat band")}>{elakayAutoText("h_2f94cca3d8adeb", "Les 3 statistiques de la stat band sont des éléments stat statiques. Modifiez les valeurs (value, label) dans Propriétés → Contenu.")}</Step>
        <Step n={3} title={elakayAutoText("h_0ffff90ccc907d", "Palette navy/gold")}>{elakayAutoText("h_ecadd9ebd68ad9", "Couleur principale :")}<code style={S.inlineCode}>#0f172a</code>{elakayAutoText("h_71a498798e34b7", "(navy) +")}<code style={S.inlineCode}>#d4af37</code>{elakayAutoText("h_31ea761b73adc8", "(gold). Modifiez dans le style de chaque section.")}</Step>
      </div>
    </div>
  ),

  "tpl-content": () => (
    <div>
      <SectionTitle icon="📄" title={elakayAutoText("h_8f1834b63a35e1", "Template Contenu Classique — Guide")}
        sub="Page de contenu blanc/violet avec sections empilées." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_dd5b6b818cd00c", "Mode de page requis : contentPage")}</h2>
        <Step n={1} title={elakayAutoText("h_1433fab539a04c", "Définir le mode")}>{elakayAutoText("h_324fa8f405db40", "Dans le panneau droite (aucun élément sélectionné), définissez le Mode de page sur")}<b>{elakayAutoText("h_010c8962b67de5", "Page de contenu (contentPage)")}</b>.</Step>
        <Step n={2} title={elakayAutoText("h_fa00b7c6649f35", "Charger les données")}>{elakayAutoText("h_a1a97e968385b1", "Dans Données → Source de données, choisissez une page de contenu (ex: \"About Us\", \"Become Seller…\").")}</Step>
        <Step n={3} title={elakayAutoText("h_e947d008cc4f00", "Structure auto")}>{elakayAutoText("h_87ecf0e587aa14", "La section centrale répète automatiquement pour chaque section de contenu (")}<code style={S.inlineCode}>contentPage.sections</code>).</Step>
        <h2 style={S.h2}>{elakayAutoText("h_1920e948743285", "Binding des sections")}</h2>
        <Code>{`// Bloc section répété (un par section du dataset)
{ "type":"panel",
  "repeatBind":{ "source":"contentPage", "path":"sections" },
  "children":[
    { "type":"heading", "bindKey":"title" },
    { "type":"text", "bindKey":"text.0" },
    { "type":"text", "bindKey":"text.1" },
    { "type":"image", "bindKey":"imagePath" }
  ]
}`}</Code>
        <Tip>{elakayAutoText("h_e7aa129113b1e7", "Le titre de la page (")}<code style={S.inlineCode}>contentPage.pageTitle</code>{elakayAutoText("h_add8605d42f314", ") est bindé sur l'élément heading du hero.")}</Tip>
      </div>
    </div>
  ),

  "tpl-invest": () => (
    <div>
      <SectionTitle icon="💰" title={elakayAutoText("h_a93db35a3975b1", "Template Investissement Pro — Guide")}
        sub="Page d'investissement marine/or avec plans tarifaires." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_1364d631bcf93c", "Mode de page requis : project")}</h2>
        <Step n={1} title={elakayAutoText("h_01cf653f466a25", "Définir le mode project")}>{elakayAutoText("h_ca973d8db26caf", "Dans le panneau droite, Mode de page → Projet / Investissement (project).")}</Step>
        <Step n={2} title={elakayAutoText("h_fa00b7c6649f35", "Charger les données")}>{elakayAutoText("h_f2405daaf0eff3", "Données → Source de données → Plan Pro Investissement (project).")}</Step>
        <Step n={3} title={elakayAutoText("h_5b0d9f38229d4e", "Plans tarifaires")}>{elakayAutoText("h_fb72fda81dd798", "Les 3 plans sont répétés via repeatBind sur")}<code style={S.inlineCode}>project.plans</code>{elakayAutoText("h_61679b6421f77a", ". Chaque plan affiche name, price, duration, returnRate, benefits.")}</Step>
        <h2 style={S.h2}>{elakayAutoText("h_fbdab4e511f8a5", "Structure des plans")}</h2>
        <Code>{`{ "type":"panel",
  "repeatBind":{ "source":"project", "path":"plans" },
  "children":[
    { "type":"heading", "bindKey":"name" },
    { "type":"heading", "bindKey":"price" },
    { "type":"text", "bindKey":"duration" },
    { "type":"text", "bindKey":"returnRate" },
    { "type":"text", "bindKey":"description" },
    { "type":"text", "bindKey":"benefits.0" },
    { "type":"text", "bindKey":"benefits.1" },
    { "type":"button", "text":"Investir" }
  ]
}`}</Code>
        <Tip>{elakayAutoText("h_e6841fa1d59de7", "Les stats, l'équipe et la FAQ utilisent le même mécanisme repeatBind sur")}<code style={S.inlineCode}>project.stats</code>, <code style={S.inlineCode}>project.team</code>, <code style={S.inlineCode}>project.faq</code>.</Tip>
      </div>
    </div>
  ),

  // ══════════════════════════════════════════════════════════════════════════════
  // GRILLE, MAPPING & PAGINATION
  // ══════════════════════════════════════════════════════════════════════════════

  "grid-base": () => {
    // Simulation visuelle des colonnes par device
    const GridPreview = ({ cols, label, color }) => (
      <div style={{ flex:1 }}>
        <div style={{ fontSize:"10px", fontWeight:700, color, textAlign:"center", marginBottom:"6px", textTransform:"uppercase", letterSpacing:"0.06em" }}>{label}</div>
        <div style={{ display:"grid", gridTemplateColumns:`repeat(${cols}, 1fr)`, gap:"4px" }}>
          {Array.from({length: Math.min(cols * 2, 8)}).map((_,i)=>(
            <div key={i} style={{ background:color, opacity:0.25+(i%2)*0.15, borderRadius:"4px", height:"32px" }} />
          ))}
        </div>
        <div style={{ textAlign:"center", fontSize:"11px", color, fontWeight:700, marginTop:"4px" }}>{cols} col{cols>1?"s":""}</div>
      </div>
    );
    return (
    <div>
      <SectionTitle icon="📐" title={elakayAutoText("h_990ab7e6e6850e", "Grille responsive — Pas à pas complet")}
        sub="Comment créer, configurer et lier une grille qui s'adapte à tous les écrans." />

      {/* ── CHEMIN À SUIVRE ─────────────────────────────────────────────────── */}
      <div style={{ ...S.card, borderLeft:`4px solid ${C.purple}` }}>
        <h2 style={S.h2}>{elakayAutoText("h_7978a38f65c345", "🗺️ Chemin à suivre dans l'interface")}</h2>
        <Step n={1} title={elakayAutoText("h_d62686179b09dd", "Ajouter l'élément Grille")}>{elakayAutoText("h_aa26a0e5136d7c", "Panneau gauche → onglet")}<b>{elakayAutoText("h_cf58c2334d4979", "Éléments")}</b>{elakayAutoText("h_a27ceca0e6a51f", "→ groupe")}<b>{elakayAutoText("h_f09e7eee2eefe8", "Mise en page")}</b>{elakayAutoText("h_0a585a6eb091cb", "→ cliquer")}<b>{elakayAutoText("h_25ee2ce6183c01", "Grille")}</b>{elakayAutoText("h_c31d71b8901483", ". La grille apparaît sur le canevas.")}</Step>
        <Step n={2} title={elakayAutoText("h_34ab8d921b30f9", "Sélectionner la grille")}>{elakayAutoText("h_6f9d673b126c74", "Cliquer la grille dans le canevas. Le panneau droite affiche ses propriétés.")}</Step>
        <Step n={3} title={elakayAutoText("h_25412925e28637", "Définir les colonnes globales")}>{elakayAutoText("h_5885f286b8aac8", "Panneau droite →")}<b>{elakayAutoText("h_74b8371d1d6c89", "Options de la grille")}</b> → <b>{elakayAutoText("h_99c28ceb930fb6", "Colonnes (défaut global)")}</b>{elakayAutoText("h_e3819d132d9efc", "→ choisir 4 dans le select.")}</Step>
        <Step n={4} title={elakayAutoText("h_2dc5f89d8a04cd", "Activer le responsive auto")}>{elakayAutoText("h_c08234377e6e7b", "Cliquer")}<b>{elakayAutoText("h_632c414f8fa038", "Responsive auto")}</b>{elakayAutoText("h_1af303c0f9592e", "(bouton gris à droite de \"Colonnes par device\"). Cela génère automatiquement mobile=1, tablet=2, laptop=3, desktop=4.")}</Step>
        <Step n={5} title={elakayAutoText("h_21c5590ab4b5e7", "Ajuster manuellement si besoin")}>{elakayAutoText("h_8d3a2618cff135", "Chaque ligne du tableau responsive affiche Device / Colonnes / Gap. Modifiez les valeurs selon votre design.")}</Step>
        <Step n={6} title={elakayAutoText("h_e61b1f70d4aae7", "Ajouter un enfant avec repeatBind")}>{elakayAutoText("h_fc724693f0e715", "Panneau gauche →")}<b>{elakayAutoText("h_cf58c2334d4979", "Éléments")}</b> → <b>{elakayAutoText("h_17f7d2e97463bf", "Panneau")}</b>{elakayAutoText("h_5e878aea619d6b", ". Le panneau s'ajoute dans la grille. Sélectionnez-le → Mapping →")}<b>{elakayAutoText("h_5a154a35a3c9d5", "Répétition de l'élément")}</b>{elakayAutoText("h_6bb61c769819be", "→ choisir source")}<code style={S.inlineCode}>store</code>{elakayAutoText("h_f3a3de9a27a573", ", chemin")}<code style={S.inlineCode}>products</code>.</Step>
        <Tip>{elakayAutoText("h_f97378f8abd309", "Le bouton")}<b>{elakayAutoText("h_632c414f8fa038", "Responsive auto")}</b>{elakayAutoText("h_c42680895e8a02", "dans le panneau droite est le moyen le plus rapide de configurer le deviceGrid — il calcule automatiquement les bons ratios.")}</Tip>
      </div>

      {/* ── APERÇU VISUEL BREAKPOINTS ──────────────────────────────────────── */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_17d0666e8c04b7", "Aperçu des breakpoints")}</h2>
        <div style={{ display:"flex", gap:"12px", marginBottom:"16px", flexWrap:"wrap" }}>
          <GridPreview cols={1} label={elakayAutoText("h_5f14dfb26c2986", "Mobile ≤480px")}   color="#ef4444" />
          <GridPreview cols={2} label={elakayAutoText("h_5252daa5e9e252", "Tablet 481–768px")} color="#f97316" />
          <GridPreview cols={3} label={elakayAutoText("h_da331cb66ca25c", "Laptop 769–1200px")} color="#6d28d9" />
          <GridPreview cols={4} label={elakayAutoText("h_c5c24f81786837", "Desktop >1200px")}  color="#059669" />
        </div>
        <div style={{ background:"#f0fdf4", border:"1px solid #a7f3d0", borderRadius:"8px", padding:"10px 14px", fontSize:"12px", color:"#065f46" }}>
          <strong>{elakayAutoText("h_9dbd1fc1b1a654", "Breakpoints exacts (media queries CSS)")}</strong><br/>{elakayAutoText("h_066ab0866f36d5", "📱 Mobile :")}<code style={S.inlineCode}>max-width: 480px</code><br/>{elakayAutoText("h_db9ba1606b57d6", "📟 Tablet :")}<code style={S.inlineCode}>min-width: 481px and max-width: 768px</code><br/>{elakayAutoText("h_89f2be831fd755", "💻 Laptop :")}<code style={S.inlineCode}>min-width: 769px and max-width: 1200px</code><br/>{elakayAutoText("h_e812f59bd73b18", "🖥️ Desktop :")}<code style={S.inlineCode}>min-width: 1201px</code>
        </div>
      </div>

      {/* ── JSON COMPLET ────────────────────────────────────────────────────── */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_fe7632a2198906", "JSON complet — Grille 4 colonnes responsive avec produits")}</h2>
        <Code>{`{
  "type": "grid",
  "options": {
    "columns": 4,                  /* défaut desktop si pas de deviceGrid */
    "deviceGrid": [
      { "device": "mobile",  "columns": 1, "gap": "12px" }, /* ≤480px */
      { "device": "tablet",  "columns": 2, "gap": "14px" }, /* 481–768px */
      { "device": "laptop",  "columns": 3, "gap": "16px" }, /* 769–1200px */
      { "device": "desktop", "columns": 4, "gap": "16px" }  /* >1200px */
    ]
  },
  "style": { "width": "100%" },
  "children": [
    {
      "type": "panel",
      "repeatBind": {
        "source": "store",
        "path": "products",
        "mode": "children",   /* les enfants sont le gabarit répété */
        "autoFill": true,     /* remplissage auto des champs */
        "paginate": true,     /* active la pagination */
        "pageSize": 12        /* 12 produits par page */
      },
      "style": {
        "background": "#ffffff",
        "borderRadius": "16px",
        "border": "1px solid #e5e7eb",
        "overflow": "hidden",
        "display": "flex",
        "flexDirection": "column",
        "boxShadow": "0 2px 10px rgba(0,0,0,0.07)"
      },
      "children": [
        {
          "type": "image",
          "bindKey": "galeriesID.galeries.0.urlImg.0",
          "src": "https://placehold.co/280x220/f3f4f6/9ca3af?text=Produit",
          "style": { "width":"100%","height":"200px","objectFit":"cover","display":"block" }
        },
        {
          "type": "stack",
          "style": { "padding":"12px 14px 14px","display":"flex",
            "flexDirection":"column","gap":"6px","flex":1 },
          "children": [
            {
              "type": "heading",
              "text": "Nom du produit",
              "bindKey": "name",
              "tag": "h3",
              "style": { "fontSize":"14px","fontWeight":600,"color":"#1a1a2e",
                "margin":0,"whiteSpace":"nowrap","overflow":"hidden",
                "textOverflow":"ellipsis","maxWidth":"100%" }
            },
            {
              "type": "row",
              "style": { "display":"flex","justifyContent":"space-between","alignItems":"center" },
              "children": [
                { "type":"text","text":"Prix","bindKey":"price","tag":"p",
                  "style":{ "fontSize":"16px","fontWeight":800,"color":"#6d28d9","margin":0 }},
                { "type":"button","text":"+",
                  "clickActionType":"function","clickActionFunction":"addToCart",
                  "style":{ "width":"32px","height":"32px","borderRadius":"50%",
                    "background":"#6d28d9","color":"#fff","border":"none",
                    "fontSize":"20px","cursor":"pointer","display":"flex",
                    "alignItems":"center","justifyContent":"center","padding":0 }}
              ]
            }
          ]
        }
      ]
    }
  ]
}`}</Code>
      </div>

      {/* ── GRILLE 2 COLONNES (EDITORIAL) ──────────────────────────────────── */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_1aea46f4e8ff22", "Layout éditorial 2 colonnes (texte + image)")}</h2>
        <p style={S.p}>{elakayAutoText("h_a61939c289dc1d", "Pour alterner texte et image côte à côte, utilisez une")}<code style={S.inlineCode}>row</code>{elakayAutoText("h_84c87a11e6df5a", "avec")}<code style={S.inlineCode}>flexWrap: wrap</code>{elakayAutoText("h_8ee167b2bf9fa8", "pour que les colonnes passent l'une sous l'autre sur mobile :")}</p>
        <Code>{`{
  "type": "row",
  "style": {
    "display": "flex",
    "gap": "40px",
    "alignItems": "center",
    "padding": "48px",
    "flexWrap": "wrap"           /* sur mobile : les enfants s'empilent */
  },
  "children": [
    {
      "type": "stack",
      "style": { "flex":1,"minWidth":"280px","display":"flex",
        "flexDirection":"column","gap":"12px" },
      "children": [
        { "type":"heading","text":"Titre section","bindKey":"title","tag":"h2",
          "style":{ "fontSize":"26px","fontWeight":800,"color":"#111827","margin":0 }},
        { "type":"text","text":"Texte...","bindKey":"text.0","tag":"p",
          "style":{ "fontSize":"15px","color":"#6b7280","lineHeight":1.7,"margin":0 }},
        { "type":"button","text":"En savoir plus →",
          "style":{ "padding":"10px 22px","background":"#6d28d9","color":"#fff",
            "border":"none","borderRadius":"8px","cursor":"pointer",
            "alignSelf":"flex-start","fontSize":"14px","fontWeight":600 }}
      ]
    },
    {
      "type": "image",
      "bindKey": "imagePath",
      "src": "https://placehold.co/520x360/f3f4f6/9ca3af?text=Image",
      "style": {
        "width": "44%",
        "minWidth": "280px",        /* sur mobile : prend 100% */
        "maxHeight": "360px",
        "objectFit": "cover",
        "borderRadius": "16px",
        "flexShrink": 0,
        "display": "block"
      }
    }
  ]
}`}</Code>
        <div style={{ background:"#fef3c7", border:"1px solid #fcd34d", borderRadius:"8px", padding:"10px 14px", fontSize:"12px", color:"#92400e", marginTop:"10px" }}>
          <strong>{elakayAutoText("h_cfbbf19e0316e3", "Résultat responsive :")}</strong><br/>{elakayAutoText("h_e2b0870b29c01c", "🖥️ Desktop/Laptop : image et texte côte à côte")}<br/>{elakayAutoText("h_c898b3e3b50672", "📱 Mobile/Tablet : texte puis image empilés verticalement (grâce à flexWrap:wrap + minWidth:280px)")}</div>
      </div>
    </div>
  );},

  "grid-pagine": () => (
    <div>
      <SectionTitle icon="⏩" title={elakayAutoText("h_8e417b53514e6c", "Mapping & Pagination — Pas à pas")}
        sub="Lier une grille aux données et naviguer entre les pages de résultats." />

      {/* ── CHEMIN MAPPING ────────────────────────────────────────────────── */}
      <div style={{ ...S.card, borderLeft:`4px solid ${C.green}` }}>
        <h2 style={S.h2}>{elakayAutoText("h_944a6e470b6f06", "🗺️ Chemin pour activer le mapping (repeatBind)")}</h2>
        <Step n={1} title={elakayAutoText("h_00779a5058ed95", "Sélectionner l'élément gabarit")}>{elakayAutoText("h_1e1e4a8d45bdc7", "Dans le canevas, cliquer sur la")}<b>{elakayAutoText("h_3980dd312695ec", "carte produit")}</b>{elakayAutoText("h_49577c03ac6d16", "(le panel enfant de la grille), pas la grille elle-même.")}</Step>
        <Step n={2} title={elakayAutoText("h_c0337283d41671", "Ouvrir l'onglet Mapping")}>{elakayAutoText("h_cf5c8e3b318f20", "Panneau droite → cliquer l'onglet")}<b>{elakayAutoText("h_def2eba5956295", "Mapping")}</b>{elakayAutoText("h_018e63d7a63699", "(à côté de Général).")}</Step>
        <Step n={3} title={elakayAutoText("h_5a154a35a3c9d5", "Répétition de l'élément")}>{elakayAutoText("h_d69cecde8d4705", "Dans la section")}<b>{elakayAutoText("h_5a154a35a3c9d5", "Répétition de l'élément")}</b>{elakayAutoText("h_00bccfa2021ab7", "→ choisir")}<b>{elakayAutoText("h_6da13addb000b6", "Source")}</b> : <code style={S.inlineCode}>store</code> → <b>{elakayAutoText("h_292b645c539e9f", "Chemin")}</b> : <code style={S.inlineCode}>products</code>.</Step>
        <Step n={4} title={elakayAutoText("h_1fb61cf395272a", "Activer la pagination")}>{elakayAutoText("h_158c11bfb5a0a6", "Cocher")}<b>{elakayAutoText("h_f0037512cff83a", "Avec pagination")}</b>{elakayAutoText("h_329fc2e4d91e91", "→ définir")}<b>{elakayAutoText("h_09347b9364de10", "Taille de page")}</b> : 12.</Step>
        <Step n={5} title={elakayAutoText("h_771aa5fe357c5d", "Activer AutoFill")}>{elakayAutoText("h_158c11bfb5a0a6", "Cocher")}<b>{elakayAutoText("h_d037d239ba3a26", "Remplissage auto")}</b>{elakayAutoText("h_13a71d71a34b43", "pour que les champs des enfants se lient automatiquement aux champs de chaque produit.")}</Step>
        <Step n={6} title={elakayAutoText("h_84ef3732a8af7f", "Vérifier l'aperçu")}>{elakayAutoText("h_a5e7b786307424", "Les produits réels apparaissent dans le canevas. Chaque cellule montre un produit différent.")}</Step>
        <Tip>{elakayAutoText("h_9c38b950bffa00", "Si les données n'apparaissent pas, vérifiez que vous avez chargé un dataset dans")}<b>{elakayAutoText("h_7d84adbe104167", "Données → Source de données")}</b>{elakayAutoText("h_9132307de49f64", "et que le mode de page est")}<b>{elakayAutoText("h_ae64243512289a", "Boutique (store)")}</b>.</Tip>
      </div>

      {/* ── CHEMIN PAGINATION ─────────────────────────────────────────────── */}
      <div style={{ ...S.card, borderLeft:`4px solid ${C.orange}` }}>
        <h2 style={S.h2}>{elakayAutoText("h_97db57eda6e687", "🗺️ Chemin pour ajouter les boutons pagination")}</h2>
        <Step n={1} title={elakayAutoText("h_4d0143fbbf0a1d", "Méthode rapide — Élément Live")}>{elakayAutoText("h_aa26a0e5136d7c", "Panneau gauche → onglet")}<b>{elakayAutoText("h_0e5c3295afc311", "Live ⚡")}</b>{elakayAutoText("h_0a585a6eb091cb", "→ cliquer")}<b>{elakayAutoText("h_dab4355704781b", "Pagination (← / →)")}</b>{elakayAutoText("h_82379541de694c", ". Il se place automatiquement et se sync avec la grille.")}</Step>
        <Step n={2} title={elakayAutoText("h_b87ace5a31323d", "Méthode manuelle — 2 Boutons")}>{elakayAutoText("h_8fecbfad327efd", "Ajouter un élément")}<b>{elakayAutoText("h_36baa5fac1553f", "Ligne (Row)")}</b>{elakayAutoText("h_4afaea87733042", "sous la grille → ajouter 2")}<b>{elakayAutoText("h_10263c64bdf56e", "Boutons")}</b>{elakayAutoText("h_2fd01fff61676b", "dedans → sélectionner chaque bouton →")}<b>{elakayAutoText("h_7db38605b27390", "Propriétés → Action Au Clic → Type : Fonction shopUser")}</b>{elakayAutoText("h_00bccfa2021ab7", "→ choisir")}<code style={S.inlineCode}>loadMore0</code>{elakayAutoText("h_fe6083f4cb77f4", "(précédent) et")}<code style={S.inlineCode}>loadMore</code>{elakayAutoText("h_af91915362fd9c", "(suivant).")}</Step>
        <Tip>{elakayAutoText("h_c7bddcb5a41543", "Préférez l'élément")}<b>{elakayAutoText("h_100325b8d6de92", "Pagination")}</b>{elakayAutoText("h_91bdccfed77189", "du Live ⚡ — il gère automatiquement l'état (désactive les boutons quand il n'y a plus de pages).")}</Tip>
      </div>

      {/* ── APERÇU VISUEL ─────────────────────────────────────────────────── */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_7f17748d9e19bd", "Résultat visuel — Grille + pagination")}</h2>
        {/* Mini grille simulée */}
        <div style={{ background:"#f9fafb", borderRadius:"10px", padding:"16px" }}>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:"8px", marginBottom:"12px" }}>
            {["Produit 1","Produit 2","Produit 3","Produit 4","Produit 5","Produit 6","Produit 7","Produit 8"].map((p,i)=>(
              <div key={i} style={{ background:"#fff", borderRadius:"8px", border:"1px solid #e5e7eb", overflow:"hidden" }}>
                <div style={{ height:"60px", background:`hsl(${220+i*15},60%,90%)`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"9px", color:"#6b7280" }}>{elakayAutoText("h_978ea7af39ad5f", "img")}</div>
                <div style={{ padding:"6px 8px" }}>
                  <div style={{ fontSize:"10px", fontWeight:600, color:"#1a1a2e", marginBottom:"3px" }}>{p}</div>
                  <div style={{ fontSize:"11px", fontWeight:800, color:"#6d28d9" }}>$25</div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <span style={{ padding:"6px 16px", background:"#6d28d9", color:"#fff", borderRadius:"8px", fontSize:"11px", fontWeight:600, cursor:"pointer" }}>{elakayAutoText("h_3ec988c1b0f8a6", "← Précédent")}</span>
            <span style={{ fontSize:"11px", color:"#9b93b8" }}>{elakayAutoText("h_9a893d49ca60b3", "Page 1 sur 3 · 28 produits")}</span>
            <span style={{ padding:"6px 16px", background:"#6d28d9", color:"#fff", borderRadius:"8px", fontSize:"11px", fontWeight:600, cursor:"pointer" }}>{elakayAutoText("h_ea96c11e6b8fef", "Suivant →")}</span>
          </div>
        </div>
      </div>

      {/* ── JSON COMPLET ──────────────────────────────────────────────────── */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_2a3ebc19ca6a2b", "JSON complet — repeatBind avec pagination")}</h2>
        <Code>{`/* ① L'élément gabarit (carte produit) avec repeatBind */
{
  "type": "panel",
  "repeatBind": {
    "source": "store",          /* ← clé du dataset chargé */
    "path": "products",          /* ← chemin dans les données */
    "mode": "children",          /* les enfants = gabarit répété */
    "autoFill": true,            /* lie automatiquement les champs */
    "paginate": true,            /* ← activer la pagination */
    "pageSize": 12               /* ← éléments par page */
  },
  "style": { "background":"#fff","borderRadius":"16px",
    "border":"1px solid #e5e7eb","overflow":"hidden",
    "display":"flex","flexDirection":"column" },
  "children": [
    { "type":"image","bindKey":"galeriesID.galeries.0.urlImg.0",
      "style":{"width":"100%","height":"200px","objectFit":"cover"} },
    { "type":"stack","style":{"padding":"12px 14px","gap":"6px"},
      "children":[
        { "type":"heading","bindKey":"name","tag":"h3",
          "style":{"fontSize":"14px","fontWeight":600,"color":"#1a1a2e","margin":0} },
        { "type":"text","bindKey":"price","tag":"p",
          "style":{"fontSize":"16px","fontWeight":800,"color":"#6d28d9","margin":0} }
      ]}
  ]
}

/* ② Boutons pagination manuels (ou utiliser shopButtonPagination) */
{
  "type": "row",
  "style": { "display":"flex","justifyContent":"space-between",
    "alignItems":"center","padding":"20px 0 0" },
  "children": [
    {
      "type": "button",
      "text": "← Précédent",
      "clickActionType": "function",
      "clickActionFunction": "loadMore0",
      "style": { "padding":"8px 22px","background":"#6d28d9","color":"#fff",
        "border":"none","borderRadius":"8px","cursor":"pointer",
        "fontSize":"13px","fontWeight":600 }
    },
    {
      "type": "button",
      "text": "Suivant →",
      "clickActionType": "function",
      "clickActionFunction": "loadMore",
      "style": { "padding":"8px 22px","background":"#6d28d9","color":"#fff",
        "border":"none","borderRadius":"8px","cursor":"pointer",
        "fontSize":"13px","fontWeight":600 }
    }
  ]
}

/* ③ OU utiliser l'élément Live dédié (recommandé) */
{ "type": "shopButtonPagination",
  "style": { "padding":"16px 32px","display":"flex","justifyContent":"space-between" }
}

/* ④ Compteur de produits (affiche le total) */
{
  "type": "stat",
  "bindKey": "store.siseProductAll",
  "content": { "value":"28","label":"produits",
    "valueColor":"#6d28d9","labelColor":"#9b93b8" },
  "style": { "padding":"6px 14px","background":"#f5f3ff",
    "borderRadius":"50px","border":"1px solid #e4dcfb","display":"inline-block" }
}`}</Code>
      </div>

      <h2 style={S.h2}>{elakayAutoText("h_65b18adb6c17e8", "Afficher le compteur de produits")}</h2>
        <Code>{`{ "type": "stat",
  "bindKey": "store.siseProductAll",
  "content": { "value":"28","label":"produits",
    "valueColor":"#6d28d9","labelColor":"#9b93b8" },
  "style":{ "padding":"6px 14px","background":"#f5f3ff",
    "borderRadius":"50px","border":"1px solid #e4dcfb",
    "display":"inline-block" }
}`}</Code>
      </div>
  ),

  "grid-field": () => (
    <div>
      <SectionTitle icon="🗺️" title={elakayAutoText("h_c38da9c071acb2", "Mapping des champs (fieldMap)")}
        sub="Mappez manuellement des clés de données sur des enfants précis." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_02f458eed55c62", "Quand utiliser fieldMap ?")}</h2>
        <p style={S.p}>{elakayAutoText("h_e5f1e183d835c4", "Quand")}<code style={S.inlineCode}>autoFill: true</code>{elakayAutoText("h_bf181d9f3c46f8", "ne trouve pas automatiquement les bons champs (noms non standards, structures imbriquées), utilisez")}<code style={S.inlineCode}>fieldMap</code>{elakayAutoText("h_04c3140aecc94c", "pour lier manuellement chaque champ.")}</p>
        <Code>{`"repeatBind": {
  "source": "store",
  "path": "products",
  "mode": "children",
  "autoFill": false,    // ← désactivé
  "fieldMap": {
    // "id-de-l-enfant": "chemin.dans.item"
    "elem-image-id":   "galeriesID.galeries.0.urlImg.0",
    "elem-title-id":   "name",
    "elem-price-id":   "price",
    "elem-stars-id":   "Stars",
    "elem-badge-id":   "salePrice"
  }
}`}</Code>
        <h2 style={S.h2}>{elakayAutoText("h_777fdd409dc7f7", "Trouver les IDs des enfants")}</h2>
        <p style={S.p}>{elakayAutoText("h_d898c9cc449b36", "L'ID de chaque élément est visible dans :")}</p>
        <ul style={{ paddingLeft:"18px", margin:"0 0 10px" }}>
          <li style={{ fontSize:"13px", color:C.txt2, marginBottom:"3px" }}>{elakayAutoText("h_2aad6c7c998f56", "L'onglet JSON de l'élément sélectionné (champ")}<code style={S.inlineCode}>"id"</code>)</li>
          <li style={{ fontSize:"13px", color:C.txt2, marginBottom:"3px" }}>{elakayAutoText("h_68534504eef748", "Le panneau Données → Section sélectionnée en haut (JSON de l'élément)")}</li>
          <li style={{ fontSize:"13px", color:C.txt2 }}>{elakayAutoText("h_dbd2575706a710", "La section \"Élément sélectionné\" dans Données → API ShopUser")}</li>
        </ul>
        <Tip>{elakayAutoText("h_5d74f6411ee2f0", "Préférez")}<code style={S.inlineCode}>autoFill: true</code>{elakayAutoText("h_cd3f85a6673702", "— le moteur de remplissage auto reconnaît les noms courants (name, title, image, price, url…) et les mappe sans configuration.")}</Tip>
      </div>
    </div>
  ),

  // ══════════════════════════════════════════════════════════════════════════════
  // CARTES PORTRAIT & PAYSAGE
  // ══════════════════════════════════════════════════════════════════════════════

  "card-portrait": () => (
    <div>
      <SectionTitle icon="🃏" title={elakayAutoText("h_ff2343cc07ceb1", "Carte Portrait (verticale)")}
        sub="Image en haut, contenu en bas — format standard de carte produit." />

      {/* ── CHEMIN ──────────────────────────────────────────────────────── */}
      <div style={{ ...S.card, borderLeft:`4px solid ${C.purple}` }}>
        <h2 style={S.h2}>{elakayAutoText("h_bdd7a0d0bf0977", "🗺️ Chemin pour créer une carte portrait")}</h2>
        <Step n={1} title={elakayAutoText("h_987b0c9cc18b7f", "Ajouter un Panneau")}>{elakayAutoText("h_fc724693f0e715", "Panneau gauche →")}<b>{elakayAutoText("h_cf58c2334d4979", "Éléments")}</b> → <b>{elakayAutoText("h_f09e7eee2eefe8", "Mise en page")}</b> → <b>{elakayAutoText("h_17f7d2e97463bf", "Panneau")}</b>{elakayAutoText("h_5a2ac1a164cc41", ". La panneau apparaît sur le canevas.")}</Step>
        <Step n={2} title={elakayAutoText("h_78d14d8ca0adb2", "Définir le style flexDirection column")}>{elakayAutoText("h_3d18b79508a960", "Sélectionner le panneau → Panneau droite →")}<b>{elakayAutoText("h_5376df989fac86", "Général")}</b> → <b>{elakayAutoText("h_f09e7eee2eefe8", "Mise en page")}</b> → <b>{elakayAutoText("h_c40d127cd6d62f", "display: flex")}</b>, <b>{elakayAutoText("h_e263a1fade28cc", "flexDirection: column")}</b>{elakayAutoText("h_76e8800ab75779", ". Ajouter")}<code style={S.inlineCode}>overflow: hidden</code>, <code style={S.inlineCode}>borderRadius: 16px</code>.</Step>
        <Step n={3} title={elakayAutoText("h_91cba04afb7ebf", "Ajouter l'image")}>{elakayAutoText("h_106f635585fbf6", "Dans le panneau droite →")}<b>{elakayAutoText("h_5795e9757067b7", "Ajouter un élément à l'intérieur")}</b> → <b>{elakayAutoText("h_50e19fda0d5b4b", "Image")}</b>{elakayAutoText("h_6af914922b439d", ". Sélectionner l'image → style :")}<code style={S.inlineCode}>height: 200px</code>, <code style={S.inlineCode}>objectFit: cover</code>{elakayAutoText("h_b9fb49014bb8ce", ". Dans Mapping → bindKey :")}<code style={S.inlineCode}>galeriesID.galeries.0.urlImg.0</code>.</Step>
        <Step n={4} title={elakayAutoText("h_e837b9463c2014", "Ajouter le contenu texte")}>{elakayAutoText("h_edef806ef1184c", "Ajouter un")}<b>{elakayAutoText("h_83e5a0d3d2ef19", "Stack")}</b>{elakayAutoText("h_2c97f1c84f0a88", "sous l'image → dans le Stack, ajouter un")}<b>{elakayAutoText("h_eb97899aedcd56", "Titre")}</b>{elakayAutoText("h_2c6ee71c9e1b19", "(bindKey: name) et un")}<b>{elakayAutoText("h_ff9afef1eae0a9", "Texte")}</b>{elakayAutoText("h_f0a3f6946bd0ea", "(bindKey: price). Styliser avec padding, gap.")}</Step>
        <Step n={5} title={elakayAutoText("h_395094c2c4b019", "Lier aux données (repeatBind)")}>{elakayAutoText("h_2ffcd9867f708b", "Sélectionner la carte (panel) → Mapping →")}<b>{elakayAutoText("h_5a154a35a3c9d5", "Répétition de l'élément")}</b>{elakayAutoText("h_c5312993f1a43e", "→ source: store, chemin: products, paginate: true, pageSize: 12.")}</Step>
        <Step n={6} title={elakayAutoText("h_70279666ef70e7", "Placer dans une grille")}>{elakayAutoText("h_59a85b9ecf4051", "Sélectionner la grille parente → choisir 4 colonnes → cliquer")}<b>{elakayAutoText("h_632c414f8fa038", "Responsive auto")}</b>{elakayAutoText("h_32998b8361ca40", "pour le deviceGrid.")}</Step>
      </div>

      {/* ── APERÇU VISUEL ────────────────────────────────────────────────── */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_cc14771321a519", "Aperçu du résultat")}</h2>
        <div style={{ display:"flex", gap:"12px", flexWrap:"wrap" }}>
          {[1,2,3,4].map(i=>(
            <div key={i} style={{ width:"140px", background:"#fff", borderRadius:"12px", border:"1px solid #e5e7eb", overflow:"hidden", boxShadow:"0 2px 8px rgba(0,0,0,0.07)", flexShrink:0 }}>
              <div style={{ height:"100px", background:`hsl(${220+i*20},55%,88%)`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"10px", color:"#6b7280" }}>{elakayAutoText("h_3f9a22ef6aa1bd", "📷 image")}</div>
              <div style={{ padding:"10px 12px" }}>
                <div style={{ fontSize:"11px", fontWeight:600, color:"#1a1a2e", marginBottom:"4px", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{elakayAutoText("h_99bc1441961b7a", "Nom du produit")}{i}</div>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <span style={{ fontSize:"13px", fontWeight:800, color:"#6d28d9" }}>${20+i*5}</span>
                  <span style={{ width:"24px", height:"24px", background:"#6d28d9", color:"#fff", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"14px", cursor:"pointer" }}>+</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <p style={{ ...S.p, marginTop:"10px", fontSize:"12px", color:C.txt3 }}>{elakayAutoText("h_e64639e412819e", "flexDirection:")}<strong>{elakayAutoText("h_aa60230ab00282", "column")}</strong>{elakayAutoText("h_6e6c4a921d41a9", "→ image EN HAUT · contenu EN BAS")}</p>
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_0ec2fb9245b524", "Structure JSON")}</h2>
        <p style={S.p}>{elakayAutoText("h_a98e4704e17220", "La carte portrait empile l'image et le contenu verticalement (flexDirection: column). C'est le format le plus courant pour les grilles produits.")}</p>
        <Code>{`{
  "type": "panel",
  "repeatBind": { "source":"store","path":"products","mode":"children","autoFill":true },
  "style": {
    "background": "#ffffff",
    "borderRadius": "16px",
    "border": "1px solid #e5e7eb",
    "overflow": "hidden",
    "display": "flex",
    "flexDirection": "column",   /* ← colonne = portrait */
    "boxShadow": "0 2px 10px rgba(0,0,0,0.07)"
  },
  "children": [
    {
      "type": "image",
      "bindKey": "galeriesID.galeries.0.urlImg.0",
      "src": "https://placehold.co/280x220/f3f4f6/9ca3af?text=Produit",
      "style": {
        "width": "100%",
        "height": "200px",
        "objectFit": "cover",
        "display": "block",
        "flexShrink": 0
      }
    },
    {
      "type": "stack",
      "style": {
        "padding": "14px 16px 16px",
        "display": "flex",
        "flexDirection": "column",
        "gap": "8px",
        "flex": 1
      },
      "children": [
        {
          "type": "heading",
          "text": "Nom du produit",
          "bindKey": "name",
          "tag": "h3",
          "style": {
            "fontSize": "14px", "fontWeight": 600, "color": "#111827",
            "margin": 0, "whiteSpace": "nowrap",
            "overflow": "hidden", "textOverflow": "ellipsis"
          }
        },
        {
          "type": "row",
          "style": { "display":"flex","justifyContent":"space-between","alignItems":"center" },
          "children": [
            { "type":"text", "text":"Prix", "bindKey":"price",
              "style":{ "fontSize":"18px","fontWeight":800,"color":"#6d28d9","margin":0 }},
            { "type":"button", "text":"+ Panier",
              "clickActionType":"function","clickActionFunction":"addToCart",
              "style":{ "padding":"6px 14px","background":"#6d28d9","color":"#fff",
                "border":"none","borderRadius":"8px","cursor":"pointer","fontSize":"12px" }}
          ]
        }
      ]
    }
  ]
}`}</Code>
        <Tip>{elakayAutoText("h_7e4cbb12ebb9f9", "Ajoutez un badge remise (")}<code style={S.inlineCode}>bindKey: "salePrice"</code>{elakayAutoText("h_41ee80157a388c", ") positionné en")}<code style={S.inlineCode}>position: absolute</code>{elakayAutoText("h_2a01795fb758e3", "sur l'image pour les promotions.")}</Tip>
      </div>
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_ece1aa67a5e870", "Variante — Carte portrait avec étoiles")}</h2>
        <Code>{`// Dans le stack, entre le titre et le prix :
{
  "type": "rating",
  "content": { "value":4,"max":5,"color":"#f59e0b","label":"" },
  "bindKey": "Stars",
  "style": { "display":"flex","alignItems":"center","gap":"4px" }
}`}</Code>
      </div>
    </div>
  ),

  "card-landscape": () => (
    <div>
      <SectionTitle icon="🖼️" title={elakayAutoText("h_94bc86de09dbca", "Carte Paysage (horizontale)")}
        sub="Image à gauche, contenu à droite — format éditorial / magazine." />

      {/* ── CHEMIN ──────────────────────────────────────────────────────── */}
      <div style={{ ...S.card, borderLeft:`4px solid ${C.orange}` }}>
        <h2 style={S.h2}>{elakayAutoText("h_f729c132eedced", "🗺️ Différence clé avec la carte Portrait")}</h2>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"16px" }}>
          <div style={{ background:"#f3effe", borderRadius:"8px", padding:"12px" }}>
            <div style={{ fontSize:"12px", fontWeight:700, color:C.purple, marginBottom:"6px" }}>{elakayAutoText("h_92b6b1bf71e0c0", "Portrait")}</div>
            <div style={{ background:"#e8d5fb", borderRadius:"6px", height:"60px", marginBottom:"6px", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"10px", color:"#6d28d9" }}>{elakayAutoText("h_02312f83fdcb10", "📷 image (100%)")}</div>
            <div style={{ fontSize:"10px", color:C.txt2, lineHeight:1.5 }}>{elakayAutoText("h_8d406e3d12cd24", "nom")}<br/>{elakayAutoText("h_88809b53901e1b", "prix + bouton")}</div>
            <code style={{ ...S.inlineCode, display:"block", marginTop:"6px", fontSize:"10px" }}>flexDirection: column</code>
          </div>
          <div style={{ background:"#fff7ed", borderRadius:"8px", padding:"12px" }}>
            <div style={{ fontSize:"12px", fontWeight:700, color:C.orange, marginBottom:"6px" }}>{elakayAutoText("h_7eaf86815a8a9d", "Paysage")}</div>
            <div style={{ display:"flex", gap:"6px", alignItems:"stretch" }}>
              <div style={{ background:"#fed7aa", borderRadius:"6px", width:"56px", flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"10px", color:C.orange }}>📷</div>
              <div style={{ flex:1, fontSize:"10px", color:C.txt2, lineHeight:1.7 }}>{elakayAutoText("h_8b6a312f13dd3c", "titre")}<br/>{elakayAutoText("h_cb329146a0dd0d", "description")}<br/>{elakayAutoText("h_ca892402e2bf99", "prix · bouton")}</div>
            </div>
            <code style={{ ...S.inlineCode, display:"block", marginTop:"6px", fontSize:"10px" }}>flexDirection: row</code>
          </div>
        </div>
        <h2 style={{ ...S.h2, marginTop:"16px" }}>{elakayAutoText("h_7771a176305d72", "🗺️ Chemin pour créer une carte paysage")}</h2>
        <Step n={1} title={elakayAutoText("h_987b0c9cc18b7f", "Ajouter un Panneau")}>{elakayAutoText("h_8e836f0c92b9e3", "Panneau gauche → Éléments → Mise en page →")}<b>{elakayAutoText("h_17f7d2e97463bf", "Panneau")}</b>.</Step>
        <Step n={2} title={elakayAutoText("h_fb4b63f7efc78c", "Changer flexDirection en row")}>{elakayAutoText("h_f71738bc065f3a", "Panneau droite → Général → Mise en page →")}<b>{elakayAutoText("h_a34ae1f05b4d1e", "flexDirection: row")}</b>{elakayAutoText("h_6eded8d4f5cddf", "(au lieu de column).")}</Step>
        <Step n={3} title={elakayAutoText("h_8d14bb311587aa", "Ajouter l'image à GAUCHE")}>{elakayAutoText("h_cea159c3c01b74", "Ajouter un élément à l'intérieur →")}<b>{elakayAutoText("h_50e19fda0d5b4b", "Image")}</b>{elakayAutoText("h_d57032602d28bf", ". Style :")}<code style={S.inlineCode}>width: 200px</code>, <code style={S.inlineCode}>flexShrink: 0</code>, <code style={S.inlineCode}>objectFit: cover</code>, <code style={S.inlineCode}>minHeight: 140px</code>{elakayAutoText("h_cd2e0735a7a262", ". bindKey → imagePath.")}</Step>
        <Step n={4} title={elakayAutoText("h_e8fd85bf9d3372", "Ajouter le Stack à DROITE")}>{elakayAutoText("h_4cd69134e740b8", "Ajouter un élément →")}<b>{elakayAutoText("h_83e5a0d3d2ef19", "Stack")}</b>{elakayAutoText("h_d57032602d28bf", ". Style :")}<code style={S.inlineCode}>flex: 1</code>, <code style={S.inlineCode}>padding: 20px 24px</code>{elakayAutoText("h_b508e74fdfd50c", ". Ajouter Titre (bindKey: title/name), Texte (bindKey: text.0/description), Bouton.")}</Step>
        <Step n={5} title={elakayAutoText("h_92e5cfa6d416f8", "repeatBind sur la carte")}>{elakayAutoText("h_eef9b8510c74f5", "Sélectionner la carte → Mapping → Répétition → source: store ou contentPage, chemin: products ou sections.")}</Step>
      </div>

      {/* ── APERÇU VISUEL ────────────────────────────────────────────────── */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_cc14771321a519", "Aperçu du résultat")}</h2>
        <div style={{ display:"flex", flexDirection:"column", gap:"10px" }}>
          {[["Polo Shirts en coton — Collection été","Collection mode","$45"],
            ["Daphn Laptop 13\" Core i7","Électronique","$700"],
            ["Bluetooth Earbuds Pro","Accessoires","$58"]].map(([nom,cat,prix],i)=>(
            <div key={i} style={{ display:"flex", gap:0, background:"#fff", borderRadius:"10px", border:"1px solid #e5e7eb", overflow:"hidden", boxShadow:"0 2px 6px rgba(0,0,0,0.05)" }}>
              <div style={{ width:"120px", flexShrink:0, background:`hsl(${210+i*25},50%,88%)`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"20px" }}>📷</div>
              <div style={{ flex:1, padding:"14px 18px", display:"flex", flexDirection:"column", gap:"5px", justifyContent:"center" }}>
                <div style={{ fontSize:"13px", fontWeight:700, color:"#111827" }}>{nom}</div>
                <div style={{ fontSize:"10px", color:"#9ca3af" }}>{cat}</div>
                <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
                  <span style={{ fontSize:"16px", fontWeight:800, color:"#6d28d9" }}>{prix}</span>
                  <span style={{ padding:"5px 14px", background:"#f5f3ff", color:"#6d28d9", border:"1px solid #e4dcfb", borderRadius:"6px", fontSize:"11px", fontWeight:600, cursor:"pointer" }}>{elakayAutoText("h_c63bee19332f96", "Voir →")}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <p style={{ ...S.p, marginTop:"10px", fontSize:"12px", color:C.txt3 }}>{elakayAutoText("h_e64639e412819e", "flexDirection:")}<strong>row</strong>{elakayAutoText("h_9f3b783e0cc4d4", "→ image À GAUCHE · contenu À DROITE")}</p>
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_0ec2fb9245b524", "Structure JSON")}</h2>
        <p style={S.p}>{elakayAutoText("h_b661175ec0e335", "La carte paysage place image et contenu côte à côte (flexDirection: row). Idéale pour les listes (search results, page de contenu magazine).")}</p>
        <Code>{`{
  "type": "panel",
  "repeatBind": { "source":"store","path":"products","mode":"children","autoFill":true },
  "style": {
    "background": "#ffffff",
    "borderRadius": "12px",
    "border": "1px solid #e5e7eb",
    "overflow": "hidden",
    "display": "flex",
    "flexDirection": "row",    /* ← ligne = paysage */
    "boxShadow": "0 2px 8px rgba(0,0,0,0.06)",
    "marginBottom": "12px"
  },
  "children": [
    {
      "type": "image",
      "bindKey": "galeriesID.galeries.0.urlImg.0",
      "src": "https://placehold.co/200x160/f3f4f6/9ca3af?text=",
      "style": {
        "width": "200px",
        "flexShrink": 0,
        "objectFit": "cover",
        "display": "block",
        "minHeight": "140px"
      }
    },
    {
      "type": "stack",
      "style": {
        "flex": 1,
        "padding": "20px 24px",
        "display": "flex",
        "flexDirection": "column",
        "gap": "8px",
        "justifyContent": "center"
      },
      "children": [
        { "type":"heading","bindKey":"name","tag":"h3",
          "style":{ "fontSize":"16px","fontWeight":700,"color":"#111827","margin":0 }},
        { "type":"text","bindKey":"description","tag":"p",
          "style":{ "fontSize":"13px","color":"#6b7280","lineHeight":1.5,
            "margin":0,"display":"-webkit-box","-webkit-line-clamp":"2",
            "-webkit-box-orient":"vertical","overflow":"hidden" }},
        { "type":"row",
          "style":{ "display":"flex","alignItems":"center","gap":"16px","marginTop":"4px" },
          "children":[
            { "type":"text","bindKey":"price",
              "style":{ "fontSize":"20px","fontWeight":800,"color":"#6d28d9","margin":0 }},
            { "type":"button","text":"Voir le produit",
              "style":{ "padding":"8px 18px","background":"#f5f3ff","color":"#6d28d9",
                "border":"1px solid #e4dcfb","borderRadius":"8px","cursor":"pointer",
                "fontSize":"13px","fontWeight":600 }}
          ]}
      ]
    }
  ]
}`}</Code>
      </div>
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_59d4029f5ff760", "Variante — Carte paysage contenu (sections)")}</h2>
        <p style={S.p}>{elakayAutoText("h_fb52967b3d5ef9", "Même structure mais liée à")}<code style={S.inlineCode}>contentPage.sections</code> :</p>
        <Code>{`{
  "type": "panel",
  "repeatBind": { "source":"contentPage","path":"sections","mode":"children" },
  "style": { "display":"flex","flexDirection":"row","gap":0,
    "border":"1px solid #e5e7eb","borderRadius":"10px","overflow":"hidden",
    "marginBottom":"16px" },
  "children": [
    { "type":"image", "bindKey":"imagePath",
      "style":{ "width":"260px","flexShrink":0,"objectFit":"cover","minHeight":"180px" }},
    { "type":"stack",
      "style":{ "flex":1,"padding":"24px 28px","gap":"10px","justifyContent":"center" },
      "children":[
        { "type":"heading","bindKey":"title","tag":"h2",
          "style":{ "fontSize":"20px","fontWeight":800,"color":"#111827","margin":0 }},
        { "type":"text","bindKey":"text.0","tag":"p",
          "style":{ "fontSize":"14px","color":"#4b5563","lineHeight":1.7,"margin":0 }},
        { "type":"text","bindKey":"text.1","tag":"p",
          "style":{ "fontSize":"13px","color":"#6b7280","lineHeight":1.6,"margin":0 }}
      ]}
  ]
}`}</Code>
      </div>
    </div>
  ),

  "card-mini": () => (
    <div>
      <SectionTitle icon="📦" title={elakayAutoText("h_270c0ef537ae8d", "Carte Mini (compact)")}
        sub="Format minimaliste pour des grilles denses — 5 ou 6 colonnes." />
      <div style={S.card}>
        <Code>{`{
  "type": "panel",
  "repeatBind": { "source":"store","path":"products","mode":"children","autoFill":true },
  "style": {
    "background": "#fff",
    "borderRadius": "10px",
    "border": "1px solid #f3f4f6",
    "overflow": "hidden",
    "cursor": "pointer",
    "transition": "box-shadow 0.2s"
  },
  "children": [
    { "type":"image","bindKey":"galeriesID.galeries.0.urlImg.0",
      "style":{ "width":"100%","height":"140px","objectFit":"cover","display":"block" }},
    { "type":"stack","style":{ "padding":"8px 10px","gap":"4px" },
      "children":[
        { "type":"text","bindKey":"name","tag":"p",
          "style":{ "fontSize":"12px","fontWeight":600,"color":"#1f2937",
            "margin":0,"whiteSpace":"nowrap","overflow":"hidden","textOverflow":"ellipsis" }},
        { "type":"text","bindKey":"price","tag":"p",
          "style":{ "fontSize":"13px","fontWeight":800,"color":"#6d28d9","margin":0 }}
      ]}
  ]
}`}</Code>
        <Tip>{elakayAutoText("h_3ff0d900bd2163", "Pour une grille 5 colonnes mini :")}<code style={S.inlineCode}>options.columns: 5</code>{elakayAutoText("h_84c87a11e6df5a", "avec")}<code style={S.inlineCode}>deviceGrid: mobile 2, tablet 3, laptop 4, desktop 5</code>.</Tip>
      </div>
    </div>
  ),

  // ══════════════════════════════════════════════════════════════════════════════
  // CATÉGORIES HORIZONTALE & VERTICALE
  // ══════════════════════════════════════════════════════════════════════════════

  // ── Catégories : guide de choix ──────────────────────────────────────────────
  "cat-horiz": () => {
    const CATS = ["Plain T-Shirts","Polo Shirts","Tank Tops","Laptop","tablet","phone"];
    const CATS_DARK = ["Plain T-Shirts","Polo Shirts","Tank Tops","Laptop","tablet","phone","Graphic T-Shirts"];
    return (
    <div>
      <SectionTitle icon="🏷️" title={elakayAutoText("h_f291dd3752fae9", "Catégories — Choisir le bon type")}
        sub="Deux layouts selon le contexte : barre horizontale (pills) ou sidebar verticale." />

      {/* ── COMPARAISON VISUELLE ────────────────────────────────────────────── */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_1679db2a0a57cf", "Comparaison visuelle")}</h2>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"20px" }}>

          {/* Aperçu Horizontal */}
          <div>
            <div style={{ fontSize:"12px", fontWeight:700, color:C.green, marginBottom:"8px", textTransform:"uppercase", letterSpacing:"0.08em" }}>{elakayAutoText("h_fe18949ea9c6a1", "✓ Horizontal (catBar)")}</div>
            <div style={{ background:"#fff", border:"1px solid #f0f0f0", borderRadius:"10px", padding:"12px 16px", overflow:"hidden" }}>
              <div style={{ display:"flex", alignItems:"center", gap:"6px", overflowX:"auto", flexWrap:"nowrap", scrollbarWidth:"none" }}>
                <span style={{ padding:"6px 16px", background:"#1a1a2e", borderRadius:"50px", fontSize:"11px", fontWeight:700, color:"#fff", flexShrink:0 }}>{elakayAutoText("h_6b0b09b8a698b7", "Tout")}</span>
                {CATS.map(cat=>(
                  <span key={cat} style={{ padding:"6px 14px", background:"#f9f9f9", borderRadius:"50px", border:"1px solid #e5e7eb", fontSize:"11px", color:"#374151", flexShrink:0, whiteSpace:"nowrap", fontWeight:500 }}>{cat}</span>
                ))}
                <span style={{ padding:"6px 10px", color:"#9ca3af", fontSize:"11px", flexShrink:0 }}>…</span>
              </div>
            </div>
          </div>

          {/* Aperçu Vertical */}
          <div>
            <div style={{ fontSize:"12px", fontWeight:700, color:C.orange, marginBottom:"8px", textTransform:"uppercase", letterSpacing:"0.08em" }}>{elakayAutoText("h_ff4beb171fd0cd", "✓ Vertical (catSidebar)")}</div>
            <div style={{ background:"#1a1a2e", border:"1px solid #2d2d50", borderRadius:"10px", padding:"10px 12px", display:"flex", flexDirection:"column", gap:"4px" }}>
              <div style={{ padding:"8px 12px", background:"#d4af37", borderRadius:"6px", fontSize:"11px", fontWeight:700, color:"#0f172a", marginBottom:"2px" }}>{elakayAutoText("h_9f442b7c154c80", "Tout voir")}</div>
              {CATS_DARK.slice(0,5).map(cat=>(
                <div key={cat} style={{ padding:"7px 12px", background:"transparent", border:"1px solid #2a2a50", borderRadius:"6px", fontSize:"11px", color:"#94a3b8" }}>{cat}</div>
              ))}
              <div style={{ fontSize:"10px", color:"#4a4a6a", textAlign:"center", paddingTop:"2px" }}>…</div>
            </div>
          </div>
        </div>
      </div>

      {/* ── GUIDE DE CHOIX ──────────────────────────────────────────────────── */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_b7254970fdffea", "Quand choisir chaque type ?")}</h2>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"16px" }}>
          <div style={{ background:"#f0fdf4", border:"1px solid #a7f3d0", borderRadius:"10px", padding:"16px" }}>
            <div style={{ fontSize:"13px", fontWeight:700, color:C.green, marginBottom:"10px" }}>{elakayAutoText("h_70012d8db24aaa", "🏷️ Barre Horizontale — si :")}</div>
            {["La page a une largeur ≥ 100% (pleine page)","Vous avez un carrousel/hero au-dessus","Le design est épuré, minimaliste","Mobile : les catégories sont peu nombreuses (≤ 8)","Template : Classique, Nature, Sport, Festival, Urban"].map((t,i)=>(
              <div key={i} style={{ fontSize:"12px", color:"#065f46", marginBottom:"4px" }}>✓ {t}</div>
            ))}
          </div>
          <div style={{ background:"#fff7ed", border:"1px solid #fed7aa", borderRadius:"10px", padding:"16px" }}>
            <div style={{ fontSize:"13px", fontWeight:700, color:C.orange, marginBottom:"10px" }}>{elakayAutoText("h_b9a20be41134ac", "📑 Sidebar Verticale — si :")}</div>
            {["Vous avez beaucoup de catégories (> 8)","La page a un layout 2 colonnes (sidebar + grille)","Design Premium, Luxe, Tech, Nuit","Le filtre doit rester visible en scrollant","L'espace horizontal est limité (app, dashboard)"].map((t,i)=>(
              <div key={i} style={{ fontSize:"12px", color:"#9a3412", marginBottom:"4px" }}>✓ {t}</div>
            ))}
          </div>
        </div>
      </div>

      {/* ── JSON BARRE HORIZONTALE ──────────────────────────────────────────── */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_8282766198b518", "JSON complet — Barre horizontale (catBar)")}</h2>
        <p style={S.p}>{elakayAutoText("h_f8dc68de0b39b0", "Exactement comme le screenshot : fond blanc, pill noire \"Tout\", pills grises bordées, scroll horizontal sans scrollbar.")}</p>
        <Code>{`{
  "type": "section",
  "style": {
    "padding": "12px 32px",
    "background": "#ffffff",
    "borderBottom": "1px solid #f0f0f0"
  },
  "children": [
    {
      "type": "row",
      "style": {
        "display": "flex",
        "alignItems": "center",
        "gap": "8px",
        "overflowX": "auto",       /* scroll horizontal */
        "flexWrap": "nowrap",       /* pas de retour à la ligne */
        "scrollbarWidth": "none",   /* masque la scrollbar Firefox */
        "-ms-overflow-style": "none" /* masque IE */
      },
      "children": [

        /* ── Bouton "Tout" (sélectionné / actif) ── */
        {
          "type": "panel",
          "clickActionType": "function",
          "clickActionFunction": "loadProductsByArrival_",
          "style": {
            "padding": "7px 20px",
            "background": "#1a1a2e",    /* ← fond sombre = état actif */
            "borderRadius": "50px",
            "cursor": "pointer",
            "flexShrink": 0             /* ne rétrécit pas */
          },
          "children": [
            {
              "type": "text",
              "text": "Tout",
              "tag": "p",
              "style": {
                "fontSize": "12px",
                "fontWeight": 700,
                "color": "#ffffff",
                "margin": 0,
                "whiteSpace": "nowrap"
              }
            }
          ]
        },

        /* ── Pills catégories (répétées automatiquement) ── */
        {
          "type": "panel",
          "repeatBind": {
            "source": "store",
            "path": "categories.categories",   /* tableau catégories boutique */
            "mode": "children",
            "autoFill": false,
            "fieldMap": {}
          },
          "clickActionType": "function",
          "clickActionFunction": "loadProductsByArrival_",  /* filtre par catégorie */
          "style": {
            "padding": "7px 20px",
            "background": "#f9fafb",         /* fond gris très clair */
            "borderRadius": "50px",
            "cursor": "pointer",
            "border": "1px solid #e5e7eb",   /* bordure légère */
            "flexShrink": 0
          },
          "children": [
            {
              "type": "text",
              "text": "Catégorie",
              "bindKey": "name.0",            /* ← 1er niveau de nom de catégorie */
              "tag": "p",
              "style": {
                "fontSize": "12px",
                "fontWeight": 600,
                "color": "#374151",
                "margin": 0,
                "whiteSpace": "nowrap"
              }
            }
          ]
        }

      ]
    }
  ]
}`}</Code>

        <div style={{ background:"#f0f9ff", border:"1px solid #bae6fd", borderRadius:"10px", padding:"14px", marginTop:"12px" }}>
          <div style={{ fontSize:"12px", fontWeight:700, color:C.cyan, marginBottom:"8px" }}>{elakayAutoText("h_63dd6da3b83770", "🎨 Variantes de couleur")}</div>
          {[
            ["Classique (crème/brun)","#fdf8f0","#2d1a0e","#fdf8f0","#2d1a0e","#e8d5b7"],
            ["Nature (vert)","#f5f9f6","#2d4a3e","#fff","#2d4a3e","#c8e2ce"],
            ["Sport (rouge)","#1f2937","#ef4444","#111827","#d1d5db","#374151"],
            ["Ocean (bleu)","#f0f9ff","#0c4a6e","#fff","#0c4a6e","#bae6fd"],
            ["Festival (corail)","#fff7ed","#f43f5e","#fff","#9a3412","#fed7aa"],
          ].map(([label, secBg, allBg, pillBg, pillTxt, border])=>(
            <div key={label} style={{ display:"flex", gap:"8px", alignItems:"center", marginBottom:"6px" }}>
              <span style={{ fontSize:"11px", color:C.txt2, minWidth:"140px" }}>{label}</span>
              <div style={{ background:secBg, padding:"4px 8px", borderRadius:"20px", display:"flex", gap:"4px", alignItems:"center", border:`1px solid ${border}` }}>
                <span style={{ padding:"3px 10px", background:allBg, borderRadius:"50px", fontSize:"9px", color:"#fff", fontWeight:700 }}>{elakayAutoText("h_6b0b09b8a698b7", "Tout")}</span>
                <span style={{ padding:"3px 10px", background:pillBg, borderRadius:"50px", border:`1px solid ${border}`, fontSize:"9px", color:pillTxt }}>{elakayAutoText("h_fdc2e22edbff6b", "Polo Shirts")}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── VARIANTE TABS ───────────────────────────────────────────────────── */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_5066e22a44ee35", "Variante — Tabs avec ligne active")}</h2>
        <p style={S.p}>{elakayAutoText("h_b913222b0c19c9", "Pour un design plus formel (Tech, Moderne, Urban) avec indicateur de sélection sous forme de ligne :")}</p>
        <Code>{`{
  "type": "section",
  "style": {
    "padding": "0 40px",
    "background": "#27272a",          /* fond sombre Tech/Urban */
    "borderBottom": "1px solid #3f3f46"
  },
  "children": [
    {
      "type": "tabs",
      "style": { "border": "none", "borderRadius": 0 },
      "items": [
        { "id": "t1", "label": "Tout le Shop",
          "text": "L'ensemble de notre catalogue." },
        { "id": "t2", "label": "Nouveaux",
          "text": "Les dernières additions à notre collection." },
        { "id": "t3", "label": "En Promo",
          "text": "Nos meilleures offres limitées." },
        { "id": "t4", "label": "Top Ventes",
          "text": "Les articles les plus populaires." }
      ]
    }
  ]
}`}</Code>
      </div>
    </div>
  );},

  "cat-vert": () => {
    const CATS_DARK = ["Plain T-Shirts","Polo Shirts","Tank Tops","Laptop","tablet","phone","Graphic T-Shirts","Graphic T-Shirts"];
    return (
    <div>
      <SectionTitle icon="📑" title={elakayAutoText("h_a54aa82c71a4d8", "Catégories — Sidebar verticale")}
        sub="Exactement comme le screenshot sombre : colonne gauche fixe + grille produits droite." />

      {/* ── APERÇU VISUEL ───────────────────────────────────────────────────── */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_cc14771321a519", "Aperçu du résultat")}</h2>
        <div style={{ display:"flex", gap:"12px", border:"1px solid #2d2d50", borderRadius:"10px", overflow:"hidden", maxWidth:"480px" }}>
          {/* Sidebar */}
          <div style={{ width:"140px", flexShrink:0, background:"#1a1a2e", padding:"14px 10px", display:"flex", flexDirection:"column", gap:"5px" }}>
            <div style={{ padding:"8px 12px", background:"#d4af37", borderRadius:"6px", fontSize:"11px", fontWeight:700, color:"#0f172a", marginBottom:"4px" }}>{elakayAutoText("h_9f442b7c154c80", "Tout voir")}</div>
            {CATS_DARK.slice(0,6).map(cat=>(
              <div key={cat} style={{ padding:"7px 10px", background:"transparent", border:"1px solid #2a3050", borderRadius:"5px", fontSize:"10px", color:"#6b7280" }}>{cat}</div>
            ))}
          </div>
          {/* Grille placeholder */}
          <div style={{ flex:1, background:"#f9fafb", padding:"14px", display:"grid", gridTemplateColumns:"1fr 1fr", gap:"8px" }}>
            {[1,2,3,4].map(i=>(
              <div key={i} style={{ background:"#fff", borderRadius:"8px", border:"1px solid #e5e7eb", height:"80px", display:"flex", alignItems:"center", justifyContent:"center", color:"#d1d5db", fontSize:"10px" }}>{elakayAutoText("h_0e57b0e7da2b17", "produit")}{i}</div>
            ))}
          </div>
        </div>
        <p style={{ ...S.p, marginTop:"10px", color:C.txt3, fontSize:"12px" }}>{elakayAutoText("h_4b6e3a8577c950", "La sidebar reste fixe (200px) ; la grille occupe tout l'espace restant (flex: 1).")}</p>
      </div>

      {/* ── STRUCTURE PARENTE ───────────────────────────────────────────────── */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_51b4bd17980080", "Étape 1 — Structure parente (Row)")}</h2>
        <p style={S.p}>{elakayAutoText("h_b6ddf3f3ee4223", "Toute la page est une")}<code style={S.inlineCode}>row</code>{elakayAutoText("h_82cb8ae9e165dc", "qui contient la sidebar et la grille côte à côte :")}</p>
        <Code>{`{
  "type": "row",
  "style": {
    "display": "flex",
    "gap": 0,
    "background": "#1a1a2e",   /* fond global sombre */
    "minHeight": "80vh"
  },
  "children": [
    /* 1. La sidebar (voir Étape 2) */
    { "type":"stack", ... },

    /* 2. Le contenu produits (voir Étape 3) */
    { "type":"stack", ... }
  ]
}`}</Code>
      </div>

      {/* ── JSON SIDEBAR ────────────────────────────────────────────────────── */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_469b1369a65fed", "Étape 2 — JSON sidebar verticale (exactement le screenshot)")}</h2>
        <Code>{`{
  "type": "stack",
  "style": {
    "width": "200px",
    "flexShrink": 0,
    "padding": "24px 14px",
    "background": "#1a1a2e",           /* ← fond sombre navy */
    "borderRight": "1px solid #2a3050",
    "display": "flex",
    "flexDirection": "column",
    "gap": "6px"
  },
  "children": [

    /* ── Bouton "Tout voir" (toujours visible, style actif) ── */
    {
      "type": "panel",
      "clickActionType": "function",
      "clickActionFunction": "loadProductsByArrival_",
      "style": {
        "padding": "10px 14px",
        "background": "#d4af37",        /* ← or = bouton principal actif */
        "borderRadius": "6px",
        "cursor": "pointer",
        "marginBottom": "4px"
      },
      "children": [
        {
          "type": "text",
          "text": "Tout voir",
          "tag": "p",
          "style": {
            "fontSize": "13px",
            "fontWeight": 700,
            "color": "#0f172a",         /* ← texte sombre sur fond or */
            "margin": 0
          }
        }
      ]
    },

    /* ── Items catégories (répétés automatiquement) ── */
    {
      "type": "panel",
      "repeatBind": {
        "source": "store",
        "path": "categories.categories",
        "mode": "children",
        "autoFill": false,
        "fieldMap": {}
      },
      "clickActionType": "function",
      "clickActionFunction": "loadProductsByArrival_",
      "style": {
        "padding": "9px 14px",
        "background": "transparent",    /* ← fond transparent = inactif */
        "borderRadius": "5px",
        "cursor": "pointer",
        "border": "1px solid #2a3050"  /* ← bordure sombre discrète */
      },
      "children": [
        {
          "type": "text",
          "text": "Catégorie",
          "bindKey": "name.0",          /* ← 1er niveau de nom */
          "tag": "p",
          "style": {
            "fontSize": "13px",
            "fontWeight": 400,
            "color": "#6b7280",         /* ← texte gris inactif */
            "margin": 0
          }
        }
      ]
    }

  ]
}`}</Code>
      </div>

      {/* ── JSON GRILLE PRODUITS ─────────────────────────────────────────────── */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_9003de43e941d2", "Étape 3 — JSON grille produits (panneau droit)")}</h2>
        <Code>{`{
  "type": "stack",
  "style": {
    "flex": 1,                        /* ← prend tout l'espace restant */
    "padding": "32px 40px",
    "display": "flex",
    "flexDirection": "column",
    "gap": "20px",
    "background": "#0f172a"           /* ← même fond sombre */
  },
  "children": [

    /* Titre */
    {
      "type": "heading",
      "text": "Toute la Collection",
      "tag": "h2",
      "style": {
        "fontSize": "20px",
        "fontWeight": 800,
        "color": "#f8fafc",
        "margin": 0
      }
    },

    /* Grille responsive */
    {
      "type": "grid",
      "options": {
        "columns": 4,
        "deviceGrid": [
          { "device": "mobile",  "columns": 1, "gap": "12px" },
          { "device": "tablet",  "columns": 2, "gap": "14px" },
          { "device": "laptop",  "columns": 3, "gap": "16px" },
          { "device": "desktop", "columns": 4, "gap": "16px" }
        ]
      },
      "style": { "width": "100%" },
      "children": [
        {
          "type": "panel",
          "repeatBind": {
            "source": "store",
            "path": "products",
            "mode": "children",
            "autoFill": true,
            "paginate": true,
            "pageSize": 12
          },
          "style": {
            "background": "#1e293b",       /* ← card sombre */
            "borderRadius": "4px",
            "overflow": "hidden",
            "display": "flex",
            "flexDirection": "column"
          },
          "children": [
            { "type":"image",
              "bindKey":"galeriesID.galeries.0.urlImg.0",
              "style":{ "width":"100%","height":"200px","objectFit":"cover","display":"block" }},
            { "type":"stack",
              "style":{ "padding":"12px 14px","gap":"8px","flex":1 },
              "children":[
                { "type":"heading","bindKey":"name","tag":"h3",
                  "style":{ "fontSize":"13px","fontWeight":600,"color":"#f1f5f9","margin":0 }},
                { "type":"row",
                  "style":{ "display":"flex","justifyContent":"space-between","alignItems":"center" },
                  "children":[
                    { "type":"text","bindKey":"price",
                      "style":{ "fontSize":"16px","fontWeight":800,
                        "color":"#d4af37","margin":0 }},
                    { "type":"button","text":"+",
                      "style":{ "width":"32px","height":"32px","borderRadius":"50%",
                        "background":"#d4af37","color":"#0f172a",
                        "border":"none","fontSize":"20px","fontWeight":700,
                        "cursor":"pointer","display":"flex","alignItems":"center",
                        "justifyContent":"center","padding":0 }}
                  ]}
              ]}
          ]
        }
      ]
    },

    /* Pagination */
    {
      "type": "row",
      "style": {
        "display": "flex",
        "justifyContent": "space-between",
        "alignItems": "center",
        "padding": "20px 0 0"
      },
      "children": [
        {
          "type": "button",
          "text": "← Previous",
          "clickActionType": "function",
          "clickActionFunction": "loadMore0",
          "style": {
            "padding": "8px 22px","fontSize":"13px","fontWeight":600,
            "color":"#0f172a","background":"#d4af37",
            "border":"none","borderRadius":"8px","cursor":"pointer"
          }
        },
        {
          "type": "button",
          "text": "Next →",
          "clickActionType": "function",
          "clickActionFunction": "loadMore",
          "style": {
            "padding": "8px 22px","fontSize":"13px","fontWeight":600,
            "color":"#0f172a","background":"#d4af37",
            "border":"none","borderRadius":"8px","cursor":"pointer"
          }
        }
      ]
    }

  ]
}`}</Code>
      </div>

      {/* ── VARIANTES COULEUR ────────────────────────────────────────────────── */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_7f03dcf81d5d2e", "Variantes de couleur de sidebar")}</h2>
        {[
          { label:elakayAutoText("h_4021d0477ff9dc", "Premium (marine/or)"),    sidebarBg:"#0f172a", borderColor:"#1e3a5f", allBg:"#d4af37", allTxt:"#0f172a", itemBorder:"#2a3550", itemTxt:"#94a3b8" },
          { label:elakayAutoText("h_b3d084c1131bd5", "Luxe (noir/or)"),         sidebarBg:"#1a1a1a", borderColor:"#2a2a2a", allBg:"#c9a84c", allTxt:"#0d0d0d", itemBorder:"#2a2a2a", itemTxt:"#a09070" },
          { label:elakayAutoText("h_cfd292c5dc2b41", "Tech (dark/cyan)"),       sidebarBg:"#0d1117", borderColor:"#30363d", allBg:"#00d4aa", allTxt:"#0d1117", itemBorder:"#30363d", itemTxt:"#8b949e" },
          { label:elakayAutoText("h_18360abd83fa14", "Nuit (violet/lavande)"),  sidebarBg:"#16123a", borderColor:"#312e81", allBg:"rgba(167,139,250,0.15)", allTxt:"#a78bfa", itemBorder:"#312e81", itemTxt:"#7c6fa8" },
          { label:elakayAutoText("h_f5b82e581b354b", "Classique (crème/brun)"), sidebarBg:"#fdf8f0", borderColor:"#e8d5b7", allBg:"#2d1a0e", allTxt:"#fdf8f0", itemBorder:"#e8d5b7", itemTxt:"#7a5c3a" },
        ].map(({ label, sidebarBg, borderColor, allBg, allTxt, itemBorder, itemTxt }) => (
          <div key={label} style={{ display:"flex", gap:"12px", alignItems:"center", marginBottom:"8px", padding:"8px 10px", background:"#fafafa", borderRadius:"8px" }}>
            <span style={{ fontSize:"11px", color:C.txt2, minWidth:"170px" }}>{label}</span>
            <div style={{ background:sidebarBg, borderRadius:"7px", padding:"8px 10px", display:"flex", flexDirection:"column", gap:"4px", minWidth:"120px", border:`1px solid ${borderColor}` }}>
              <div style={{ padding:"5px 10px", background:allBg, borderRadius:"4px", fontSize:"9px", fontWeight:700, color:allTxt }}>{elakayAutoText("h_9f442b7c154c80", "Tout voir")}</div>
              {["Polo","Laptop"].map(c=>(
                <div key={c} style={{ padding:"4px 10px", border:`1px solid ${itemBorder}`, borderRadius:"4px", fontSize:"9px", color:itemTxt }}>{c}</div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <Tip>{elakayAutoText("h_ec583f386fdde8", "Pour que la sidebar reste visible au scroll, ajoutez")}<code style={S.inlineCode}>position: sticky; top: 0; height: 100vh; overflowY: auto</code>{elakayAutoText("h_00ed27e2e0138a", "à son style.")}</Tip>
    </div>
  );},

  "cat-active": CatActiveSection,

  "cat-matrix": () => (
    <div>
      <SectionTitle icon="🌐" title={elakayAutoText("h_caa2ff10f9ed9b", "Catégories Matrix animée (shopCatMatrix)")}
        sub="Composant live avec animations personnalisables." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_754164850f38c1", "Configuration")}</h2>
        <PropTable rows={[
          {name:"bindSource",type:"string",desc:"'store.categories' — source des données"},
          {name:"options.title",type:"string",desc:"Titre de la section"},
          {name:"options.titleColor",type:"string",desc:"Couleur du titre"},
          {name:"options.nbrArr",type:"number",desc:"Nombre de colonnes (ex: 4)"},
          {name:"options.type_Animation",type:"string",desc:"Code animation fond (ex: '0_type_Animation')"},
          {name:"options.inView",type:"boolean",desc:"Déclenche l'animation au scroll (true)"},
          {name:"options.wm0",type:"number",desc:"Colonnes mobile (ex: 1.3 = partiel)"},
          {name:"options.wm640",type:"number",desc:"Colonnes tablet (ex: 2)"},
          {name:"options.wm768",type:"number",desc:"Colonnes laptop (ex: 3)"},
          {name:"options.wm1024",type:"number",desc:"Colonnes large (ex: 4)"},
          {name:"options.headerBackgroundColor",type:"string",desc:"Fond header"},
          {name:"options.textFoorter",type:"boolean",desc:"Afficher le texte bas de carte"},
        ]} />
        <Code>{`{ "type": "shopCatMatrix",
  "bindSource": "store.categories",
  "style": { "width":"100%","background":"#f9fafb" },
  "options": {
    "title": "Nos Catégories",
    "titleColor": "#111827",
    "titleFontSize": "1.6rem",
    "titleFontWeight": 700,
    "inView": true,
    "nbrArr": 4,
    "type_Animation": "0_type_Animation",
    "wm0": 1.3,
    "wm640": 2,
    "wm768": 3,
    "wm1024": 4,
    "wm1200": 4,
    "headerBackgroundColor": "transparent",
    "textFoorter": false
  }
}`}</Code>
        <Tip>{elakayAutoText("h_43af6496ce62f4", "Codes d'animation populaires :")}<code style={S.inlineCode}>0</code>{elakayAutoText("h_171b926ce5d1c1", "Arc-en-ciel ·")}<code style={S.inlineCode}>4</code>{elakayAutoText("h_97628eaf336335", "Gradient ·")}<code style={S.inlineCode}>5</code>{elakayAutoText("h_aa6f23e8c1b59e", "Cyan Teal ·")}<code style={S.inlineCode}>14</code>{elakayAutoText("h_4d83d41644d053", "Artisan ·")}<code style={S.inlineCode}>19</code>{elakayAutoText("h_ee3dfa16a52af0", "Neon Glow ·")}<code style={S.inlineCode}>22</code>{elakayAutoText("h_28bd2f75512300", "Electric Storm ·")}<code style={S.inlineCode}>24</code>{elakayAutoText("h_e8ca72a4bdc93e", "Water Ripples")}</Tip>
      </div>
    </div>
  ),

  // ══════════════════════════════════════════════════════════════════════════════
  // 5 EXEMPLES PRATIQUES
  // ══════════════════════════════════════════════════════════════════════════════

  "ex-hero": () => (
    <div>
      <SectionTitle icon="🌟" title={elakayAutoText("h_bc879948828e75", "Exemple 1 — Hero + Stat band")}
        sub="Section hero pleine largeur avec bande de statistiques." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_3ad9acb4114088", "Résultat visuel")}</h2>
        <div style={{ background:"#0f172a",borderRadius:"10px",padding:"24px",marginBottom:"12px",textAlign:"center" }}>
          <div style={{ fontSize:"10px",color:"#94a3b8",letterSpacing:"0.2em",marginBottom:"4px" }}>{elakayAutoText("h_a7d279b1ad33c3", "ELAKAY BOUTIQUE")}</div>
          <div style={{ fontSize:"24px",fontWeight:900,color:"#f8fafc",marginBottom:"4px" }}>{elakayAutoText("h_7a82c710fdd2ba", "Titre Hero")}</div>
          <div style={{ fontSize:"12px",color:"#64748b",marginBottom:"12px" }}>{elakayAutoText("h_ca2bb19be3b43c", "Sous-titre descriptif de la boutique")}</div>
          <div style={{ display:"flex",gap:"8px",justifyContent:"center" }}>
            <span style={{ padding:"6px 16px",background:"#6d28d9",color:"#fff",borderRadius:"50px",fontSize:"11px" }}>{elakayAutoText("h_ac7b495a1d3bca", "CTA Principal")}</span>
            <span style={{ padding:"6px 16px",border:"1px solid #334155",color:"#94a3b8",borderRadius:"50px",fontSize:"11px" }}>{elakayAutoText("h_616994abbb6086", "Secondaire")}</span>
          </div>
        </div>
        <div style={{ background:"#d4af37",borderRadius:"8px",padding:"10px",display:"flex",justifyContent:"center",gap:"32px" }}>
          {[["500+","Vendeurs"],["10K+","Acheteurs"],["$2M+","Volume"]].map(([v,l])=>(
            <div key={l} style={{ textAlign:"center" }}>
              <div style={{ fontSize:"16px",fontWeight:900,color:"#0f172a" }}>{v}</div>
              <div style={{ fontSize:"10px",color:"#5c4700" }}>{l}</div>
            </div>
          ))}
        </div>
      </div>
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_99e16940876a16", "JSON complet")}</h2>
        <Code>{`/* Section Hero */
{ "type":"section",
  "style":{ "padding":"80px 48px 64px","background":"#0f172a",
    "display":"flex","flexDirection":"column",
    "alignItems":"center","gap":"16px","textAlign":"center" },
  "children":[
    { "type":"text","text":"ELAKAY BOUTIQUE","tag":"p",
      "style":{ "fontSize":"10px","fontWeight":700,"color":"#6d28d9",
        "letterSpacing":"0.3em","margin":0 }},
    { "type":"heading","text":"Bienvenue dans notre boutique",
      "bindKey":"store.owner.shopName.0","tag":"h1",
      "style":{ "fontSize":"48px","fontWeight":900,"color":"#f8fafc",
        "margin":"0 0 8px","lineHeight":1.1 },
      "animation":"fadeInUp","animationDuration":"0.8s","animationFillMode":"both" },
    { "type":"text","text":"Votre destination shopping de confiance.",
      "style":{ "fontSize":"17px","color":"#64748b","lineHeight":1.6,
        "maxWidth":"560px","margin":"0 auto" }},
    { "type":"row",
      "style":{ "display":"flex","gap":"12px","justifyContent":"center","flexWrap":"wrap" },
      "children":[
        { "type":"button","text":"Explorer la boutique",
          "clickActionType":"url","clickActionHref":"/shop",
          "style":{ "padding":"12px 28px","background":"#6d28d9","color":"#fff",
            "border":"none","borderRadius":"50px","cursor":"pointer",
            "fontSize":"14px","fontWeight":700 }},
        { "type":"stat","content":{ "value":"28","label":"produits",
            "valueColor":"#6d28d9","labelColor":"#94a3b8" },
          "bindKey":"store.siseProductAll",
          "style":{ "padding":"10px 20px","background":"rgba(109,40,217,0.1)",
            "borderRadius":"50px","border":"1px solid rgba(109,40,217,0.25)",
            "display":"inline-block" }}
      ]}
  ]
},

/* Stat band or */
{ "type":"banner",
  "style":{ "background":"#d4af37","padding":"14px 48px",
    "display":"flex","alignItems":"center","justifyContent":"center",
    "gap":"48px","flexWrap":"wrap" },
  "children":[
    { "type":"stat","content":{ "value":"500+","label":"Vendeurs actifs",
        "valueColor":"#0f172a","labelColor":"#5c4700" },
      "style":{ "textAlign":"center" }},
    { "type":"divider","style":{ "width":"1px","height":"32px",
        "background":"rgba(0,0,0,0.2)","border":"none" }},
    { "type":"stat","content":{ "value":"10K+","label":"Acheteurs",
        "valueColor":"#0f172a","labelColor":"#5c4700" }},
    { "type":"divider","style":{ "width":"1px","height":"32px",
        "background":"rgba(0,0,0,0.2)","border":"none" }},
    { "type":"stat","content":{ "value":"$2M+","label":"Volume 2024",
        "valueColor":"#0f172a","labelColor":"#5c4700" }}
  ]
}`}</Code>
      </div>
    </div>
  ),

  "ex-faq": () => (
    <div>
      <SectionTitle icon="❓" title={elakayAutoText("h_e40e4f3372d11b", "Exemple 2 — FAQ Accordéon")}
        sub="Section questions/réponses avec accordéon dépliable." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_a0c74632daec7e", "Accordéon statique (items fixes)")}</h2>
        <Code>{`{ "type": "section",
  "style": { "padding":"48px","background":"#f9fafb" },
  "children": [
    { "type":"heading","text":"Questions fréquentes","tag":"h2",
      "style":{ "fontSize":"24px","fontWeight":800,"color":"#111827",
        "margin":"0 0 24px","textAlign":"center" }},
    { "type":"accordion",
      "style":{ "display":"flex","flexDirection":"column","gap":"8px",
        "maxWidth":"700px","margin":"0 auto" },
      "items":[
        { "id":"faq1",
          "q":"Comment passer commande ?",
          "a":"Ajoutez un produit au panier et suivez les étapes de paiement sécurisé PayPal ou carte bancaire." },
        { "id":"faq2",
          "q":"Quels sont les délais de livraison ?",
          "a":"Livraison en 3 à 5 jours ouvrés selon votre adresse. Suivi disponible par email." },
        { "id":"faq3",
          "q":"Comment retourner un article ?",
          "a":"Contactez-nous sous 14 jours pour tout retour ou échange. Retour gratuit pour les membres." },
        { "id":"faq4",
          "q":"Puis-je modifier ma commande ?",
          "a":"Oui, dans les 2 heures après la commande. Contactez notre support immédiatement." }
      ]
    }
  ]
}`}</Code>
      </div>
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_900215531ae67b", "FAQ liée aux données (repeatBind)")}</h2>
        <Code>{`/* Quand les FAQ viennent du dataset project.faq */
{ "type":"section",
  "style":{ "padding":"48px","background":"#f9fafb" },
  "children":[
    { "type":"heading","text":"FAQ","bindKey":"project.pageTitle","tag":"h2",
      "style":{ "fontSize":"22px","fontWeight":800,"color":"#111827","margin":"0 0 20px" }},
    {
      "type": "panel",
      "repeatBind":{
        "source":"project","path":"faq","mode":"children","autoFill":false
      },
      "style":{ "padding":"18px 22px","background":"#fff",
        "borderRadius":"10px","border":"1px solid #e5e7eb",
        "marginBottom":"8px","display":"flex","flexDirection":"column","gap":"6px" },
      "children":[
        { "type":"heading","text":"Question ?","bindKey":"question","tag":"h4",
          "style":{ "fontSize":"15px","fontWeight":700,"color":"#111827","margin":0 }},
        { "type":"text","text":"Réponse...","bindKey":"answer","tag":"p",
          "style":{ "fontSize":"14px","color":"#6b7280","lineHeight":1.6,"margin":0 }}
      ]
    }
  ]
}`}</Code>
        <Tip>{elakayAutoText("h_bafb7456e01789", "Pour un vrai accordéon interactif (open/close) avec les données du dataset, utilisez l'élément")}<code style={S.inlineCode}>accordion</code>{elakayAutoText("h_84c87a11e6df5a", "avec")}<code style={S.inlineCode}>repeatBind</code>{elakayAutoText("h_a5bc1d9b2ae74e", "et")}<code style={S.inlineCode}>fieldMap</code>{elakayAutoText("h_60950c9d282176", "mappant")}<code style={S.inlineCode}>q → question</code>{elakayAutoText("h_a5bc1d9b2ae74e", "et")}<code style={S.inlineCode}>a → answer</code>.</Tip>
      </div>
    </div>
  ),

  "ex-gallery": () => (
    <div>
      <SectionTitle icon="🖼️" title={elakayAutoText("h_38f2c146174b2f", "Exemple 3 — Galerie Média (images + vidéos)")}
        sub="Grille de médias mixtes avec images et vidéos." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_edca5ce4c9b358", "Grille d'images 3 colonnes")}</h2>
        <Code>{`{ "type":"section",
  "style":{ "padding":"48px","background":"#0d1117" },
  "children":[
    { "type":"heading","text":"Notre Galerie","tag":"h2",
      "style":{ "fontSize":"24px","fontWeight":800,"color":"#fff",
        "margin":"0 0 24px","textAlign":"center" }},
    { "type":"grid",
      "options":{ "columns":3,"deviceGrid":[
        {"device":"mobile","columns":1,"gap":"8px"},
        {"device":"tablet","columns":2,"gap":"10px"},
        {"device":"desktop","columns":3,"gap":"12px"}
      ]},
      "style":{ "width":"100%" },
      "children":[
        /* Image 1 — grande (span 2) */
        { "type":"image","src":"https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?w=800&h=500&fit=crop",
          "style":{ "width":"100%","height":"280px","objectFit":"cover",
            "borderRadius":"12px","display":"block" },
          "animation":"fadeIn","animationDuration":"0.6s","animationFillMode":"both" },
        { "type":"image","src":"https://images.unsplash.com/photo-1483985988355-763728e1935b?w=400&h=280&fit=crop",
          "style":{ "width":"100%","height":"280px","objectFit":"cover",
            "borderRadius":"12px","display":"block" }},
        { "type":"image","src":"https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=400&h=280&fit=crop",
          "style":{ "width":"100%","height":"280px","objectFit":"cover",
            "borderRadius":"12px","display":"block" }},
        { "type":"video",
          "src":"https://www.w3schools.com/html/mov_bbb.mp4",
          "style":{ "width":"100%","height":"280px","objectFit":"cover",
            "borderRadius":"12px" }},
        { "type":"image","src":"https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=400&h=280&fit=crop",
          "style":{ "width":"100%","height":"280px","objectFit":"cover",
            "borderRadius":"12px","display":"block" }},
        { "type":"image","src":"https://images.unsplash.com/photo-1521334884684-d80222895322?w=400&h=280&fit=crop",
          "style":{ "width":"100%","height":"280px","objectFit":"cover",
            "borderRadius":"12px","display":"block" }}
      ]}
  ]
}`}</Code>
        <h2 style={S.h2}>{elakayAutoText("h_f8c8cd220a7202", "Galerie liée aux images produits")}</h2>
        <Code>{`/* Galerie auto-générée depuis store.products */
{ "type":"grid",
  "options":{ "columns":4,"deviceGrid":[
    {"device":"mobile","columns":2,"gap":"6px"},
    {"device":"tablet","columns":3,"gap":"8px"},
    {"device":"desktop","columns":4,"gap":"10px"}
  ]},
  "children":[
    { "type":"panel",
      "repeatBind":{
        "source":"store","path":"products","mode":"children","autoFill":true
      },
      "clickActionType":"url","clickActionHref":"/product",
      "style":{ "position":"relative","borderRadius":"10px",
        "overflow":"hidden","cursor":"pointer" },
      "children":[
        { "type":"image",
          "bindKey":"galeriesID.galeries.0.urlImg.0",
          "style":{ "width":"100%","height":"160px","objectFit":"cover","display":"block" }},
        { "type":"panel",
          "style":{ "position":"absolute","bottom":0,"left":0,"right":0,
            "padding":"8px","background":"linear-gradient(transparent,rgba(0,0,0,0.7))" },
          "children":[
            { "type":"text","bindKey":"name","tag":"p",
              "style":{ "fontSize":"11px","fontWeight":600,"color":"#fff",
                "margin":0,"whiteSpace":"nowrap","overflow":"hidden",
                "textOverflow":"ellipsis" }}
          ]}
      ]}
  ]
}`}</Code>
      </div>
    </div>
  ),

  "ex-pricing": () => (
    <div>
      <SectionTitle icon="💳" title={elakayAutoText("h_b889d4a33a6c61", "Exemple 4 — Plans tarifaires")}
        sub="Grille de cartes de tarifs avec mise en avant du plan recommandé." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_7aaf7052ea40ca", "Plans statiques (3 colonnes)")}</h2>
        <Code>{`{ "type":"section",
  "style":{ "padding":"64px 48px","background":"#f9fafb" },
  "children":[
    { "type":"heading","text":"Nos Plans","tag":"h2",
      "style":{ "fontSize":"28px","fontWeight":900,"color":"#111827",
        "margin":"0 0 8px","textAlign":"center" }},
    { "type":"text","text":"Choisissez le plan adapté à votre activité.","tag":"p",
      "style":{ "fontSize":"16px","color":"#6b7280","textAlign":"center",
        "margin":"0 0 40px" }},
    { "type":"grid",
      "options":{ "columns":3,"deviceGrid":[
        {"device":"mobile","columns":1,"gap":"20px"},
        {"device":"tablet","columns":2,"gap":"20px"},
        {"device":"desktop","columns":3,"gap":"24px"}
      ]},
      "style":{ "width":"100%","maxWidth":"900px","margin":"0 auto" },
      "children":[

        /* Plan Starter */
        { "type":"panel",
          "style":{ "background":"#fff","borderRadius":"16px",
            "border":"1px solid #e5e7eb","padding":"32px 24px",
            "display":"flex","flexDirection":"column","gap":"14px" },
          "children":[
            { "type":"text","text":"STARTER","tag":"p",
              "style":{ "fontSize":"11px","fontWeight":700,"color":"#6d28d9",
                "letterSpacing":"0.15em","margin":0 }},
            { "type":"heading","text":"$500","tag":"h2",
              "style":{ "fontSize":"40px","fontWeight":900,"color":"#111827","margin":0 }},
            { "type":"text","text":"par mois","tag":"p",
              "style":{ "fontSize":"13px","color":"#9ca3af","margin":"-10px 0 0" }},
            { "type":"divider","style":{ "border":"none","borderTop":"1px solid #f3f4f6" }},
            { "type":"text","text":"✓ Accès réseau","style":{ "fontSize":"13px","color":"#374151","margin":0 }},
            { "type":"text","text":"✓ Rapport trimestriel","style":{ "fontSize":"13px","color":"#374151","margin":0 }},
            { "type":"text","text":"✓ Support email","style":{ "fontSize":"13px","color":"#374151","margin":0 }},
            { "type":"button","text":"Commencer",
              "style":{ "padding":"12px","background":"#f5f3ff","color":"#6d28d9",
                "border":"1px solid #e4dcfb","borderRadius":"10px","cursor":"pointer",
                "fontWeight":700,"fontSize":"14px" }}
          ]},

        /* Plan Pro — mis en avant */
        { "type":"panel",
          "style":{ "background":"#6d28d9","borderRadius":"16px",
            "border":"2px solid #5b21b6","padding":"32px 24px",
            "display":"flex","flexDirection":"column","gap":"14px",
            "transform":"scale(1.04)","boxShadow":"0 8px 32px rgba(109,40,217,0.35)" },
          "children":[
            { "type":"text","text":"✦ RECOMMANDÉ","tag":"p",
              "style":{ "fontSize":"10px","fontWeight":700,"color":"#c4b5fd",
                "letterSpacing":"0.15em","margin":0 }},
            { "type":"text","text":"PRO","tag":"p",
              "style":{ "fontSize":"11px","fontWeight":700,"color":"#e0e7ff",
                "letterSpacing":"0.15em","margin":0 }},
            { "type":"heading","text":"$2500","tag":"h2",
              "style":{ "fontSize":"40px","fontWeight":900,"color":"#fff","margin":0 }},
            { "type":"text","text":"par mois","tag":"p",
              "style":{ "fontSize":"13px","color":"#a78bfa","margin":"-10px 0 0" }},
            { "type":"divider","style":{ "border":"none","borderTop":"1px solid rgba(255,255,255,0.15)" }},
            { "type":"text","text":"✓ Tout du Starter","style":{ "fontSize":"13px","color":"#e0e7ff","margin":0 }},
            { "type":"text","text":"✓ Rapport mensuel","style":{ "fontSize":"13px","color":"#e0e7ff","margin":0 }},
            { "type":"text","text":"✓ Support dédié","style":{ "fontSize":"13px","color":"#e0e7ff","margin":0 }},
            { "type":"text","text":"✓ Droit de vote","style":{ "fontSize":"13px","color":"#e0e7ff","margin":0 }},
            { "type":"button","text":"Choisir Pro",
              "style":{ "padding":"12px","background":"#fff","color":"#6d28d9",
                "border":"none","borderRadius":"10px","cursor":"pointer",
                "fontWeight":800,"fontSize":"14px" }}
          ]},

        /* Plan Royale */
        { "type":"panel",
          "style":{ "background":"#fff","borderRadius":"16px",
            "border":"1px solid #e5e7eb","padding":"32px 24px",
            "display":"flex","flexDirection":"column","gap":"14px" },
          "children":[
            { "type":"text","text":"ROYALE","tag":"p",
              "style":{ "fontSize":"11px","fontWeight":700,"color":"#d4af37",
                "letterSpacing":"0.15em","margin":0 }},
            { "type":"heading","text":"$10K","tag":"h2",
              "style":{ "fontSize":"40px","fontWeight":900,"color":"#111827","margin":0 }},
            { "type":"divider","style":{ "border":"none","borderTop":"1px solid #f3f4f6" }},
            { "type":"text","text":"✓ Tout du Pro","style":{ "fontSize":"13px","color":"#374151","margin":0 }},
            { "type":"text","text":"✓ Siège au comité","style":{ "fontSize":"13px","color":"#374151","margin":0 }},
            { "type":"text","text":"✓ Manager dédié","style":{ "fontSize":"13px","color":"#374151","margin":0 }},
            { "type":"button","text":"Contacter",
              "style":{ "padding":"12px","background":"#fffbeb","color":"#92400e",
                "border":"1px solid #fcd34d","borderRadius":"10px","cursor":"pointer",
                "fontWeight":700,"fontSize":"14px" }}
          ]}
      ]}
  ]
}`}</Code>
        <h2 style={S.h2}>{elakayAutoText("h_82c70b6a3ec574", "Plans liés au dataset (repeatBind)")}</h2>
        <p style={S.p}>{elakayAutoText("h_b6fa5722f6d4d2", "Pour lier les plans depuis")}<code style={S.inlineCode}>project.plans</code>{elakayAutoText("h_ac81d67620c80c", ", remplacez les 3 panels par un seul avec repeatBind :")}</p>
        <Code>{`{ "type":"panel",
  "repeatBind":{ "source":"project","path":"plans","mode":"children","autoFill":false,
    "fieldMap":{ /* mappez les IDs des enfants aux champs */ }
  },
  "style":{ "background":"#fff","borderRadius":"16px",... },
  "children":[
    { "type":"heading","bindKey":"name","tag":"h3" },
    { "type":"heading","bindKey":"price","tag":"h2" },
    { "type":"text","bindKey":"duration" },
    { "type":"text","bindKey":"returnRate" },
    { "type":"text","bindKey":"benefits.0" }
  ]
}`}</Code>
      </div>
    </div>
  ),

  "ex-contact": () => (
    <div>
      <SectionTitle icon="📬" title={elakayAutoText("h_69d08128832873", "Exemple 5 — Section Contact / Formulaire")}
        sub="Formulaire de contact et informations de contact côte à côte." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_1721c90af22e89", "Section Contact complète")}</h2>
        <Code>{`{ "type":"section",
  "style":{ "padding":"64px 48px","background":"#fff" },
  "children":[
    { "type":"heading","text":"Contactez-nous","tag":"h2",
      "style":{ "fontSize":"28px","fontWeight":900,"color":"#111827",
        "margin":"0 0 8px","textAlign":"center" }},
    { "type":"text","text":"Nous répondons dans les 24h.","tag":"p",
      "style":{ "fontSize":"16px","color":"#6b7280","textAlign":"center",
        "margin":"0 0 40px" }},

    /* Layout 2 colonnes */
    { "type":"row",
      "style":{ "display":"flex","gap":"48px","alignItems":"flex-start",
        "flexWrap":"wrap" },
      "children":[

        /* Colonne infos */
        { "type":"stack",
          "style":{ "flex":1,"minWidth":"240px","gap":"20px" },
          "children":[
            { "type":"text","text":"📍 226 Norfeld BLVD, Elmont, NY 11003",
              "style":{ "fontSize":"14px","color":"#374151","lineHeight":1.6 }},
            { "type":"text","text":"📞 +1 347 481 3174",
              "style":{ "fontSize":"14px","color":"#374151" }},
            { "type":"text","text":"✉ yvesoxilus@gmail.com",
              "style":{ "fontSize":"14px","color":"#374151" }},
            { "type":"text","text":"🕒 Lun–Ven 9h–18h EST",
              "style":{ "fontSize":"14px","color":"#9ca3af" }},
            /* Map placeholder */
            { "type":"panel",
              "style":{ "width":"100%","height":"180px","background":"#f3f4f6",
                "borderRadius":"12px","display":"flex","alignItems":"center",
                "justifyContent":"center" },
              "children":[
                { "type":"text","text":"🗺️ Carte Google Maps",
                  "style":{ "fontSize":"13px","color":"#9ca3af" }}
              ]}
          ]},

        /* Formulaire de contact */
        { "type":"panel",
          "tag":"form",
          "attrs":{ "method":"POST","action":"/contact" },
          "style":{ "flex":1,"minWidth":"280px","background":"#f9fafb",
            "borderRadius":"16px","padding":"28px 24px",
            "display":"flex","flexDirection":"column","gap":"14px",
            "border":"1px solid #e5e7eb" },
          "children":[
            /* Nom */
            { "type":"formField","tag":"input",
              "field":{ "type":"text","name":"name","placeholder":"Votre nom",
                "required":true },
              "style":{ "padding":"10px 14px","border":"1px solid #e5e7eb",
                "borderRadius":"8px","fontSize":"14px","background":"#fff",
                "width":"100%","boxSizing":"border-box" }},
            /* Email */
            { "type":"formField","tag":"input",
              "field":{ "type":"email","name":"email","placeholder":"votre@email.com",
                "required":true },
              "style":{ "padding":"10px 14px","border":"1px solid #e5e7eb",
                "borderRadius":"8px","fontSize":"14px","background":"#fff",
                "width":"100%","boxSizing":"border-box" }},
            /* Sujet */
            { "type":"formField","tag":"select",
              "field":{ "name":"sujet" },
              "style":{ "padding":"10px 14px","border":"1px solid #e5e7eb",
                "borderRadius":"8px","fontSize":"14px","background":"#fff",
                "width":"100%","cursor":"pointer" },
              "options":[
                { "value":"commande","label":"Commande" },
                { "value":"produit","label":"Question produit" },
                { "value":"partenariat","label":"Partenariat" },
                { "value":"autre","label":"Autre" }
              ]},
            /* Message */
            { "type":"formField","tag":"textarea",
              "field":{ "name":"message","placeholder":"Votre message…",
                "rows":4,"required":true },
              "style":{ "padding":"10px 14px","border":"1px solid #e5e7eb",
                "borderRadius":"8px","fontSize":"14px","background":"#fff",
                "width":"100%","resize":"vertical","minHeight":"100px",
                "boxSizing":"border-box" }},
            /* Bouton envoi */
            { "type":"button","text":"Envoyer le message",
              "clickActionType":"function","clickActionFunction":"onFilterShop",
              "style":{ "padding":"12px 24px","background":"#6d28d9","color":"#fff",
                "border":"none","borderRadius":"10px","cursor":"pointer",
                "fontSize":"14px","fontWeight":700,"width":"100%" }}
          ]}
      ]}
  ]
}`}</Code>
        <Tip>{elakayAutoText("h_1924cbd7b65403", "En Page Builder, les formulaires sont visualisés mais non soumis dans l'éditeur. Le rendu via PageRenderer connecte les actions réelles à votre backend.")}</Tip>
      </div>
    </div>
  ),

  // ── EXPORT ──────────────────────────────────────────────────────────────────────
  export: () => (
    <div>
      <SectionTitle icon="📦" title={elakayAutoText("h_801a56805e8047", "Export / Import & API")}
        sub="Sauvegardez, partagez et déployez votre page." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_bc399052d42042", "Export JSON")}</h2>
        <p style={S.p}>{elakayAutoText("h_4fb24767d1fdb8", "Exporte le document complet (structure + styles + bindings) en fichier")}<code style={S.inlineCode}>.json</code>.</p>
        <Step n={1}>{elakayAutoText("h_a20338edbdc97c", "Barre du haut → bouton")}<b>{elakayAutoText("h_031a4e76f0b39d", "JSON")}</b>.</Step>
        <Step n={2}>{elakayAutoText("h_60bcb1508ce2b8", "Le fichier peut être rechargé via")}<b>{elakayAutoText("h_f54cfe90f7d2c7", "Importer")}</b>.</Step>
        <Tip>{elakayAutoText("h_d1e2d373470b61", "Sauvegardez régulièrement en JSON avant de faire des modifications importantes.")}</Tip>
      </div>
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_1a3b57bfbfd191", "Export HTML standalone")}</h2>
        <p style={S.p}>{elakayAutoText("h_fa0d7793cb48f5", "Génère une page HTML complète autonome avec le CSS intégré et les données de démo incluses.")}</p>
        <Step n={1}>{elakayAutoText("h_a20338edbdc97c", "Barre du haut → bouton")}<b>{elakayAutoText("h_9f738ce8457f29", "HTML")}</b>{elakayAutoText("h_88f2790f9c4f15", "(icône téléchargement).")}</Step>
        <Step n={2}>{elakayAutoText("h_e264b3e21d8478", "Le fichier HTML peut être ouvert directement dans un navigateur sans serveur.")}</Step>
      </div>
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_a30671e0cdff65", "Sauvegarde en base de données")}</h2>
        <p style={S.p}>{elakayAutoText("h_5975a70485e88e", "Pour sauvegarder en BD, le composant parent doit passer la prop")}<code style={S.inlineCode}>onSave</code>{elakayAutoText("h_ad190c14b4e12b", "à PageBuilder. Voir la section")}<b>{elakayAutoText("h_091f26953600b4", "💾 Sauvegarde en base de données")}</b>{elakayAutoText("h_da87b0ea434e43", "pour le détail complet.")}</p>
      </div>
    </div>
  ),

  // ── SAUVEGARDE BD ────────────────────────────────────────────────────────────────
  "save-btn": () => (
    <div>
      <SectionTitle icon="💾" title={elakayAutoText("h_0be78e4d84129a", "Bouton Sauvegarder / Modifier")}
        sub="Nouvelle page : Sauvegarder. Page utilisateur sélectionnée : Modifier le document existant." />

      <div style={{ ...S.card, background:"#f0fdf4", border:"1px solid #a7f3d0" }}>
        <h2 style={{ ...S.h2, color:"#065f46" }}>{elakayAutoText("h_fd2efffffe1c36", "Un bouton, deux états")}</h2>
        <p style={{ ...S.p, color:"#047857" }}>{elakayAutoText("h_d722ea0cd9e2ab", "Quand la prop")}<code style={S.inlineCode}>onSave</code>{elakayAutoText("h_c1f4c26e1775bd", "est présente, les trois emplacements suivent automatiquement")}<code style={S.inlineCode}>savedPageId</code> :</p>
        <PropTable rows={[
          { name:"Nouvelle page",      type:"💾 Sauvegarder", desc:"Crée un nouveau document MongoDB avec POST /pageBuilder" },
          { name:"Page sélectionnée",  type:"✏ Modifier",    desc:"Met à jour la page créée par l'utilisateur avec PATCH /pageBuilder/:id" },
          { name:"Topbar Partie 2",    type:"dynamique",     desc:"Affiche Sauvegarder ou Modifier selon savedPageId" },
          { name:"Tab Mes pages",      type:"dynamique",     desc:"Affiche le même état que les boutons de la topbar" },
          { name:"Métadonnées",        type:"bouton séparé", desc:"Ouvre le modal titre, prix, statut et options" },
        ]} />
      </div>

      <div style={{ ...S.card, background:"#f8fafc", border:"1px solid #cbd5e1" }}>
        <h2 style={{ ...S.h2, color:"#334155" }}>{elakayAutoText("h_7afdecde376cd6", "Règle des listes Shop")}</h2>
        <p style={{ ...S.p, color:"#475569" }}>{elakayAutoText("h_0833afde94546e", "Seules les boutiques de la liste")}<b>{elakayAutoText("h_4b3f024a2e1b35", "Créées")}</b>{elakayAutoText("h_058c4a4904e176", "peuvent être modifiées et sauvegardées. Les listes")}<b>{elakayAutoText("h_d2c7cc666bb624", "Achetées")}</b>, <b>{elakayAutoText("h_4550c68ee1cf77", "Par défaut")}</b>{elakayAutoText("h_a5bc1d9b2ae74e", "et")}<b>{elakayAutoText("h_6c2f2888c561e0", "Premium")}</b>{elakayAutoText("h_38622701f3b053", "s'ouvrent uniquement en aperçu, avec les panneaux d'édition et les boutons de sauvegarde désactivés.")}</p>
        <p style={{ ...S.p, color:"#475569" }}>{elakayAutoText("h_5a620a3b799aee", "Un utilisateur dont le rôle actif est")}<b>{elakayAutoText("h_4efb6cb7c018f0", "Developer")}</b>{elakayAutoText("h_75ed3657210312", "peut cliquer")}<b>{elakayAutoText("h_af3d455352aaa7", "\"Copier / modifier Developer\"")}</b>{elakayAutoText("h_7f81cae0a1ec10", ". Le modal demande le mot de passe du compte connecté, puis le serveur crée une copie indépendante et modifiable. La page originale reste inchangée.")}</p>
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_1dfe27782ab628", "Ce qui est sauvegarde automatiquement")}</h2>
        <p style={S.p}>{elakayAutoText("h_75d9fb3e79e6fa", "Au clic, le payload est construit automatiquement — aucune saisie requise :")}</p>
        <PropTable rows={[
          { name:"doc",         type:"object",  desc:"L'arbre JSON complet (toutes les sections, styles, bindings)" },
          { name:"title",       type:"string",  desc:"savedPage.title → doc.meta.title → pages[0].name → 'Ma page'" },
          { name:"description", type:"string",  desc:"savedPage.description ou doc.meta.description" },
          { name:"price",       type:"number",  desc:"savedPage.price ou prix auto des elements combines (si > 0)" },
          { name:"isTemplate",  type:"boolean", desc:"savedPage.isTemplate (false par defaut)" },
          { name:"forSale",     type:"boolean", desc:"savedPage.forSale (false par defaut)" },
          { name:"status",      type:"string",  desc:"savedPage.status ou 'draft'" },
          { name:"pageMode",    type:"string",  desc:"doc.pageMode — 'store' pour une boutique" },
        ]} />
        <Tip><code style={S.inlineCode}>savedPage</code>{elakayAutoText("h_175358093c481d", "contient le document MongoDB complet de la page sélectionnée.")}<code style={S.inlineCode}>initialDoc</code>{elakayAutoText("h_e85d73dbf0bc2f", "reste uniquement le JSON rendu par le builder.")}</Tip>
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_a1d37b1b070ae2", "Flux complet — premiere sauvegarde")}</h2>
        <Step n={1}><b>{elakayAutoText("h_073a862a0e3486", "Construire la page")}</b>{elakayAutoText("h_8632d65d14639f", "— au moins 1 element suffit.")}</Step>
        <Step n={2}><b>{elakayAutoText("h_b33af34b4500c2", "Cliquer \"Sauvegarder\"")}</b>{elakayAutoText("h_4dc10170ae0e64", "dans la topbar (Partie 1 ou 2) ou dans le tab \"Mes pages\".")}</Step>
        <Step n={3}><b>{elakayAutoText("h_0c0f6935af8c18", "Sauvegarde immediate")}</b>{elakayAutoText("h_635fddb097d961", "— bouton en etat de chargement pendant l'envoi a l'API.")}</Step>
        <Step n={4}><b>{elakayAutoText("h_089d563d804177", "Succes")}</b>{elakayAutoText("h_9f681650ae90ee", "— brouillon localStorage efface,")}<code style={S.inlineCode}>savedPageId</code>{elakayAutoText("h_100de724a7510b", "stocke, bouton devient")}<b>{elakayAutoText("h_8f60453da2d2fa", "\"Modifier\"")}</b>.</Step>
        <Step n={5}><b>{elakayAutoText("h_45f0c763f7972d", "Modifier les metadonnees")}</b>{elakayAutoText("h_0621d680f158e2", "— cliquer \"Métadonnées\" pour changer titre, prix et statut.")}</Step>
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_813a9c237a08ea", "Signature de la prop onSave")}</h2>
        <Code>{`// Dans le composant parent (index.jsx)
<PageBuilder
  onSave={async (payload) => {
    // payload auto-rempli : doc, title, price, status, pageMode…
    const saved = await savePageBuilder(payload, currentId, token);
    setSavedPageId(saved._id);
    return saved;
  }}
  savedPageId={savedPageId}   // _id MongoDB si deja sauvegarde
  savedPage={savedPageData}   // document MongoDB complet sélectionné
  myPages={myPages}           // liste pour le tab "Mes pages"
  onLoadPage={loadPageInBuilder}
  onEditInDb={() => setShowEditModal(true)}
  onRefreshPages={loadMyPages}
  onDeletePage={async (id) => { await deletePageBuilder(id, token); loadMyPages(); }}
/>`}</Code>
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_b9297ac0c26c54", "API REST — Endpoints pageBuilder")}</h2>
        <PropTable rows={[
          { name:"POST /pageBuilder",           type:"auth requis", desc:"Cree un nouveau document (quota : 3 max pour les vendeurs)" },
          { name:"GET  /pageBuilder/mine",       type:"auth requis", desc:"Liste les pages de l'utilisateur connecte" },
          { name:"GET  /pageBuilder/templates",  type:"public",      desc:"Liste les templates publies (isTemplate:true, status:published)" },
          { name:"GET  /pageBuilder/:id",        type:"auth requis", desc:"Recupere un document complet" },
          { name:"PATCH /pageBuilder/:id",       type:"auth requis", desc:"Met a jour le document (owner uniquement)" },
          { name:"DELETE /pageBuilder/:id",      type:"auth requis", desc:"Supprime le document (owner uniquement)" },
        ]} />
      </div>
    </div>
  ),

  "save-modal": () => (
    <div>
      <SectionTitle icon="✏" title={elakayAutoText("h_e68fe65c0c9c97", "Métadonnées — Modal d'édition")}
        sub="Après la sauvegarde, le bouton Métadonnées permet de modifier titre, prix et statut." />
      <div style={{ ...S.card, background:"#fffbeb", border:"1px solid #fcd34d" }}>
        <h2 style={{ ...S.h2, color:"#92400e" }}>{elakayAutoText("h_e467a8cc2446e8", "Le modal de sauvegarde a ete supprime")}</h2>
        <p style={{ ...S.p, color:"#78350f" }}>{elakayAutoText("h_ca22bb6a4562d6", "La sauvegarde est maintenant")}<b>{elakayAutoText("h_fd01e1719cf680", "directe et sans modal")}</b>{elakayAutoText("h_6d27e095f446a4", ". Un seul clic sur \"Sauvegarder\" suffit — les metadonnees sont auto-remplies depuis la page existante ou avec des valeurs par defaut.")}</p>
        <p style={{ ...S.p, color:"#78350f", margin:0 }}>{elakayAutoText("h_729562583792b3", "Pour modifier les métadonnées")}<em>{elakayAutoText("h_a1e9fc12ff46a8", "après")}</em>{elakayAutoText("h_4d358fd4489b89", "la sauvegarde, utilisez le bouton")}<b>{elakayAutoText("h_052264541a7ca9", "\"Métadonnées\"")}</b>{elakayAutoText("h_86394f597d72c9", "dans la topbar.")}</p>
      </div>
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_9db37d118e5996", "Modal d'edition — Champs disponibles")}</h2>
        <p style={S.p}>{elakayAutoText("h_f97378f8abd309", "Le bouton")}<b>{elakayAutoText("h_052264541a7ca9", "\"Métadonnées\"")}</b>{elakayAutoText("h_ddae516002c66a", "ouvre un modal dans")}<code style={S.inlineCode}>index.jsx</code>{elakayAutoText("h_074e2d491314ee", "pour modifier :")}</p>
        <PropTable rows={[
          { name:"Titre",        type:"string",   desc:"Nom affiche dans la liste 'Mes pages'" },
          { name:"Description",  type:"string",   desc:"Courte description optionnelle" },
          { name:"Prix ($)",     type:"number",   desc:"0 = gratuit · visible dans la galerie si forSale = true" },
          { name:"Statut",       type:"select",   desc:"draft (brouillon) | published (publie) | archived (archive)" },
          { name:"Tags",         type:"string[]", desc:"Mots-cles comma-separes : ex. mode, boutique, tech" },
          { name:"Template",     type:"checkbox", desc:"Marque comme template reutilisable par d'autres" },
          { name:"En vente",     type:"checkbox", desc:"Rend la page achetable dans la galerie publique" },
        ]} />
        <Warn>{elakayAutoText("h_fafde0784d5da6", "Ce modal est dans le composant parent")}<code style={S.inlineCode}>index.jsx</code>{elakayAutoText("h_e129dec7a7caca", ". Il n'est visible que si la page a deja un")}<code style={S.inlineCode}>savedPageId</code>.</Warn>
      </div>
    </div>
  ),

  "save-edit": () => (
    <div>
      <SectionTitle icon="✏" title={elakayAutoText("h_f003b4fd44132e", "Éditer une page existante en base de données")} />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_0e437fa507bc53", "Deux façons d'éditer")}</h2>
        <Step n={1}><b>{elakayAutoText("h_2d70ce922b8cf8", "Via le tab \"Mes pages\"")}</b>{elakayAutoText("h_a8afc4f56867d3", "— cliquer \"Sélectionner\". Le document complet est chargé depuis l'API et son")}<code style={S.inlineCode}>savedPageId</code>{elakayAutoText("h_740a792f66d8f3", "devient actif.")}</Step>
        <Step n={2}><b>{elakayAutoText("h_f2c66ff8f98045", "Via la topbar")}</b>{elakayAutoText("h_ec4451bc08eaf9", "— le bouton \"Sauvegarder\" devient automatiquement")}<b>{elakayAutoText("h_49be3df7edd4d7", "\"✏ Modifier\"")}</b>{elakayAutoText("h_d0127476ccce48", "et applique un PATCH sur cette page.")}</Step>
        <Tip>{elakayAutoText("h_aea6d40185e463", "Le bouton \"Métadonnées\" reste séparé pour modifier titre, prix, statut et options sans ambiguïté.")}</Tip>
      </div>
    </div>
  ),

  "save-mypages": () => (
    <div>
      <SectionTitle icon="📄" title={elakayAutoText("h_ee4ab53f72149a", "Tab Mes pages — Panneau gauche")} />
      <div style={S.card}>
        <p style={S.p}>{elakayAutoText("h_7f1d50ae6af1a2", "Le tab")}<b>{elakayAutoText("h_f8c29a367f1220", "\"Mes pages\"")}</b>{elakayAutoText("h_7e6a6f5ba4b30f", "dans le panneau gauche liste toutes vos pages sauvegardées en BD. Il nécessite que les props")}<code style={S.inlineCode}>myPages</code>, <code style={S.inlineCode}>onLoadPage</code>{elakayAutoText("h_a5bc1d9b2ae74e", "et")}<code style={S.inlineCode}>onRefreshPages</code>{elakayAutoText("h_0f505c90c7e7fc", "soient passés à PageBuilder.")}</p>
        <PropTable rows={[
          { name:"Sélectionner",type:"bouton bleu",  desc:"Charge le doc complet dans le builder et synchronise savedPageId" },
          { name:"✕",          type:"bouton rouge", desc:"Supprime la page en BD (appelle onDeletePage)" },
          { name:"↻",          type:"bouton",       desc:"Actualise la liste (appelle onRefreshPages)" },
          { name:"Page sélectionnée", type:"badge", desc:"Indique la page actuellement chargée et modifiable" },
        ]} />
        <Tip>{elakayAutoText("h_5a37f1bd114e36", "La liste")}<code style={S.inlineCode}>myPages</code>{elakayAutoText("h_c59a081b40f6e9", "est chargée au montage de index.jsx et actualisée automatiquement après chaque sauvegarde.")}</Tip>
      </div>
    </div>
  ),

  "save-draft": () => (
    <div>
      <SectionTitle icon="💾" title={elakayAutoText("h_d8d28e97794077", "Auto-save localStorage — Brouillon automatique")}
        sub="Le PageBuilder sauvegarde automatiquement le doc en cours dans le localStorage du navigateur : toutes les 10 minutes (filet de sécurité), et 30s après la dernière modification." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_181a99d68ae07f", "Fonctionnement")}</h2>
        <PropTable rows={[
          { name:"Intervalle",     type:"10 minutes",             desc:"Le doc est sauvegardé toutes les 10 min quelle que soit l'activité (configurable via AUTOSAVE_MS)" },
          { name:"Debounce",       type:"30 secondes",            desc:"Le doc est aussi sauvegardé 30s après la dernière modification d'un champ (configurable via AUTOSAVE_DEBOUNCE_MS)" },
          { name:"Clé localStorage",type:"pb_autosave_draft",     desc:"Contient le doc JSON complet" },
          { name:"Méta",           type:"pb_autosave_meta",       desc:"Contient { savedAt: timestamp } pour afficher l'heure de la dernière sauvegarde" },
          { name:"Indicateur",     type:"💾 il y a X min",        desc:"Affiché dans la topbar Partie 2 après la première auto-save" },
        ]} />
        <h2 style={S.h2}>{elakayAutoText("h_095ad6db012bf4", "Bannière de restauration")}</h2>
        <p style={S.p}>{elakayAutoText("h_a1e120edb8e5d6", "Au chargement du PageBuilder, si un brouillon existe dans le localStorage, une")}<b>{elakayAutoText("h_f8f8b531e94089", "bannière jaune")}</b>{elakayAutoText("h_26c45fbdcf89b3", "s'affiche avec trois actions :")}</p>
        <PropTable rows={[
          { name:"Restaurer", type:"bouton orange", desc:"Charge le brouillon dans le builder (remplace le doc courant)" },
          { name:"Ignorer",   type:"bouton",        desc:"Masque la bannière sans supprimer le brouillon" },
          { name:"Supprimer", type:"bouton rouge",  desc:"Efface définitivement le brouillon du localStorage" },
        ]} />
        <Tip>{elakayAutoText("h_0eb83ca426a973", "Le brouillon localStorage est automatiquement supprimé après une sauvegarde réussie en base de données.")}</Tip>
        <Warn>{elakayAutoText("h_a655152e243350", "Le localStorage a une limite de ~5 Mo. Les pages très complexes avec de nombreux bindings et images en base64 peuvent dépasser cette limite.")}</Warn>
      </div>
    </div>
  ),

  // ── TOGGLE ───────────────────────────────────────────────────────────────────────
  "toggle-how": () => (
    <div>
      <SectionTitle icon="⚙️" title={elakayAutoText("h_79129cf24b50ad", "Fonction Toggle — Principe & configuration")}
        sub="Lie plusieurs éléments dans un groupe exclusif : cliquer sur l'un active son style et désactive tous les autres." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_c05bafdb56031b", "Concept")}</h2>
        <p style={S.p}>{elakayAutoText("h_a87a0117539cf8", "La")}<b>{elakayAutoText("h_94ca4aaf3ec4bf", "fonction Toggle")}</b>{elakayAutoText("h_4c9d91e272e0dd", "est une propriété supplémentaire qu'on peut ajouter à")}<b>{elakayAutoText("h_28e05d75540ffa", "n'importe quel élément")}</b>{elakayAutoText("h_a1dde0a324221b", "(panel, container, bouton…). Quand elle est activée :")}</p>
        <Step n={1}>{elakayAutoText("h_abbc3520593165", "L'élément s'enregistre dans le DOM avec l'attribut")}<code style={S.inlineCode}>data-tg="groupId"</code>.</Step>
        <Step n={2}>{elakayAutoText("h_9a29a44baddc91", "Au clic, le")}<b>{elakayAutoText("h_c0f0c2c05cec7f", "style ACTIF")}</b>{elakayAutoText("h_180da04c198b3e", "s'applique à cet élément.")}</Step>
        <Step n={3}>{elakayAutoText("h_8b996b90ffd57c", "Tous les autres éléments du même groupe reçoivent le")}<b>{elakayAutoText("h_15440f553bf5ed", "style INACTIF")}</b>.</Step>
        <Tip>{elakayAutoText("h_9f5baa95485d65", "Les propriétés")}<code style={S.inlineCode}>color</code>, <code style={S.inlineCode}>fontWeight</code>{elakayAutoText("h_a5bc1d9b2ae74e", "et")}<code style={S.inlineCode}>fontSize</code>{elakayAutoText("h_8758fc965b8cb1", "sont automatiquement transmises au premier enfant texte (p, span, h1-h6) à l'intérieur de l'élément.")}</Tip>
      </div>
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_eb98cc0b369646", "Activer la fonction Toggle")}</h2>
        <Step n={1}>{elakayAutoText("h_b437d2bb58403d", "Sélectionner l'élément dans le Builder.")}</Step>
        <Step n={2}>{elakayAutoText("h_f2cd3117e575f8", "Panneau droit → onglet")}<b>{elakayAutoText("h_5376df989fac86", "Général")}</b>{elakayAutoText("h_e77985e80a5e93", "→ section")}<b>{elakayAutoText("h_216850d02778fb", "\"Fonction Toggle — Activer / Désactiver\"")}</b>.</Step>
        <Step n={3}>{elakayAutoText("h_90324d9ec02564", "Cliquer sur")}<b>{elakayAutoText("h_b139b2d145afd7", "\"Activer le toggle\"")}</b>.</Step>
        <Step n={4}>{elakayAutoText("h_e2937d3c889ecc", "Remplir les champs :")}<br/>— <b>{elakayAutoText("h_9a52416ba94ea7", "ID du groupe")}</b>{elakayAutoText("h_8a44ba7a4ecefe", ": même ID sur tous les éléments liés (ex.")}<code style={S.inlineCode}>catNav</code>)<br/>— <b>{elakayAutoText("h_e6d2356c777165", "Actif par défaut")}</b>{elakayAutoText("h_6d105c8695cb44", ": cet élément démarre actif au chargement")}<br/>— <b>{elakayAutoText("h_12bfab1157053b", "Style ACTIF")}</b>{elakayAutoText("h_55e967115dc5f8", ": styles CSS appliqués quand actif")}<br/>— <b>{elakayAutoText("h_3fd2f79120fa41", "Style INACTIF")}</b>{elakayAutoText("h_a89d40cba12a05", ": styles CSS appliqués quand un autre est actif")}</Step>
        <Code>{`// Structure stockée sur le nœud JSON
{
  "id": "btn1",
  "type": "panel",
  "toggleGroup": {
    "id": "catNav",
    "isDefault": true,
    "activeStyle":   { "background": "#111827", "color": "#fff" },
    "inactiveStyle": { "background": "#f9fafb", "color": "#374151" }
  }
}`}</Code>
      </div>
    </div>
  ),

  "toggle-auto": () => (
    <div>
      <SectionTitle icon="⚡" title={elakayAutoText("h_a2e1c635317f38", "Toggle — Bouton Auto-configure")} />
      <div style={S.card}>
        <p style={S.p}>{elakayAutoText("h_f97378f8abd309", "Le bouton")}<b>{elakayAutoText("h_290ef852d6f1b1", "\"⚡ Auto\"")}</b>{elakayAutoText("h_f2584117e4577f", "configure automatiquement le toggle sur")}<b>{elakayAutoText("h_32146e55d721c6", "tous les éléments frères")}</b>{elakayAutoText("h_b33df3941c30e9", "(siblings) du conteneur parent :")}</p>
        <Step n={1}><b>{elakayAutoText("h_fc329369a42315", "Activer le toggle")}</b>{elakayAutoText("h_17f077f4984fc5", "sur l'élément courant (ID groupe généré automatiquement).")}</Step>
        <Step n={2}><b>{elakayAutoText("h_7ea96883bdb11f", "Cliquer sur \"Auto\"")}</b>{elakayAutoText("h_5d4a53579e6710", "— le builder cherche le conteneur parent et configure :")}<br/>{elakayAutoText("h_8db63fb0d77fe0", "— Élément courant →")}<code style={S.inlineCode}>isDefault: true</code>{elakayAutoText("h_c28a3a9fdb5450", "(actif)")}<br/>{elakayAutoText("h_860cf32c729c68", "— Tous les frères →")}<code style={S.inlineCode}>isDefault: false</code>{elakayAutoText("h_52eb9c36aabced", "(inactifs)")}</Step>
        <Step n={3}>{elakayAutoText("h_e95582fbf8c29f", "Vérifier et ajuster les styles ACTIF/INACTIF si nécessaire.")}</Step>
        <Tip>{elakayAutoText("h_638b790646e3e1", "Parfait pour les onglets, pills de catégories, menus multi-boutons créés manuellement.")}</Tip>
      </div>
    </div>
  ),

  "toggle-check": () => (
    <div>
      <SectionTitle icon="☑" title={elakayAutoText("h_c53e7b230bc146", "Toggle — Sélection manuelle par checkboxes")} />
      <div style={S.card}>
        <p style={S.p}>{elakayAutoText("h_49de78d883b726", "Quand le toggle est activé sur un élément, la section affiche une")}<b>{elakayAutoText("h_63517e5301f9c9", "liste checkbox")}</b>{elakayAutoText("h_6fd925241c6f20", "de tous les éléments de la page. Cocher un élément l'ajoute au même groupe toggle (en tant qu'inactif) :")}</p>
        <PropTable rows={[
          { name:"Checkbox cochée", type:"in-group",  desc:"L'élément est dans le groupe — badge actif/inactif visible" },
          { name:"Badge map",       type:"jaune",     desc:"L'élément a un repeatBind — chaque instance répétée rejoint le groupe" },
          { name:"Décocher",        type:"remove",    desc:"Retire l'élément du groupe toggle" },
        ]} />
        <Warn>{elakayAutoText("h_2918b587521227", "Quand on ajoute un élément mapping (repeatBind) au groupe, chaque instance répétée dans le DOM s'enregistre automatiquement dans le groupe.")}</Warn>
      </div>
    </div>
  ),

  "toggle-cat": () => (
    <div>
      <SectionTitle icon="🏷️" title={elakayAutoText("h_b0ce1d6bfdb2d8", "catBar & catSidebar — Toggle pré-configuré")}
        sub="Les composants Barre catégories et Sidebar catégories sont livrés avec le toggle déjà configuré." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_08b2926a96b4be", "Insertion depuis les Composants custom")}</h2>
        <p style={S.p}>{elakayAutoText("h_fc724693f0e715", "Panneau gauche →")}<b>{elakayAutoText("h_0860e88d172f38", "Composants riches")}</b> → <b>{elakayAutoText("h_2c91acf59907c4", "Barre Catégories")}</b>{elakayAutoText("h_d5f10c9bc83706", "ou")}<b>{elakayAutoText("h_885ed73863554d", "Sidebar Catégories")}</b>.<br/>{elakayAutoText("h_74939f4a849e42", "Les deux composants sont insérés avec le toggle pré-configuré :")}</p>
        <PropTable rows={[
          { name:"Bouton Tout / Tout voir", type:"isDefault:true",  desc:"Actif par défaut — fond sombre, texte blanc" },
          { name:"Pill/Item catégorie",     type:"isDefault:false", desc:"Inactif — fond clair. Lié à store.categories.categories via repeatBind" },
          { name:"ID de groupe",            type:"cb-xxx / cs-xxx", desc:"Unique par instance (généré au moment de l'insertion)" },
        ]} />
        <Tip>{elakayAutoText("h_919e7b5dfe5a26", "Même group ID sur le bouton \"Tout\" et sur le repeatBind des catégories — ils forment automatiquement un groupe exclusif.")}</Tip>
        <Code>{`// Barre catégories (catBar) — structure simplifiée
section
  row (overflowX:auto)
    panel "Tout"        → toggleGroup { id:"cb-abc", isDefault:true  }
    panel "Catégorie"   → toggleGroup { id:"cb-abc", isDefault:false }
                          repeatBind  { source:"store", path:"categories.categories" }`}</Code>
      </div>
    </div>
  ),

  sauvegarde: () => (
    <div>
      <SectionTitle icon="💾" title={elakayAutoText("h_a30671e0cdff65", "Sauvegarde en base de données")}
        sub="Vue d'ensemble : bouton, modal, liste des pages et auto-save." />
      <div style={S.card}>
        <p style={S.p}>{elakayAutoText("h_0f67e14eb2a3a2", "Utilisez la navigation de gauche pour accéder à chaque sous-section détaillée :")}</p>
        <ul style={{ paddingLeft:"20px", lineHeight:2.0, fontSize:"14px", color:C.txt2 }}>
          <li><b>{elakayAutoText("h_0be78e4d84129a", "Bouton Sauvegarder / Modifier")}</b>{elakayAutoText("h_7cd7b1cb24a669", ": son état dépend de la page sélectionnée.")}</li>
          <li><b>{elakayAutoText("h_38da27bfda4d36", "Modal — titre, prix, options")}</b>{elakayAutoText("h_50640bc9cf2666", ": tous les champs du modal de sauvegarde.")}</li>
          <li><b>{elakayAutoText("h_dfee322a084b03", "Éditer une page existante")}</b>{elakayAutoText("h_2031e4abf7e7b5", ": mettre à jour depuis la topbar ou la liste.")}</li>
          <li><b>{elakayAutoText("h_c681d7911f30e1", "Tab Mes pages")}</b>{elakayAutoText("h_b49deb8a16c175", ": liste des pages en BD dans le panneau gauche.")}</li>
          <li><b>{elakayAutoText("h_e8a322eada2de9", "Auto-save localStorage")}</b>{elakayAutoText("h_3a0d31fc07fc65", ": brouillon automatique toutes les 5 minutes.")}</li>
        </ul>
      </div>
    </div>
  ),

  // ── GRILLE L × C ────────────────────────────────────────────────────────────────
  lxc: () => (
    <div>
      <SectionTitle icon="🔢" title={elakayAutoText("h_54179d875d5754", "Grille l × c — Sélecteur matriciel")}
        sub="Insère rapidement une mise en page en choisissant le nombre de lignes et de colonnes." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_0d6d1277b19666", "Où trouver le sélecteur")}</h2>
        <PropTable rows={[
          { name:"Topbar Partie 1",      type:"bouton l×c",    desc:"Bouton dédié → dropdown avec matrice visuelle + inputs personnalisés" },
          { name:"Panneau gauche",       type:"Composants riches", desc:"Sélecteur matriciel au sommet du groupe" },
        ]} />
        <h2 style={S.h2}>{elakayAutoText("h_7f7b95dd267ce4", "Comment l'utiliser")}</h2>
        <Step n={1}><b>{elakayAutoText("h_a0e045103f281b", "Via la matrice visuelle")}</b>{elakayAutoText("h_39f1a6e42285f8", "— survoler les cellules pour choisir l (lignes) × c (colonnes). La sélection est mise en violet. Cliquer pour insérer.")}</Step>
        <Step n={2}><b>{elakayAutoText("h_fcc2f08d575f73", "Via les inputs personnalisés")}</b>{elakayAutoText("h_6ea09514742b13", "(dropdown topbar) — saisir directement des valeurs")}<b>l &gt; 6</b>{elakayAutoText("h_d5f10c9bc83706", "ou")}<b>c &gt; 2</b>{elakayAutoText("h_70081275f4e1f1", "dans les champs numériques, puis cliquer \"Créer\".")}</Step>
        <h2 style={S.h2}>{elakayAutoText("h_5c0c4ab331be82", "Type d'élément inséré selon les dimensions")}</h2>
        <PropTable rows={[
          { name:"1 × c",  type:"row",   desc:"Conteneur flex horizontal — c panneaux côte à côte" },
          { name:"l × 1",  type:"stack", desc:"Conteneur flex vertical — l panneaux empilés" },
          { name:"l × c",  type:"grid",  desc:"CSS Grid — repeat(c, 1fr) — l×c cellules" },
        ]} />
        <Tip>{elakayAutoText("h_ea4c3855419896", "Chaque cellule insérée est un")}<code style={S.inlineCode}>container</code>{elakayAutoText("h_15772cfcf359bd", "avec padding et bordure légère, prêt à accueillir d'autres éléments.")}</Tip>
      </div>
    </div>
  ),

  // ── ÉLÉMENTS COMBINÉS ────────────────────────────────────────────────────────────
  combined: () => (
    <div>
      <SectionTitle icon="📦" title={elakayAutoText("h_de42c2afda15c7", "Éléments combinés")}
        sub="Sauvegardez un groupe d'éléments sous un nom et réutilisez-le en un clic." />
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_25751cb56241a6", "Créer un élément combiné")}</h2>
        <Step n={1}><b>{elakayAutoText("h_bad03d176652d0", "Sélectionner plusieurs éléments")}</b>{elakayAutoText("h_8aee34f59d850d", "dans le canevas (Shift+clic ou Ctrl+clic).")}</Step>
        <Step n={2}>{elakayAutoText("h_376f6b7a5476d7", "Panneau gauche → tab")}<b>{elakayAutoText("h_0048a692ae73a3", "\"Combinés\"")}</b>{elakayAutoText("h_e0d2ac31d3a428", "(icône dossier).")}</Step>
        <Step n={3}><b>{elakayAutoText("h_a081a9b6790ebc", "Nommer l'élément")}</b>{elakayAutoText("h_03148604553948", "dans le champ texte.")}</Step>
        <Step n={4}>{elakayAutoText("h_c08234377e6e7b", "Cliquer")}<b>{elakayAutoText("h_43a60982c69170", "\"Sauvegarder comme combiné\"")}</b>.</Step>
        <h2 style={S.h2}>{elakayAutoText("h_938a80bd7d0cc9", "Insérer un élément combiné")}</h2>
        <Step n={1}>{elakayAutoText("h_c4696302f0afb9", "Dans le tab")}<b>{elakayAutoText("h_0048a692ae73a3", "\"Combinés\"")}</b>{elakayAutoText("h_3350aaf1fbdece", ", trouver l'élément dans la bibliothèque.")}</Step>
        <Step n={2}>{elakayAutoText("h_c08234377e6e7b", "Cliquer")}<b>{elakayAutoText("h_9db8edea5ce173", "\"Insérer\"")}</b>{elakayAutoText("h_874bdb97efb3c8", "— les nœuds sont clonés avec de nouveaux IDs.")}</Step>
        <Tip>{elakayAutoText("h_6ac44008e0b367", "Les éléments combinés sont stockés dans")}<code style={S.inlineCode}>doc.combinedElements</code>{elakayAutoText("h_9598411c3a1727", "et sont sauvegardés avec le JSON complet de la page.")}</Tip>
      </div>
    </div>
  ),

  // ══════════════════════════════════════════════════════════════════════════════
  // GUIDE CREER UNE PAGE BOUTIQUE
  // ══════════════════════════════════════════════════════════════════════════════

  "boutique-guide": () => (
    <div>
      <SectionTitle icon="🛒" title={elakayAutoText("h_886c18cfd4eba4", "Guide complet — Creer une page boutique")}
        sub="Naviguez dans les sous-sections pour suivre chaque etape en detail." />
      <div style={S.card}>
        <p style={S.p}>{elakayAutoText("h_f39475fa8e70ea", "Ce guide vous accompagne de A a Z pour creer une boutique complete avec le Page Builder :")}</p>
        <ul style={{ paddingLeft:"20px", lineHeight:2.2, fontSize:"14px", color:C.txt2 }}>
          <li><b>{elakayAutoText("h_8549f178e9b087", "Etape 1 — Mode Boutique")}</b>{elakayAutoText("h_296620edc024e9", ": activer pageMode: store et comprendre les donnees disponibles.")}</li>
          <li><b>{elakayAutoText("h_649c7b99888ed9", "Etape 2 — Structure de la page")}</b>{elakayAutoText("h_7b34957b9a55c0", ": sections, hierarchy, squelette recommande.")}</li>
          <li><b>{elakayAutoText("h_740e20e70ca188", "Etape 3 — Hero et Slider")}</b>{elakayAutoText("h_67bd457614e65d", ": swiper lie a store.sliderShop.")}</li>
          <li><b>{elakayAutoText("h_6b5b323a4eee9b", "Etape 4 — Barre categories")}</b>{elakayAutoText("h_88b87f3fc8903b", ": catBar ou catSidebar avec toggle automatique.")}</li>
          <li><b>{elakayAutoText("h_91cd4e601a148a", "Etape 5 — Grille produits")}</b>{elakayAutoText("h_7a1bdb08c27afc", ": grid responsive + repeatBind + pagination.")}</li>
          <li><b>{elakayAutoText("h_7879ef346f2260", "Etape 6 — Sauvegarder / Modifier")}</b>{elakayAutoText("h_2619e98efd9da5", ": création initiale puis mise à jour de la page sélectionnée.")}</li>
        </ul>
        <Tip>{elakayAutoText("h_019d62581c5078", "Chaque etape est independante. Si vous avez deja un slider, passez directement a l'Etape 4.")}</Tip>
      </div>
    </div>
  ),

  "btq-overview": () => {
    const STEPS = [
      { n:1, icon:"🗂️", color:"#7c3aed", bg:"#f5f3ff", border:"#c4b5fd", title:elakayAutoText("h_29e6a7fe781a78", "Mode Boutique"),       sub:elakayAutoText("page_builder_help_store_mode", "Enable pageMode: store in the right panel") },
      { n:2, icon:"🏗️", color:"#0369a1", bg:"#e0f2fe", border:"#7dd3fc", title:elakayAutoText("h_70a07aff7f06eb", "Structure de la page"), sub:elakayAutoText("page_builder_help_structure", "Section > Row / Stack / Grid — page structure") },
      { n:3, icon:"🎠", color:"#b45309", bg:"#fffbeb", border:"#fbbf24", title:elakayAutoText("h_f031dfe457898c", "Hero et Slider"),       sub:elakayAutoText("page_builder_help_slider", "Swiper linked to store.sliderShop — full width") },
      { n:4, icon:"🏷️", color:"#059669", bg:"#f0fdf4", border:"#6ee7b7", title:elakayAutoText("h_6788c668cffad0", "Barre categories"),    sub:elakayAutoText("page_builder_help_categories", "catBar (horizontal) or catSidebar (vertical) — toggle included") },
      { n:5, icon:"📦", color:"#dc2626", bg:"#fff1f2", border:"#fca5a5", title:elakayAutoText("h_e5fec6eaf7bd44", "Grille produits"),     sub:elakayAutoText("page_builder_help_grid", "Responsive grid + repeatBind + previous / next pagination") },
      { n:6, icon:"💾", color:"#6d28d9", bg:"#ede9fe", border:"#a78bfa", title:elakayAutoText("h_2c2ef0228e5a1f", "Sauvegarder / Modifier"), sub:elakayAutoText("page_builder_help_save", "The button automatically follows the selected page") },
    ];
    return (
      <div>
        <SectionTitle icon="🛒" title={elakayAutoText("h_167f32961ac200", "Vue d'ensemble — 6 etapes pour une boutique complete")}
          sub="De la configuration du mode jusqu'a la sauvegarde finale." />

        {/* Roadmap */}
        <div style={{ ...S.card, background:"#1e1b4b", border:"none", padding:"24px" }}>
          <div style={{ fontSize:"11px", fontWeight:800, color:"#a5b4fc", textTransform:"uppercase", letterSpacing:"0.1em", marginBottom:"16px" }}>{elakayAutoText("h_7111546a08faef", "Feuille de route")}</div>
          <div style={{ display:"flex", flexDirection:"column", gap:"6px" }}>
            {STEPS.map((s, i) => (
              <div key={i} style={{ display:"flex", gap:"14px", alignItems:"center" }}>
                <div style={{ display:"flex", flexDirection:"column", alignItems:"center", flexShrink:0 }}>
                  <div style={{ width:"36px", height:"36px", borderRadius:"50%", background:s.bg, border:`2px solid ${s.border}`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"16px" }}>{s.icon}</div>
                  {i < STEPS.length-1 && <div style={{ width:"2px", height:"6px", background:"rgba(165,180,252,0.2)" }} />}
                </div>
                <div style={{ flex:1, background:"rgba(255,255,255,0.06)", borderRadius:"10px", padding:"10px 14px", border:"1px solid rgba(255,255,255,0.08)" }}>
                  <div style={{ fontSize:"13px", fontWeight:700, color:"#e0e7ff" }}>
                    <span style={{ color:s.border, marginRight:"6px" }}>{elakayAutoText("h_a68718a36131b6", "Etape")}{s.n}</span>{s.title}
                  </div>
                  <div style={{ fontSize:"11px", color:"#8b9cc8", marginTop:"2px" }}>{s.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Apercu final */}
        <div style={S.card}>
          <h2 style={S.h2}>{elakayAutoText("h_79ce819321c86f", "Resultat final — Boutique complete")}</h2>
          <div style={{ background:"#f8f9fa", borderRadius:"12px", border:"1px solid #e5e7eb", overflow:"hidden" }}>
            {/* Slider hero */}
            <div style={{ height:"80px", background:"linear-gradient(135deg,#1e1b4b,#4c1d95)", display:"flex", alignItems:"center", justifyContent:"center", position:"relative" }}>
              <div style={{ fontSize:"12px", fontWeight:700, color:"#e0e7ff" }}>{elakayAutoText("h_8a5c7cc7b21749", "Swiper Hero — store.sliderShop")}</div>
              <div style={{ position:"absolute", right:"12px", display:"flex", gap:"4px" }}>
                {[0,1,2].map(i=><div key={i} style={{ width:"6px", height:"6px", borderRadius:"50%", background:i===0?"#a78bfa":"rgba(255,255,255,0.3)" }}/>)}
              </div>
              <div style={{ position:"absolute", left:"10px", fontSize:"14px", color:"rgba(255,255,255,0.5)" }}>‹</div>
              <div style={{ position:"absolute", right:"10px", fontSize:"14px", color:"rgba(255,255,255,0.5)" }}>›</div>
            </div>
            {/* Stat band */}
            <div style={{ background:"#d4af37", padding:"8px 16px", display:"flex", justifyContent:"space-around" }}>
              {["4.8 / 5","248 produits","Livraison rapide"].map((t,i)=>(
                <span key={i} style={{ fontSize:"10px", fontWeight:700, color:"#0f172a" }}>{t}</span>
              ))}
            </div>
            {/* Cat bar */}
            <div style={{ background:"#fff", padding:"10px 16px", display:"flex", gap:"6px", borderBottom:"1px solid #f0f0f0" }}>
              {["Tout","Polo","Laptop","Tablet","Phone"].map((c,i)=>(
                <span key={i} style={{ padding:"5px 12px", borderRadius:"50px", fontSize:"10px", fontWeight:i===0?700:600, background:i===0?"#1a1a2e":"#f9fafb", color:i===0?"#fff":"#374151", border:i===0?"none":"1px solid #e5e7eb", flexShrink:0 }}>{c}</span>
              ))}
            </div>
            {/* Grid */}
            <div style={{ padding:"12px 16px" }}>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:"8px", marginBottom:"10px" }}>
                {["Polo $24","Laptop $899","Tank $18","Case $12"].map((p,i)=>(
                  <div key={i} style={{ background:"#fff", borderRadius:"8px", border:"1px solid #e5e7eb", overflow:"hidden" }}>
                    <div style={{ height:"50px", background:`hsl(${210+i*20},55%,88%)`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"9px", color:"#9ca3af" }}>{elakayAutoText("h_978ea7af39ad5f", "img")}</div>
                    <div style={{ padding:"6px 8px" }}>
                      <div style={{ fontSize:"9px", fontWeight:600, color:"#1a1a2e" }}>{p.split(" ")[0]}</div>
                      <div style={{ fontSize:"10px", fontWeight:800, color:"#6d28d9" }}>{p.split(" ")[1]}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ display:"flex", justifyContent:"space-between" }}>
                <span style={{ padding:"4px 10px", background:"#6d28d9", color:"#fff", borderRadius:"6px", fontSize:"9px", fontWeight:700 }}>{elakayAutoText("h_b962f0ffdefee4", "Precedent")}</span>
                <span style={{ fontSize:"10px", color:"#9ca3af" }}>{elakayAutoText("h_59d1c79956ca21", "Page 1 / 3")}</span>
                <span style={{ padding:"4px 10px", background:"#6d28d9", color:"#fff", borderRadius:"6px", fontSize:"9px", fontWeight:700 }}>{elakayAutoText("h_596d29a7e33c76", "Suivant")}</span>
              </div>
            </div>
          </div>
          <Tip>{elakayAutoText("h_f29933ce4e7351", "Cette boutique complete peut etre construite en moins de 10 minutes en suivant les 6 etapes ci-dessus.")}</Tip>
        </div>

        {/* Prerequis */}
        <div style={S.card}>
          <h2 style={S.h2}>{elakayAutoText("h_116c535e72d173", "Prerequis avant de commencer")}</h2>
          {[
            "Avoir un compte vendeur avec au moins 1 produit publie",
            "Avoir des images de slider configurees (optionnel mais recommande)",
            "Avoir des categories creees dans votre boutique",
            "Etre connecte — la sauvegarde necessite un token d'authentification",
          ].map((r,i)=>(
            <div key={i} style={{ display:"flex", gap:"10px", marginBottom:"8px", alignItems:"flex-start" }}>
              <span style={{ color:C.green, flexShrink:0, fontSize:"14px" }}>✓</span>
              <span style={{ fontSize:"13px", color:C.txt2 }}>{r}</span>
            </div>
          ))}
        </div>
      </div>
    );
  },

  "btq-step1": () => (
    <div>
      <SectionTitle icon="🗂️" title={elakayAutoText("h_452d966fd2d2ee", "Etape 1 — Choisir le Mode Boutique (store)")}
        sub="Le mode 'store' determine quelles donnees sont disponibles. C'est la premiere chose a configurer." />

      <div style={{ ...S.card, borderLeft:`4px solid ${C.purple}` }}>
        <h2 style={S.h2}>{elakayAutoText("h_6ea0cb5a5f447c", "Ou trouver le reglage dans l'interface")}</h2>
        {/* Mockup UI */}
        <div style={{ background:"#f0f0f0", borderRadius:"10px", padding:"12px", marginBottom:"16px" }}>
          <div style={{ display:"flex", gap:"8px" }}>
            <div style={{ width:"130px", background:"#1e1b4b", borderRadius:"8px", padding:"10px", flexShrink:0 }}>
              <div style={{ fontSize:"8px", color:"#a5b4fc", fontWeight:700, marginBottom:"8px" }}>{elakayAutoText("h_c5057c4b1f7aa9", "PANNEAU GAUCHE")}</div>
              {["Elements","Calques","Pages","Boutique","Live","Mes pages"].map((t,i)=>(
                <div key={i} style={{ padding:"3px 6px", fontSize:"8px", color:"#7c8cba", marginBottom:"2px" }}>{t}</div>
              ))}
            </div>
            <div style={{ flex:1, background:"#ffffff", borderRadius:"8px", display:"flex", alignItems:"center", justifyContent:"center", border:"1px solid #e5e7eb" }}>
              <div style={{ fontSize:"11px", color:"#d1d5db", textAlign:"center" }}>
                <div style={{ fontSize:"18px", marginBottom:"4px" }}>👆</div>{elakayAutoText("h_97b82f264cb63c", "Zone vide du canevas")}</div>
            </div>
            <div style={{ width:"160px", background:"#fff", borderRadius:"8px", border:`2px solid ${C.purple}`, padding:"10px", flexShrink:0 }}>
              <div style={{ fontSize:"8px", color:C.purple, fontWeight:700, marginBottom:"6px" }}>{elakayAutoText("h_eb0545eb8e7071", "PANNEAU DROIT ← ICI")}</div>
              <div style={{ fontSize:"8px", color:"#9ca3af", marginBottom:"8px" }}>{elakayAutoText("h_09cfc8af5d7395", "Aucun element selectionne")}</div>
              <div style={{ padding:"6px 8px", background:"#f5f3ff", borderRadius:"6px", border:`1px solid ${C.border}` }}>
                <div style={{ fontSize:"8px", color:C.purple, fontWeight:700, marginBottom:"4px" }}>{elakayAutoText("h_7470fd880522f4", "Mode de page")}</div>
                <div style={{ padding:"4px 8px", background:"#6d28d9", borderRadius:"4px", display:"flex", gap:"4px", alignItems:"center" }}>
                  <span style={{ fontSize:"8px", color:"#fff", fontWeight:700 }}>{elakayAutoText("h_ae64243512289a", "Boutique (store)")}</span>
                  <span style={{ fontSize:"8px", color:"#a78bfa" }}>✓</span>
                </div>
              </div>
            </div>
          </div>
          <div style={{ textAlign:"center", marginTop:"8px", fontSize:"10px", color:"#6b7280" }}>{elakayAutoText("h_ce152337a4d7f0", "Cliquer dans une zone vide du canevas pour voir les reglages globaux dans le panneau droit")}</div>
        </div>
        <Step n={1} title={elakayAutoText("h_937ac1e3462cba", "Deselectionner tout")}>{elakayAutoText("h_c97bf18860d6c3", "Cliquez dans une zone")}<b>{elakayAutoText("h_32ff28e3fabd4d", "vide")}</b>{elakayAutoText("h_afdfad90541111", "du canevas (pas sur un element). Le panneau droit passe en mode \"Reglages de la page\".")}</Step>
        <Step n={2} title={elakayAutoText("h_ff00face33298e", "Trouver Mode de page")}>{elakayAutoText("h_aaecd18c631fbd", "Dans le panneau droit, faites defiler jusqu'a la section")}<b>{elakayAutoText("h_7a9a937855efa3", "\"Mode de page\"")}</b>.</Step>
        <Step n={3} title={elakayAutoText("h_96764038912f1d", "Choisir Boutique (store)")}>{elakayAutoText("h_487bfa491a7a52", "Cliquez sur")}<b>{elakayAutoText("h_05def31b011457", "\"Boutique (store)\"")}</b>{elakayAutoText("h_1506837c2a9a48", "dans la liste des modes.")}</Step>
        <Step n={4} title={elakayAutoText("h_d6e8c9a5659e5a", "Verifier la selection")}>{elakayAutoText("h_2107a22b1f3ed7", "Le mode apparait en violet. Les donnees boutique (")}<code style={S.inlineCode}>store.*</code>{elakayAutoText("h_22577bacc4750d", ") sont maintenant disponibles pour le binding.")}</Step>
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_abb2f421e259b8", "Donnees disponibles en mode store")}</h2>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"8px" }}>
          {[
            { key:"store.owner.shopName.0",     desc:"Nom de la boutique" },
            { key:"store.sliderShop",            desc:"Images du slider hero" },
            { key:"store.products",              desc:"Liste de tous les produits" },
            { key:"store.categories.categories", desc:"Liste des categories" },
            { key:"store.siseProductAll",         desc:"Nombre total de produits" },
            { key:"store.products.0.name",        desc:"Nom du 1er produit" },
            { key:"store.products.0.price",       desc:"Prix du 1er produit" },
            { key:"store.products.0.Stars",       desc:"Note etoiles du 1er produit" },
          ].map(({key, desc}, i)=>(
            <div key={i} style={{ padding:"8px 10px", background:"#fafafa", borderRadius:"7px", border:`1px solid ${C.border}` }}>
              <code style={{ ...S.inlineCode, display:"block", marginBottom:"2px", fontSize:"10px" }}>{key}</code>
              <span style={{ fontSize:"10px", color:C.txt2 }}>{desc}</span>
            </div>
          ))}
        </div>
        <Tip>{elakayAutoText("h_00570f0bc49e3e", "Chargez un dataset de demo dans")}<b>{elakayAutoText("h_321b9d65ccb442", "Donnees → Source de donnees")}</b>{elakayAutoText("h_90a5f4bbb3e31f", "pour voir les donnees reelles dans le builder avant de publier.")}</Tip>
      </div>

      <div style={{ background:"#f0fdf4", border:"1px solid #a7f3d0", borderRadius:"12px", padding:"16px" }}>
        <div style={{ fontWeight:700, color:"#065f46", marginBottom:"8px" }}>{elakayAutoText("h_05eef6eaa9688d", "Checklist Etape 1 terminee")}</div>
        {["Mode regle sur 'Boutique (store)'","Donnees store.* disponibles","Pret a construire la structure"].map((t,i)=>(
          <div key={i} style={{ fontSize:"12px", color:"#047857", marginBottom:"3px" }}>✓ {t}</div>
        ))}
      </div>
    </div>
  ),

  "btq-step2": () => (
    <div>
      <SectionTitle icon="🏗️" title={elakayAutoText("h_649c7b99888ed9", "Etape 2 — Structure de la page")}
        sub="Construire le squelette de la boutique : sections empilees de haut en bas." />

      <div style={{ ...S.card, borderLeft:`4px solid #0369a1` }}>
        <h2 style={S.h2}>{elakayAutoText("h_b3f8d56d485736", "Architecture recommandee — 5 sections")}</h2>
        {/* Wireframe visuel */}
        <div style={{ background:"#f8f9fa", borderRadius:"12px", border:"2px dashed #d1d5db", padding:"10px", display:"flex", flexDirection:"column", gap:"6px" }}>
          {[
            { n:1, label:elakayAutoText("h_379c0dacf2ce62", "Section Hero Slider"),           height:"70px",  bg:"linear-gradient(135deg,#1e1b4b,#4c1d95)", color:"#a5b4fc", tag:"swiper · bindSource: store.sliderShop" },
            { n:2, label:elakayAutoText("h_185ab840e71209", "Section Stat Band"),              height:"36px",  bg:"#d4af37",  color:"#0f172a", tag:"row · 3 stats statiques (produits, note, livraison)" },
            { n:3, label:elakayAutoText("h_93c690bce2b18d", "Section Barre categories (catBar)"), height:"44px", bg:"#ffffff", color:"#374151", tag:"catBar · repeatBind: store.categories.categories" },
            { n:4, label:elakayAutoText("h_34c7fbb34a70a5", "Section Vedettes (shopCatMatrix)"), height:"70px", bg:"#f9fafb", color:"#6d28d9", tag:"shopCatMatrix · bindSource: store.categories" },
            { n:5, label:elakayAutoText("h_4079083ac4556d", "Section Grille produits + pagination"), height:"90px", bg:"#eff6ff", color:"#1d4ed8", tag:"grid 4 cols · repeatBind: store.products · pageSize: 12" },
          ].map(({n, label, height, bg, color, tag})=>(
            <div key={n} style={{ height, background:bg, borderRadius:"8px", padding:"0 14px", display:"flex", alignItems:"center", gap:"12px" }}>
              <div style={{ width:"22px", height:"22px", borderRadius:"50%", background:"rgba(255,255,255,0.25)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"10px", fontWeight:700, color, flexShrink:0 }}>{n}</div>
              <div>
                <div style={{ fontSize:"11px", fontWeight:700, color }}>{label}</div>
                <div style={{ fontSize:"9px", color, opacity:0.75 }}>{tag}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_86909fd8be4c97", "Comment construire le squelette")}</h2>
        <Step n={1} title={elakayAutoText("h_bbd38bc012f178", "Ouvrir une nouvelle page")}>{elakayAutoText("h_aa26a0e5136d7c", "Panneau gauche → onglet")}<b>{elakayAutoText("h_600584c2d5ccb9", "Pages")}</b>{elakayAutoText("h_0a585a6eb091cb", "→ cliquer")}<b>{elakayAutoText("h_1f9e5ef1ad4fe1", "\"+ Nouvelle page\"")}</b>{elakayAutoText("h_f3f32ee98b0fd3", ". Ou utiliser la page vide existante.")}</Step>
        <Step n={2} title={elakayAutoText("h_9293ad6510445e", "Ajouter Section 1 (Hero)")}>{elakayAutoText("h_fc724693f0e715", "Panneau gauche →")}<b>{elakayAutoText("h_a563972e807d43", "Elements")}</b> → <b>{elakayAutoText("h_f09e7eee2eefe8", "Mise en page")}</b> → <b>{elakayAutoText("h_f2c6b564bd8119", "Section")}</b>{elakayAutoText("h_2d15d0b76fabcd", ". Styliser avec height: 400px, background sombre.")}</Step>
        <Step n={3} title={elakayAutoText("h_bb445e5e900afc", "Ajouter les autres sections")}>{elakayAutoText("h_719634d6acdb29", "Repeter pour chaque section en dessous. Chaque section est un conteneur pleine largeur.")}</Step>
        <Step n={4} title={elakayAutoText("h_f1a76027b086a3", "Reordonner via Calques")}>{elakayAutoText("h_aa26a0e5136d7c", "Panneau gauche → onglet")}<b>{elakayAutoText("h_960ea4f847b6bc", "Calques")}</b>{elakayAutoText("h_de9f49fe00dffa", "→ glisser les sections dans l'ordre voulu.")}</Step>
        <Tip>{elakayAutoText("h_bd6b7ca7807474", "Alternativement, chargez le template")}<b>{elakayAutoText("h_4232e9dd0710bd", "Boutique Classique")}</b>{elakayAutoText("h_79c7ec1b882d83", "(bouton Templates) — il contient cette structure pre-construite. Personnalisez-la ensuite.")}</Tip>
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_fb59cd38857a22", "JSON — Structure de base")}</h2>
        <Code>{`{
  "pageMode": "store",
  "pages": [{
    "name": "Ma Boutique",
    "children": [
      /* 1 Hero Slider */
      { "type":"section", "children":[
        { "type":"swiper","bindSource":"store.sliderShop",
          "options":{"autoplay":true,"interval":5000,"height":"400px"} }
      ]},
      /* 2 Stat Band */
      { "type":"banner","style":{"background":"#d4af37","padding":"12px 48px",
          "display":"flex","justifyContent":"space-around"},
        "children":[
          {"type":"stat","content":{"value":"248","label":"Produits","valueColor":"#0f172a"}},
          {"type":"stat","content":{"value":"4.8","label":"Note","valueColor":"#0f172a"}},
          {"type":"stat","content":{"value":"100%","label":"Satisfaits","valueColor":"#0f172a"}}
        ]},
      /* 3 catBar — voir Etape 4 */
      { "type":"section","style":{"padding":"8px 32px"},
        "children":[ /* inserer catBar ici */ ]},
      /* 4 shopCatMatrix */
      { "type":"section","style":{"padding":"32px 48px"},
        "children":[
          {"type":"shopCatMatrix","bindSource":"store.categories",
            "options":{"title":"Produits en vedette","nbrArr":4}}
        ]},
      /* 5 Grille produits — voir Etape 5 */
      { "type":"section","style":{"padding":"32px 48px"},
        "children":[ /* inserer grid ici */ ]}
    ]
  }]
}`}</Code>
      </div>
    </div>
  ),

  "btq-step3": () => (
    <div>
      <SectionTitle icon="🎠" title={elakayAutoText("h_740e20e70ca188", "Etape 3 — Hero et Slider")}
        sub="Le carrousel d'images pleine largeur lie aux slides de votre boutique." />

      {/* Apercu visuel */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_a358c03e02f641", "Apercu du resultat")}</h2>
        <div style={{ borderRadius:"12px", overflow:"hidden", border:"1px solid #e5e7eb" }}>
          <div style={{ height:"160px", background:"linear-gradient(135deg,#1e1b4b 0%,#4c1d95 50%,#1d4ed8 100%)", display:"flex", alignItems:"center", justifyContent:"center", position:"relative" }}>
            <div style={{ textAlign:"center" }}>
              <div style={{ fontSize:"18px", fontWeight:800, color:"#fff", marginBottom:"6px" }}>{elakayAutoText("h_6566abf40e68b8", "Bienvenue dans ma boutique")}</div>
              <div style={{ fontSize:"11px", color:"#a5b4fc" }}>{elakayAutoText("h_f20aa31178b158", "Decouvrez nos produits exceptionnels")}</div>
            </div>
            <div style={{ position:"absolute", left:"14px", width:"28px", height:"28px", background:"rgba(255,255,255,0.2)", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"14px", color:"#fff", cursor:"pointer" }}>&#8249;</div>
            <div style={{ position:"absolute", right:"14px", width:"28px", height:"28px", background:"rgba(255,255,255,0.2)", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"14px", color:"#fff", cursor:"pointer" }}>&#8250;</div>
            <div style={{ position:"absolute", bottom:"10px", display:"flex", gap:"5px" }}>
              {[1,2,3].map(i=><div key={i} style={{ width:"7px", height:"7px", borderRadius:"50%", background:i===1?"#fff":"rgba(255,255,255,0.35)" }}/>)}
            </div>
          </div>
        </div>
        <p style={{ ...S.p, marginTop:"10px", fontSize:"12px", color:C.txt3 }}>{elakayAutoText("h_01bbf77f18c14d", "Swiper lie a")}<code style={S.inlineCode}>store.sliderShop</code>{elakayAutoText("h_954f2faca5d956", "— les images changent automatiquement toutes les 5 secondes")}</p>
      </div>

      <div style={{ ...S.card, borderLeft:`4px solid #b45309` }}>
        <h2 style={S.h2}>{elakayAutoText("h_5648fab2995dd9", "Chemin pour ajouter le slider")}</h2>
        <Step n={1} title={elakayAutoText("h_1690fd5510d8b3", "Ajouter un Swiper")}>{elakayAutoText("h_fc724693f0e715", "Panneau gauche →")}<b>{elakayAutoText("h_0860e88d172f38", "Composants riches")}</b> → <b>{elakayAutoText("h_01f35dddf5b806", "Swiper")}</b>{elakayAutoText("h_4950d965abdcc0", ". Il s'insere dans la section selectionnee.")}</Step>
        <Step n={2} title={elakayAutoText("h_dabff97396c4e9", "Lier a store.sliderShop")}>{elakayAutoText("h_0c4b059b711f8b", "Selectionner le Swiper → Panneau droit → onglet")}<b>{elakayAutoText("h_def2eba5956295", "Mapping")}</b>{elakayAutoText("h_09e726130f04bf", "→ champ")}<b>{elakayAutoText("h_f0f76ad847e1f5", "bindSource")}</b>{elakayAutoText("h_717a9eb7d84c05", ": saisir")}<code style={S.inlineCode}>store.sliderShop</code>.</Step>
        <Step n={3} title={elakayAutoText("h_4d345fde39cefd", "Configurer l'autoplay")}>{elakayAutoText("h_f2cd3117e575f8", "Panneau droit → onglet")}<b>{elakayAutoText("h_9239ee2cda84ec", "General")}</b> → <b>{elakayAutoText("h_9b394bd933ab91", "Options Swiper")}</b>{elakayAutoText("h_a5feabdcd172ec", "→ activer")}<b>{elakayAutoText("h_95619b532fe893", "Autoplay")}</b>{elakayAutoText("h_a7a9ee83c0fdf9", ", regler l'intervalle a")}<b>{elakayAutoText("h_f1a0be72549069", "5000ms")}</b>.</Step>
        <Step n={4} title={elakayAutoText("h_291223c6151909", "Regler la hauteur")}>{elakayAutoText("h_49ea28a6de6e6c", "Style →")}<b>{elakayAutoText("h_255cbd69a277a0", "Hauteur")}</b> : <code style={S.inlineCode}>400px</code>{elakayAutoText("h_38e2d7f16e4f04", "(desktop). En mode Mobile, reduire a")}<code style={S.inlineCode}>220px</code>{elakayAutoText("h_6df2705815c319", "via mobileStyle.")}</Step>
      </div>

      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_76fd2156924365", "Options de configuration du Swiper")}</h2>
        <PropTable rows={[
          { name:"bindSource", type:"string",  desc:"'store.sliderShop' — lie le swiper aux slides de la boutique" },
          { name:"autoplay",   type:"boolean", desc:"true = defilement automatique" },
          { name:"interval",   type:"number",  desc:"Duree entre les slides en ms (ex: 5000 = 5s)" },
          { name:"height",     type:"string",  desc:"Hauteur du carrousel (ex: '400px', '60vh')" },
          { name:"showArrows", type:"boolean", desc:"Afficher les fleches de navigation" },
          { name:"showDots",   type:"boolean", desc:"Afficher les points de navigation en bas" },
        ]} />
        <Code>{`{ "type": "swiper",
  "bindSource": "store.sliderShop",
  "options": {
    "autoplay": true,
    "interval": 5000,
    "height": "400px",
    "showArrows": true,
    "showDots": true
  },
  "style": { "width": "100%" }
}`}</Code>
      </div>

      <div style={{ background:"#fffbeb", border:"1px solid #fcd34d", borderRadius:"12px", padding:"14px" }}>
        <div style={{ fontWeight:700, color:"#92400e", marginBottom:"8px" }}>{elakayAutoText("h_3d03e5e48fd63d", "Checklist Etape 3")}</div>
        {["Swiper ajoute dans la Section 1","bindSource = store.sliderShop configure","Autoplay et hauteur regle","Pret pour Etape 4 : categories"].map((t,i)=>(
          <div key={i} style={{ fontSize:"12px", color:"#78350f", marginBottom:"3px" }}>✓ {t}</div>
        ))}
      </div>
    </div>
  ),

  "btq-step4": () => (
    <div>
      <SectionTitle icon="🏷️" title={elakayAutoText("h_cc2ca47db6d79e", "Etape 4 — Barre categories (catBar)")}
        sub="Navigation par categories avec etat actif/inactif automatique." />

      {/* Choix catBar ou catSidebar */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_cb3b0093fc0e9f", "Choisir le style de navigation")}</h2>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"14px" }}>
          {/* catBar */}
          <div style={{ border:`2px solid #059669`, borderRadius:"10px", overflow:"hidden" }}>
            <div style={{ background:"#059669", padding:"6px 10px" }}>
              <div style={{ fontSize:"10px", fontWeight:700, color:"#fff" }}>{elakayAutoText("h_e6d622e141675b", "catBar — Horizontal (recommande)")}</div>
            </div>
            <div style={{ background:"#fff", padding:"10px 12px" }}>
              <div style={{ display:"flex", gap:"5px" }}>
                {["Tout","Polo","Laptop","Phone"].map((c,i)=>(
                  <span key={i} style={{ padding:"5px 10px", borderRadius:"50px", fontSize:"9px", fontWeight:i===0?700:600, background:i===0?"#1a1a2e":"#f9fafb", color:i===0?"#fff":"#374151", border:i===0?"none":"1px solid #e5e7eb", flexShrink:0 }}>{c}</span>
                ))}
              </div>
            </div>
            <div style={{ padding:"5px 12px", background:"#f0fdf4", fontSize:"9px", color:"#065f46" }}>{elakayAutoText("h_c5f7826fbbd992", "Scroll horizontal · Pills · Compact · Bas du slider")}</div>
          </div>
          {/* catSidebar */}
          <div style={{ border:`2px solid #6d28d9`, borderRadius:"10px", overflow:"hidden" }}>
            <div style={{ background:"#6d28d9", padding:"6px 10px" }}>
              <div style={{ fontSize:"10px", fontWeight:700, color:"#fff" }}>{elakayAutoText("h_b7f972c16cf391", "catSidebar — Vertical")}</div>
            </div>
            <div style={{ background:"#1a1a2e", padding:"10px 12px", display:"flex", flexDirection:"column", gap:"4px" }}>
              {["Tout voir","Polo Shirts","Laptops"].map((c,i)=>(
                <span key={i} style={{ padding:"5px 10px", borderRadius:"6px", fontSize:"9px", fontWeight:i===0?700:500, background:i===0?"#d4af37":"transparent", color:i===0?"#0f172a":"#6b7280", border:i===0?"none":"1px solid #2a3050" }}>{c}</span>
              ))}
            </div>
            <div style={{ padding:"5px 12px", background:"#f5f3ff", fontSize:"9px", color:"#5b21b6" }}>{elakayAutoText("h_ff7c8ef5af4d77", "Cote gauche · Boutons · Layout avec sidebar (template Premium)")}</div>
          </div>
        </div>
      </div>

      {/* Chemin catBar */}
      <div style={{ ...S.card, borderLeft:`4px solid #059669` }}>
        <h2 style={S.h2}>{elakayAutoText("h_0a7e4592cf95b3", "Chemin pour ajouter catBar")}</h2>
        <Step n={1} title={elakayAutoText("h_c36b0da933538e", "Selectionner la Section 3")}>{elakayAutoText("h_6acd5223d04313", "Cliquer sur la Section 3 (vide) dans le canevas.")}</Step>
        <Step n={2} title={elakayAutoText("h_fd8ced6722bf84", "Inserer depuis Composants riches")}>{elakayAutoText("h_fc724693f0e715", "Panneau gauche →")}<b>{elakayAutoText("h_0860e88d172f38", "Composants riches")}</b>{elakayAutoText("h_0a585a6eb091cb", "→ cliquer")}<b>{elakayAutoText("h_b686353219659f", "\"Barre Categories\"")}</b>{elakayAutoText("h_26d1a4e4557104", ". L'element s'insere dans la section.")}</Step>
        <Step n={3} title={elakayAutoText("h_7caa66a517a377", "Verifier la configuration auto")}>{elakayAutoText("h_2bf9711929d7ff", "La catBar est pre-configuree :")}<br/>{elakayAutoText("h_94b7897289a225", "— Bouton \"Tout\" : fonction")}<code style={S.inlineCode}>loadProductsByArrival_</code>{elakayAutoText("h_d32bfa688e186e", ", actif par defaut")}<br/>{elakayAutoText("h_60cffa73c58b65", "— Panel categorie : repeatBind sur")}<code style={S.inlineCode}>store.categories.categories</code><br/>{elakayAutoText("h_c0510e73885bf6", "— Toggle groupe automatique (actif/inactif au clic)")}</Step>
        <Step n={4} title={elakayAutoText("h_8fcf11feee604d", "Personnaliser les couleurs")}>{elakayAutoText("h_267da9f5f8cbc5", "Selectionner le bouton \"Tout\" → modifier background et color. Le toggle detecte ces couleurs automatiquement.")}</Step>
        <Warn>{elakayAutoText("h_19be0266b2bcb1", "Ne pas changer l'ID du groupe toggle (cb-xxx) — il doit etre identique sur le bouton \"Tout\" et sur le repeatBind des categories.")}</Warn>
      </div>

      {/* Comportement toggle */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_025d626f0b96e2", "Comportement Toggle — Automatique")}</h2>
        <div style={{ display:"flex", flexDirection:"column", gap:"8px" }}>
          {[
            { label:elakayAutoText("h_f746ebb1fc9b53", "Clic sur 'Tout'"),        desc:"Active Tout, desactive toutes les categories + filtre tous les produits", color:"#059669" },
            { label:elakayAutoText("h_45372b762a666d", "Clic sur une categorie"), desc:"Active la categorie, desactive Tout + les autres + filtre les produits de cette categorie", color:"#6d28d9" },
            { label:elakayAutoText("h_e5330e5532c9a0", "Survie au re-render"),    desc:"Memorise via data-* attributes — resiste aux rechargements React", color:"#0369a1" },
          ].map(({label, desc, color},i)=>(
            <div key={i} style={{ padding:"10px 12px", background:"#fafafa", borderRadius:"8px", border:`1px solid ${C.border}`, display:"flex", gap:"12px" }}>
              <div style={{ width:"10px", background:color, borderRadius:"4px", flexShrink:0 }} />
              <div>
                <div style={{ fontSize:"12px", fontWeight:700, color, marginBottom:"3px" }}>{label}</div>
                <div style={{ fontSize:"11px", color:C.txt2 }}>{desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* catSidebar layout */}
      <div style={{ ...S.card, borderLeft:`4px solid #6d28d9` }}>
        <h2 style={S.h2}>{elakayAutoText("h_9241d47b2c667d", "Utiliser catSidebar a la place (template Premium)")}</h2>
        <Step n={1}>{elakayAutoText("h_70d1edf5277fdd", "Remplacer Section 3 par une")}<b>{elakayAutoText("h_36baa5fac1553f", "Ligne (Row)")}</b>{elakayAutoText("h_84c87a11e6df5a", "avec")}<code style={S.inlineCode}>alignItems: flex-start</code>.</Step>
        <Step n={2}>{elakayAutoText("h_fc724693f0e715", "Panneau gauche →")}<b>{elakayAutoText("h_0860e88d172f38", "Composants riches")}</b> → <b>{elakayAutoText("h_dc9d094125dd4a", "\"Sidebar Categories\"")}</b>{elakayAutoText("h_fc08aa62f32b4b", ". Insere a gauche du Row.")}</Step>
        <Step n={3}>{elakayAutoText("h_cfebd97ee6deca", "Ajouter la grille produits (Etape 5) a droite dans le meme Row avec")}<code style={S.inlineCode}>flex: 1</code>.</Step>
        <Code>{`/* Layout sidebar + grille */
{ "type": "row",
  "style": { "display":"flex","alignItems":"flex-start","gap":"0" },
  "children": [
    { /* catSidebar (200px fixe, a gauche) */ },
    { "type":"section","style":{"flex":1,"padding":"24px 32px"},
      "children":[ /* grille produits (Etape 5) */ ]}
  ]
}`}</Code>
      </div>
    </div>
  ),

  "btq-step5": () => {
    return (
    <div>
      <SectionTitle icon="📦" title={elakayAutoText("h_e3d896db44f388", "Etape 5 — Grille produits et pagination")}
        sub="La grille responsive liee a store.products avec navigation entre les pages de resultats." />

      {/* Apercu visuel */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_a358c03e02f641", "Apercu du resultat")}</h2>
        <div style={{ background:"#f9fafb", borderRadius:"12px", border:"1px solid #e5e7eb", padding:"14px" }}>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:"10px", marginBottom:"12px" }}>
            {[
              { name:"Polo Classic", price:"$24",  img:"#bfdbfe" },
              { name:"Laptop Pro",   price:"$899", img:"#c7d2fe" },
              { name:"Tank Top",     price:"$18",  img:"#ddd6fe" },
              { name:"Phone Case",   price:"$12",  img:"#e9d5ff" },
              { name:"Smart Watch",  price:"$199", img:"#fce7f3" },
              { name:"Hoodie XL",    price:"$55",  img:"#fee2e2" },
              { name:"Tablet 10",    price:"$349", img:"#fef3c7" },
              { name:"Cap Navy",     price:"$22",  img:"#d1fae5" },
            ].map(({name, price, img},i)=>(
              <div key={i} style={{ background:"#fff", borderRadius:"10px", border:"1px solid #e5e7eb", overflow:"hidden", boxShadow:"0 1px 4px rgba(0,0,0,0.06)" }}>
                <div style={{ height:"60px", background:img, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"11px", color:"#9ca3af" }}>{elakayAutoText("h_978ea7af39ad5f", "img")}</div>
                <div style={{ padding:"7px 9px" }}>
                  <div style={{ fontSize:"9px", fontWeight:600, color:"#1a1a2e", marginBottom:"3px", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{name}</div>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                    <span style={{ fontSize:"11px", fontWeight:800, color:"#6d28d9" }}>{price}</span>
                    <span style={{ width:"18px", height:"18px", background:"#6d28d9", color:"#fff", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"11px" }}>+</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
            <span style={{ padding:"6px 14px", background:"#6d28d9", color:"#fff", borderRadius:"8px", fontSize:"10px", fontWeight:600 }}>{elakayAutoText("h_b962f0ffdefee4", "Precedent")}</span>
            <span style={{ fontSize:"11px", color:"#9ca3af" }}>{elakayAutoText("h_e5297919788143", "Page 1 / 3 · 24 produits")}</span>
            <span style={{ padding:"6px 14px", background:"#6d28d9", color:"#fff", borderRadius:"8px", fontSize:"10px", fontWeight:600 }}>{elakayAutoText("h_596d29a7e33c76", "Suivant")}</span>
          </div>
        </div>
      </div>

      {/* Chemin */}
      <div style={{ ...S.card, borderLeft:`4px solid #dc2626` }}>
        <h2 style={S.h2}>{elakayAutoText("h_419cdedc1c98cc", "Chemin pour construire la grille")}</h2>
        <Step n={1} title={elakayAutoText("h_e16343fbf08fef", "Ajouter la Grille")}>{elakayAutoText("h_fc724693f0e715", "Panneau gauche →")}<b>{elakayAutoText("h_a563972e807d43", "Elements")}</b> → <b>{elakayAutoText("h_f09e7eee2eefe8", "Mise en page")}</b> → <b>{elakayAutoText("h_25ee2ce6183c01", "Grille")}</b>{elakayAutoText("h_ea0e917d569446", ". Elle s'insere dans la Section 5.")}</Step>
        <Step n={2} title={elakayAutoText("h_626bb71194de03", "Configurer les colonnes")}>{elakayAutoText("h_999469deb440f3", "Selectionner la grille → Panneau droit →")}<b>{elakayAutoText("h_53a2544cacfd92", "Colonnes")}</b> : <b>4</b>{elakayAutoText("h_0a585a6eb091cb", "→ cliquer")}<b>{elakayAutoText("h_af9bda467fedfe", "\"Responsive auto\"")}</b>{elakayAutoText("h_523b9edbf54fde", "(genere mobile=1, tablet=2, laptop=3, desktop=4).")}</Step>
        <Step n={3} title={elakayAutoText("h_54f7cf2956ae09", "Ajouter la carte produit")}>{elakayAutoText("h_fc724693f0e715", "Panneau gauche →")}<b>{elakayAutoText("h_17f7d2e97463bf", "Panneau")}</b>{elakayAutoText("h_c269c8ff73c0dd", ". Un panneau s'ajoute dans la grille. Ce panneau est le gabarit de chaque produit.")}</Step>
        <Step n={4} title={elakayAutoText("h_dee84c57bac337", "Configurer repeatBind sur la carte")}>{elakayAutoText("h_0f1ae2b62065bb", "Selectionner le panneau enfant → Panneau droit →")}<b>{elakayAutoText("h_def2eba5956295", "Mapping")}</b> → <b>{elakayAutoText("h_711ba373a79d31", "Repetition")}</b>{elakayAutoText("h_47db04907300f5", "→ Source:")}<code style={S.inlineCode}>store</code>{elakayAutoText("h_8450ae60fd9471", ", Chemin:")}<code style={S.inlineCode}>products</code>{elakayAutoText("h_6c9b5c8bafa094", ", Pagination: oui, Taille: 12.")}</Step>
        <Step n={5} title={elakayAutoText("h_849abcea920f6e", "Ajouter les elements de la carte")}>{elakayAutoText("h_6c9cd932721d3d", "Dans le panneau, ajouter :")}<br/>— <b>{elakayAutoText("h_50e19fda0d5b4b", "Image")}</b>{elakayAutoText("h_c4379cf92ddbb9", "(bindKey: galeriesID.galeries.0.urlImg.0)")}<br/>— <b>{elakayAutoText("h_83e5a0d3d2ef19", "Stack")}</b>{elakayAutoText("h_84c87a11e6df5a", "avec")}<b>{elakayAutoText("h_eb97899aedcd56", "Titre")}</b>{elakayAutoText("h_7744c90ab7a57c", "(bindKey: name) +")}<b>{elakayAutoText("h_730ca1b85d2a6a", "shopVote")}</b> + <b>{elakayAutoText("h_753762fc71c27a", "shopPrice")}</b><br/>— <b>{elakayAutoText("h_fd5aea7172cc0a", "Bouton")}</b>{elakayAutoText("h_75b6e40d299b6e", "\"+\" avec action")}<code style={S.inlineCode}>addToCart</code></Step>
        <Step n={6} title={elakayAutoText("h_e57c5fc1e4ebb1", "Ajouter la pagination")}>{elakayAutoText("h_fc724693f0e715", "Panneau gauche →")}<b>{elakayAutoText("h_65c821a596ceec", "Live")}</b> → <b>{elakayAutoText("h_100325b8d6de92", "Pagination")}</b>{elakayAutoText("h_7de3c952b88615", ". Se sync automatiquement avec la grille. Ou ajouter manuellement 2 boutons avec fonctions")}<code style={S.inlineCode}>loadMore0</code>{elakayAutoText("h_a5bc1d9b2ae74e", "et")}<code style={S.inlineCode}>loadMore</code>.</Step>
      </div>

      {/* Types de cartes */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_cfd409839220ac", "Types de cartes disponibles")}</h2>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:"10px", marginBottom:"12px" }}>
          {[
            { label:elakayAutoText("h_42db0605e8cfe6", "Portrait (standard)"), icon:"📱", desc:"Image en haut · contenu en bas · flexDirection:column", color:"#6d28d9" },
            { label:elakayAutoText("h_713d39da083475", "Paysage (landscape)"), icon:"🖥️", desc:"Image a gauche · contenu a droite · flexDirection:row", color:"#0369a1" },
            { label:elakayAutoText("h_da1f2ceb104354", "Case Card (riche)"),   icon:"⭐", desc:"vote etoiles, prix & remise, orientation toggle, pagination", color:"#059669" },
          ].map(({label, icon, desc, color},i)=>(
            <div key={i} style={{ padding:"12px", background:"#fafafa", borderRadius:"10px", border:`1px solid ${C.border}` }}>
              <div style={{ fontSize:"20px", marginBottom:"6px" }}>{icon}</div>
              <div style={{ fontSize:"12px", fontWeight:700, color, marginBottom:"4px" }}>{label}</div>
              <div style={{ fontSize:"10px", color:C.txt2 }}>{desc}</div>
            </div>
          ))}
        </div>
        <p style={{ ...S.p, fontSize:"12px" }}>{elakayAutoText("h_ce8b634f9d0a97", "Les composants")}<b>{elakayAutoText("h_2f758a81cf2035", "Case Card")}</b>{elakayAutoText("h_a5bc1d9b2ae74e", "et")}<b>{elakayAutoText("h_939ca08b3cca00", "Case Grid")}</b>{elakayAutoText("h_81e5311f68e435", "sont dans Composants riches — ils incluent deja vote, prix, remise, orientation et pagination.")}</p>
      </div>

      {/* JSON */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_36f7c6e8b42b5d", "JSON complet — Grille 4 colonnes responsive")}</h2>
        <Code>{`{
  "type": "section",
  "style": { "padding":"32px 48px","background":"#fff" },
  "children": [
    { "type":"heading","text":"Nos Produits","tag":"h2",
      "style":{"fontSize":"24px","fontWeight":800,"color":"#111827","margin":"0 0 24px"}},

    /* Grille responsive 4 cols */
    { "type":"grid",
      "options":{
        "columns": 4,
        "deviceGrid":[
          {"device":"mobile","columns":1,"gap":"12px"},
          {"device":"tablet","columns":2,"gap":"14px"},
          {"device":"laptop","columns":3,"gap":"16px"},
          {"device":"desktop","columns":4,"gap":"16px"}
        ]
      },
      "children":[{
        "type":"panel",
        "repeatBind":{
          "source":"store","path":"products",
          "mode":"children","autoFill":true,
          "paginate":true,"pageSize":12
        },
        "style":{
          "background":"#fff","borderRadius":"16px","border":"1px solid #e5e7eb",
          "overflow":"hidden","display":"flex","flexDirection":"column",
          "boxShadow":"0 2px 10px rgba(0,0,0,0.07)"
        },
        "children":[
          {"type":"image","bindKey":"galeriesID.galeries.0.urlImg.0",
            "style":{"width":"100%","height":"200px","objectFit":"cover"}},
          {"type":"stack",
            "style":{"padding":"12px 14px","display":"flex","flexDirection":"column","gap":"8px","flex":1},
            "children":[
              {"type":"heading","bindKey":"name","tag":"h3",
                "style":{"fontSize":"14px","fontWeight":600,"color":"#111827","margin":0,
                  "whiteSpace":"nowrap","overflow":"hidden","textOverflow":"ellipsis"}},
              {"type":"shopVote"},
              {"type":"shopPrice"},
              {"type":"button","text":"+ Panier",
                "clickActionType":"function","clickActionFunction":"addToCart",
                "style":{"padding":"8px","background":"#6d28d9","color":"#fff",
                  "border":"none","borderRadius":"8px","cursor":"pointer","fontSize":"12px","fontWeight":700}}
            ]}
        ]
      }]
    },

    /* Pagination */
    {"type":"shopButtonPagination",
      "style":{"padding":"24px 0","display":"flex","justifyContent":"space-between"}}
  ]
}`}</Code>
      </div>
    </div>
    );
  },

  "btq-step6": () => (
    <div>
      <SectionTitle icon="💾" title={elakayAutoText("h_d3bc3f6cc44993", "Etape 6 — Sauvegarder / Modifier en base de données")}
        sub="Le bouton crée une nouvelle page ou modifie automatiquement la page utilisateur sélectionnée." />

      {/* Localisation des boutons */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_f2fbbaf0696782", "Les 3 emplacements du bouton dynamique")}</h2>
        <div style={{ background:"#f0f0f0", borderRadius:"10px", padding:"12px" }}>
          {/* Topbar Partie 1 */}
          <div style={{ background:"#1e1b4b", borderRadius:"8px", padding:"9px 14px", display:"flex", alignItems:"center", gap:"6px", marginBottom:"6px", flexWrap:"wrap" }}>
            <span style={{ fontSize:"8px", color:"#7c8cba" }}>{elakayAutoText("h_83fce832741084", "Logo")}</span>
            <span style={{ fontSize:"8px", color:"#7c8cba" }}>{elakayAutoText("h_532c67fe1b5afa", "Desktop")}</span>
            <span style={{ fontSize:"8px", color:"#7c8cba" }}>{elakayAutoText("h_b1d702459399a2", "Mobile")}</span>
            <span style={{ flex:1, fontSize:"8px", color:"#4c4d7a" }}>...</span>
            <span style={{ padding:"4px 10px", background:"#2563eb", borderRadius:"6px", fontSize:"8px", fontWeight:700, color:"#fff", border:"2px solid #fff" }}>{elakayAutoText("h_2c2ef0228e5a1f", "Sauvegarder / Modifier")}</span>
            <span style={{ fontSize:"8px", color:"#a5b4fc" }}>{elakayAutoText("h_a0c22dfdddb176", "Topbar Partie 1")}</span>
          </div>
          {/* Topbar Partie 2 */}
          <div style={{ background:"#2d2a5a", borderRadius:"8px", padding:"7px 14px", display:"flex", alignItems:"center", gap:"6px", marginBottom:"6px" }}>
            <span style={{ padding:"3px 8px", background:"#9333ea", borderRadius:"5px", fontSize:"8px", color:"#fff" }}>{elakayAutoText("h_0860e88d172f38", "Composants riches")}</span>
            <span style={{ flex:1, fontSize:"8px", color:"#6d5c9a" }}>{elakayAutoText("h_99113fb3241b0c", "Auto-save...")}</span>
            <span style={{ padding:"4px 10px", background:"#2563eb", borderRadius:"6px", fontSize:"8px", fontWeight:700, color:"#fff" }}>{elakayAutoText("h_2c2ef0228e5a1f", "Sauvegarder / Modifier")}</span>
            <span style={{ fontSize:"8px", color:"#a5b4fc" }}>{elakayAutoText("h_38abe77f4e251a", "Topbar Partie 2")}</span>
          </div>
          {/* Tab Mes pages */}
          <div style={{ display:"flex", gap:"8px" }}>
            <div style={{ background:"#1e1b4b", borderRadius:"8px", padding:"10px", width:"140px", flexShrink:0 }}>
              {["Elements","Calques","Pages","Boutique","Live"].map((t,i)=>(
                <div key={i} style={{ padding:"3px 6px", fontSize:"8px", color:"#4c4d7a", marginBottom:"1px" }}>{t}</div>
              ))}
              <div style={{ padding:"3px 6px", fontSize:"8px", color:"#e0e7ff", background:"#312e81", borderRadius:"4px", marginBottom:"4px" }}>{elakayAutoText("h_16c551be41249f", "Mes pages")}</div>
              <div style={{ padding:"5px 8px", background:"#2563eb", borderRadius:"5px", fontSize:"8px", fontWeight:700, color:"#fff", textAlign:"center" }}>{elakayAutoText("h_2c2ef0228e5a1f", "Sauvegarder / Modifier")}</div>
            </div>
            <div style={{ fontSize:"10px", color:"#6b7280", paddingTop:"4px" }}>{elakayAutoText("h_fe06eb6459c87f", "Tab")}<b style={{ color:"#1a1a2e" }}>{elakayAutoText("h_f8c29a367f1220", "\"Mes pages\"")}</b>{elakayAutoText("h_d2c149c49f4797", "dans")}<br/>{elakayAutoText("h_5f76dca0bc2fde", "le panneau gauche")}</div>
          </div>
        </div>
      </div>

      {/* Flux */}
      <div style={{ ...S.card, borderLeft:`4px solid #6d28d9` }}>
        <h2 style={S.h2}>{elakayAutoText("h_dcc3aa689ecc6d", "Flux de sauvegarde — 1 seul clic")}</h2>
        <Step n={1} title={elakayAutoText("h_e6013ae75dac6f", "Cliquer 'Sauvegarder'")}>{elakayAutoText("h_406503d1475cf9", "Dans la topbar (Partie 1 ou 2) ou dans le tab \"Mes pages\".")}<b>{elakayAutoText("h_ca14e045a9c8cf", "Aucun modal ne s'ouvre.")}</b></Step>
        <Step n={2} title={elakayAutoText("h_6312ea6c140338", "Sauvegarde automatique")}>{elakayAutoText("h_58afa753484ce2", "Chargement en cours. Les metadonnees sont auto-remplies : titre depuis la page, statut 'draft', prix calcule.")}</Step>
        <Step n={3} title={elakayAutoText("h_3424edc2354c7c", "Confirmation")}>{elakayAutoText("h_67d1ad6606c74d", "La page reçoit un")}<code style={S.inlineCode}>_id</code>{elakayAutoText("h_3eafd3ddc798a9", "MongoDB. Le bouton devient")}<b>{elakayAutoText("h_8f60453da2d2fa", "\"Modifier\"")}</b>.</Step>
        <Step n={4} title={elakayAutoText("h_42e8605cd56008", "Sélection d'une page")}>{elakayAutoText("h_0c6b9993676668", "Dans \"Mes pages\", cliquer \"Sélectionner\" : le JSON complet est chargé et le bouton affiche")}<b>{elakayAutoText("h_8f60453da2d2fa", "\"Modifier\"")}</b>.</Step>
        <Step n={5} title={elakayAutoText("h_8b717b58035531", "Modifier les métadonnées")}>{elakayAutoText("h_c08234377e6e7b", "Cliquer")}<b>{elakayAutoText("h_052264541a7ca9", "\"Métadonnées\"")}</b>{elakayAutoText("h_ef1ccd9e253226", "dans la topbar pour changer titre, prix et statut.")}</Step>
      </div>

      {/* Apres sauvegarde */}
      <div style={S.card}>
        <h2 style={S.h2}>{elakayAutoText("h_00c43fa3a52faf", "Apres la sauvegarde")}</h2>
        <PropTable rows={[
          { name:"Bouton Modifier",    type:"visible",   desc:"Met à jour le JSON complet de la page sélectionnée sans créer de doublon" },
          { name:"Métadonnées",        type:"visible",   desc:"Permet de modifier titre, prix et statut dans un modal séparé" },
          { name:"Brouillon efface",  type:"auto",      desc:"Le brouillon localStorage (pb_autosave_draft) est supprime apres une sauvegarde reussie" },
          { name:"Tab Mes pages",     type:"mis a jour", desc:"La page apparaît dans la liste avec boutons Sélectionner et Supprimer" },
          { name:"Quota utilise",     type:"compteur",  desc:"Le compteur de pages disponibles diminue selon le role" },
        ]} />
      </div>

      {/* Quotas */}
      <div style={{ background:"#fff7ed", border:"1px solid #fed7aa", borderRadius:"12px", padding:"16px", marginBottom:"12px" }}>
        <div style={{ fontWeight:700, color:"#c2410c", marginBottom:"10px" }}>{elakayAutoText("h_5f908a40bcba4f", "Quotas de sauvegarde par role")}</div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"8px" }}>
          {[
            { role:"Vendeur (Seller)",     max:"3 pages max",  color:"#dc2626" },
            { role:"Editeur (Associate)",  max:"30 pages max", color:"#d97706" },
            { role:"Développeur (Developer)",     max:"Illimite",     color:"#059669" },
            { role:"Admin",                max:"Illimite",     color:"#6d28d9" },
          ].map(({role, max, color},i)=>(
            <div key={i} style={{ padding:"8px 12px", background:"#fff", borderRadius:"8px", border:`1px solid ${C.border}`, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <span style={{ fontSize:"11px", color:C.txt2 }}>{role}</span>
              <span style={{ fontSize:"12px", fontWeight:700, color }}>{max}</span>
            </div>
          ))}
        </div>
        <p style={{ fontSize:"11px", color:"#9a3412", margin:"10px 0 0" }}>{elakayAutoText("h_641e5e5b41ad31", "Si la limite est atteinte, supprimez une page dans le tab \"Mes pages\" avant d'en creer une nouvelle.")}</p>
      </div>

      {/* Checklist finale */}
      <div style={{ background:"#f0fdf4", border:"1px solid #a7f3d0", borderRadius:"12px", padding:"16px" }}>
        <div style={{ fontWeight:700, color:"#065f46", marginBottom:"10px" }}>{elakayAutoText("h_6892ef0c750083", "Boutique complete — Checklist finale")}</div>
        {[
          "Mode pageMode: store configure",
          "Structure 5 sections construite",
          "Swiper hero lie a store.sliderShop",
          "catBar ou catSidebar avec toggle actif",
          "Grille 4 cols avec repeatBind + pagination",
          "Sauvegarde reussie en base de donnees",
        ].map((t,i)=>(
          <div key={i} style={{ fontSize:"12px", color:"#047857", marginBottom:"4px" }}>✓ {t}</div>
        ))}
      </div>
    </div>
  ),
};

// ─── Fallback pour sections non-implémentées ─────────────────────────────────────
const FallbackSection = ({ id }) => (
  <div style={{ padding:"40px", textAlign:"center", color:C.txt3 }}>
    <div style={{ fontSize:"32px", marginBottom:"12px" }}>🚧</div>
    <div style={{ fontSize:"14px" }}>{elakayAutoText("h_f2c6b564bd8119", "Section")}<code style={S.inlineCode}>{id}</code>{elakayAutoText("h_4f3fdcb2906d02", "— contenu en cours de rédaction.")}</div>
  </div>
);

// ═══════════════════════════════════════════════════════════════════════════════
// COMPOSANT PRINCIPAL
// ═══════════════════════════════════════════════════════════════════════════════
export default function PageBuilderHelp({ onClose, mode }) {
  const isBoutique = mode === "boutique";
  const [activeId, setActiveId] = useState(isBoutique ? "btq-overview" : "intro");
  const [expanded, setExpanded] = useState(
    isBoutique
      ? { elements:true, animations:true, links:false, data:false, templates:true, "boutique-guide":true }
      : { elements:true, animations:true, links:false, data:false, templates:true }
  );
  const [search, setSearch] = useState("");
  const rightRef = useRef(null);

  const toggle = (id) => setExpanded(p => ({ ...p, [id]: !p[id] }));

  const navigate = useCallback((id) => {
    setActiveId(id);
    if (rightRef.current) rightRef.current.scrollTo({ top:0, behavior:"smooth" });
  }, []);

  // En mode boutique : cacher les enfants contentPage/project dans templates
  const SELLER_HIDDEN = new Set(["tpl-content", "tpl-invest"]);
  const visibleNav = isBoutique
    ? NAV.map(s =>
        s.id === "templates" && s.children
          ? { ...s, children: s.children.filter(c => !SELLER_HIDDEN.has(c.id)) }
          : s
      )
    : NAV;

  const Content = SECTIONS[activeId] || (() => <FallbackSection id={activeId} />);

  // Filter navigation by search
  const matchSearch = (label) => !search || label.toLowerCase().includes(search.toLowerCase());

  return (
    <div style={{ display:"flex", height:"100%", background:C.bg, fontFamily:"'DM Sans',system-ui,sans-serif", position:"relative" }}>

      {/* ── SIDEBAR GAUCHE (30%) ─────────────────────────────────────────────── */}
      <aside style={{
        width:"30%", minWidth:"240px", maxWidth:"320px",
        background:C.sidebar, display:"flex", flexDirection:"column",
        borderRight:`1px solid ${C.sideBdr}`, flexShrink:0, overflowY:"auto",
      }}>
        {/* Header sidebar */}
        <div style={{ padding:"16px 18px 12px", borderBottom:`1px solid ${C.sideBdr}`, flexShrink:0 }}>
          <div style={{ fontSize:"10px", fontWeight:700, color:C.sideTxt, textTransform:"uppercase", letterSpacing:"1.5px", marginBottom:"2px" }}>Elakay</div>
          <div style={{ fontSize:"14px", fontWeight:800, color:"#e0e7ff", marginBottom:"12px" }}>{elakayAutoText("h_cac38908247de3", "Guide Page Builder")}</div>
          <input
            value={search} onChange={e => setSearch(e.target.value)}
            placeholder={elakayAutoText("h_1d12cdfbd87a1c", "Rechercher…")}
            style={{ width:"100%", padding:"6px 10px", borderRadius:"7px", border:`1px solid ${C.sideBdr}`, background:"#13113a", color:"#e0e7ff", fontSize:"12px", outline:"none", boxSizing:"border-box" }}
          />
        </div>

        {/* Navigation */}
        <nav style={{ flex:1, padding:"8px 0" }}>
          {visibleNav.map((section) => {
            const isActive = activeId === section.id;
            const isOpen = expanded[section.id];
            const hasChildren = section.children?.length > 0;

            if (!matchSearch(section.label) && !section.children?.some(c => matchSearch(c.label))) return null;

            return (
              <div key={section.id}>
                {/* Section header */}
                <button
                  onClick={() => { hasChildren ? toggle(section.id) : navigate(section.id); if (!hasChildren && section.id !== activeId) {} }}
                  style={{
                    width:"100%", display:"flex", alignItems:"center", gap:"8px",
                    padding:"9px 18px", background:isActive && !hasChildren ? C.sideAct : "transparent",
                    borderTop:"none", borderRight:"none", borderBottom:"none", borderLeft:`3px solid ${isActive && !hasChildren ? C.sideTxt : "transparent"}`,
                    cursor:"pointer", textAlign:"left", color: isActive && !hasChildren ? C.sideActT : C.sideTxt,
                    fontSize:"12px", fontWeight: isActive && !hasChildren ? 700 : 500,
                  }}
                >
                  <span style={{ fontSize:"14px", flexShrink:0 }}>{section.icon}</span>
                  <span style={{ flex:1 }}>{section.label}</span>
                  {hasChildren && <span style={{ fontSize:"9px", opacity:0.6 }}>{isOpen ? "▼" : "▶"}</span>}
                </button>

                {/* Children */}
                {hasChildren && (isOpen || search) && section.children
                  .filter(c => matchSearch(c.label))
                  .map(child => {
                    const cActive = activeId === child.id;
                    return (
                      <button key={child.id}
                        onClick={() => navigate(child.id)}
                        style={{
                          width:"100%", display:"flex", alignItems:"center", gap:"8px",
                          padding:"7px 18px 7px 40px", background:cActive ? C.sideAct : "transparent",
                          borderTop:"none", borderRight:"none", borderBottom:"none", borderLeft:`3px solid ${cActive ? "#818cf8" : "transparent"}`,
                          cursor:"pointer", textAlign:"left",
                          color: cActive ? "#e0e7ff" : "#7c8cba",
                          fontSize:"11px", fontWeight: cActive ? 600 : 400,
                        }}
                      >
                        <span style={{ width:"5px", height:"5px", borderRadius:"50%", background:cActive ? "#818cf8" : "#374168", flexShrink:0 }} />
                        {child.label}
                      </button>
                    );
                  })
                }
              </div>
            );
          })}
        </nav>

        {/* Footer */}
        <div style={{ padding:"12px 18px", borderTop:`1px solid ${C.sideBdr}`, display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <span style={{ fontSize:"10px", color:"#4c4d7a" }}>{elakayAutoText("h_28868411beb95a", "Page Builder v2")}</span>
          {onClose && (
            <button onClick={onClose} style={{ padding:"4px 10px", borderRadius:"6px", border:`1px solid ${C.sideBdr}`, background:"transparent", color:C.sideTxt, fontSize:"11px", cursor:"pointer" }}>{elakayAutoText("h_5ab4ec640d654d", "Fermer")}</button>
          )}
        </div>
      </aside>

      {/* ── PANNEAU DROIT (66%) ──────────────────────────────────────────────── */}
      <main ref={rightRef} style={{ flex:1, overflowY:"auto", padding:"32px 40px 60px" }}>
        <Content isBoutique={isBoutique} />
      </main>
    </div>
  );
}
